
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("DoNsZ", function(module, exports) {

var $dGKc1 = parcelRequire("dGKc1");


var $6icEc = parcelRequire("6icEc");

const $2d8620dcf810155b$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $2d8620dcf810155b$var$prefix = 'ak-editor-panel';
const $2d8620dcf810155b$export$6dd740b6c888e050 = {
    prefix: $2d8620dcf810155b$var$prefix,
    content: `${$2d8620dcf810155b$var$prefix}__content`,
    icon: `${$2d8620dcf810155b$var$prefix}__icon`,
    noIcon: `${$2d8620dcf810155b$var$prefix}__no-icon`
};
const $2d8620dcf810155b$export$b0ee08fae091706a = {
    infoPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).INFO}]`,
    notePanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).NOTE}]`,
    warningPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).WARNING}]`,
    errorPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).ERROR}]`,
    successPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $2d8620dcf810155b$export$8099afddf1b1be78 = (panelType)=>$2d8620dcf810155b$var$lightPanelColors[panelType] || 'none';
const $2d8620dcf810155b$export$dd3f0fd482ae7ccc = (panelType)=>(0, $6icEc.hexToEditorBackgroundPaletteColor)($2d8620dcf810155b$var$lightPanelColors[panelType]) || 'none';
module.exports["PanelSharedCssClassName"] = $2d8620dcf810155b$export$6dd740b6c888e050;
module.exports["getPanelTypeBackgroundNoTokens"] = $2d8620dcf810155b$export$8099afddf1b1be78;

});

parcelRegister("iGbqR", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $2e985ae6445cc58f$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? (0, $d925B.ACTION_SUBJECT).HYPERLINK : (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $2e985ae6445cc58f$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $d925B.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $d925B.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $d925B.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $2e985ae6445cc58f$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? $2e985ae6445cc58f$var$buildVisitedHyperLinkPayload() : $2e985ae6445cc58f$export$4c5e2a0406e7eae8(type, (0, $d925B.INPUT_METHOD).TOOLBAR);
};
const $2e985ae6445cc58f$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $d925B.ACTION).VISITED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $2e985ae6445cc58f$export$4c5e2a0406e7eae8 = (type, inputMethod, resolvedAttributes)=>{
    return {
        action: (0, $d925B.ACTION).VISITED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod,
            ...resolvedAttributes && {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            }
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $2e985ae6445cc58f$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
            display: $2e985ae6445cc58f$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $2e985ae6445cc58f$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $d925B.ACTION).UNLINK,
        actionSubject: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? (0, $d925B.ACTION_SUBJECT).HYPERLINK : (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
module.exports["buildEditLinkPayload"] = $2e985ae6445cc58f$export$7f3c24765adf61f0;
module.exports["buildVisitedLinkPayload"] = $2e985ae6445cc58f$export$e81ec2390acfc152;
module.exports["buildVisitedNonHyperLinkPayload"] = $2e985ae6445cc58f$export$4c5e2a0406e7eae8;
module.exports["buildOpenedSettingsPayload"] = $2e985ae6445cc58f$export$96aa8ae974c8591a;
module.exports["unlinkPayload"] = $2e985ae6445cc58f$export$aab75a08bdd88be4;

});

parcelRegister("eiA8Z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

/**
 *
 * Directly map object values
 *
 * @private
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $1663cf3718a173a6$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginStateWithSelector` example: `useSharedPluginStateWithSelector(api, ['width'], selector)`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $1663cf3718a173a6$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>plugins, []);
}
function $1663cf3718a173a6$export$e5d623015ec283cc(injectionApi, plugins, selector) {
    const pluginNames = $1663cf3718a173a6$var$useStaticPlugins(plugins);
    const selectorRef = (0, $42omo.useRef)(selector);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $42omo.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $1663cf3718a173a6$var$useSharedPluginStateInternal(namedExternalPlugins, selectorRef);
}
function $1663cf3718a173a6$var$useSharedPluginStateInternal(externalPlugins, selector) {
    const refStates = (0, $42omo.useRef)($1663cf3718a173a6$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
    const [pluginStates, setPluginState] = (0, $42omo.useState)(()=>selector.current(refStates.current));
    const mounted = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setPluginState((currentPluginStates)=>{
                const nextStates = selector.current({
                    ...refStates.current
                });
                if ($1663cf3718a173a6$var$shallowEqual(nextStates, currentPluginStates)) return currentPluginStates;
                return nextStates;
            });
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $1663cf3718a173a6$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    }, [
        externalPlugins,
        selector
    ]);
    return pluginStates;
}
function $1663cf3718a173a6$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}
module.exports["useSharedPluginStateWithSelector"] = $1663cf3718a173a6$export$e5d623015ec283cc;

});

parcelRegister("6qdjm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $3597304f6bb24fd4$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $3597304f6bb24fd4$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>plugins, []);
}
function $3597304f6bb24fd4$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $3597304f6bb24fd4$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $42omo.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $3597304f6bb24fd4$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $3597304f6bb24fd4$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $42omo.useRef)();
    const cleanup = (0, $42omo.useRef)();
    const latestEffect = (0, $42omo.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $42omo.useLayoutEffect)(()=>{
        if (options.disabled) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $3597304f6bb24fd4$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
        cleanup.current = latestEffect.current?.(refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = latestEffect.current?.(refStates.current);
                }
            }));
        return ()=>{
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb?.());
            cleanup.current?.();
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}
module.exports["usePluginStateEffect"] = $3597304f6bb24fd4$export$85f3fdc261c569b3;

});

parcelRegister("2cmfr", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $3jQ9y = parcelRequire("3jQ9y");

const $cdbf3a2c8517d76b$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $cdbf3a2c8517d76b$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $3jQ9y.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        ...((0, $dh538.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') || (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) && {
            priority: extensionModule.priority
        },
        ...extensionModule.lozenge != null && {
            lozenge: extensionModule.lozenge
        },
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $cdbf3a2c8517d76b$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$cdbf3a2c8517d76b$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $cdbf3a2c8517d76b$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $cdbf3a2c8517d76b$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $cdbf3a2c8517d76b$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $cdbf3a2c8517d76b$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cdbf3a2c8517d76b$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $cdbf3a2c8517d76b$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $cdbf3a2c8517d76b$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $cdbf3a2c8517d76b$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $cdbf3a2c8517d76b$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $cdbf3a2c8517d76b$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $cdbf3a2c8517d76b$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $cdbf3a2c8517d76b$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$cdbf3a2c8517d76b$var$compareContext(currentContext, context)));
    }
};
const $cdbf3a2c8517d76b$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $cdbf3a2c8517d76b$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $cdbf3a2c8517d76b$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($cdbf3a2c8517d76b$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($cdbf3a2c8517d76b$var$isToolbarButton(toolbarItem)) return $cdbf3a2c8517d76b$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $cdbf3a2c8517d76b$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $cdbf3a2c8517d76b$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}
module.exports["getQuickInsertItemsFromModule"] = $cdbf3a2c8517d76b$export$a1d0004a197b97a3;
module.exports["getAutoConvertPatternsFromModule"] = $cdbf3a2c8517d76b$export$60407594ea5edd1c;
module.exports["getExtensionAutoConvertersFromProvider"] = $cdbf3a2c8517d76b$export$38a3a11e6509754a;
module.exports["getContextualToolbarItemsFromModule"] = $cdbf3a2c8517d76b$export$9d13b95c50a2a6c9;

});

parcelRegister("b5IZN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ffCOo = parcelRequire("ffCOo");


var $inPa6 = parcelRequire("inPa6");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");


var $2T4ch = parcelRequire("2T4ch");


var $lWghV = parcelRequire("lWghV");


var $iu6m9 = parcelRequire("iu6m9");


var $fswVK = parcelRequire("fswVK");


var $auTg8 = parcelRequire("auTg8");


var $6DQRK = parcelRequire("6DQRK");


var $7lreV = parcelRequire("7lreV");


var $75KVc = parcelRequire("75KVc");





var $jSnXV = parcelRequire("jSnXV");









// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $df33a49f9570fdc5$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $2791f7d61bdfd64e$export$51e52147760fc784 {
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
   * Returns the `interactionCount` value using the native API (if available)
   * or the polyfill estimate in this module.
   */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        this.po = void 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
}


class $11086031fa1bcc5c$export$aaa80641d584351c {
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
    constructor(){
        this.longestInteractionList = void 0;
        this.longestInteractionMap = void 0;
        this.interactionCountPolyfill = void 0;
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $2791f7d61bdfd64e$export$51e52147760fc784)();
    }
}
$11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER = 10;


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $a86e91972531a920$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

const $4716358fa782d9bd$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $4716358fa782d9bd$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $a86e91972531a920$export$91ec2be6fdd8f1b4)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $4716358fa782d9bd$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $e53cd74394c138c9$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $df33a49f9570fdc5$export$17679dccdd551979)(callback);
    const interactionManager = new (0, $11086031fa1bcc5c$export$aaa80641d584351c)();
    const handleEntries = (entries)=>{
        (0, $4716358fa782d9bd$export$4d9952dcbf5b2792)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $e53cd74394c138c9$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $a86e91972531a920$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $e53cd74394c138c9$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};



var $kyRHQ = parcelRequire("kyRHQ");

const $1035ef17fe90bcc8$export$56930d9a67e0aae6 = (callback)=>{
    if (!$1035ef17fe90bcc8$var$isINPSupported()) return;
    return (0, $e53cd74394c138c9$export$7df4b36ecaed99e1)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $1035ef17fe90bcc8$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $kyRHQ !== 'undefined' && Boolean($kyRHQ?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};



var $4u5NT = parcelRequire("4u5NT");

const $32714f82364735d9$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $inPa6.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $42omo.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $32714f82364735d9$var$createIdleCallback(()=>{
            cleanupFn = (0, $1035ef17fe90bcc8$export$56930d9a67e0aae6)(({ value: value })=>{
                const interaction = (0, $4u5NT.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $32714f82364735d9$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $32714f82364735d9$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $32714f82364735d9$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















var $jTxSS = parcelRequire("jTxSS");




function $03c9dba1f478f2d1$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $42omo.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $42omo.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $42omo.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portalElements);
}


function $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $42omo.useState)(portalManager.getBuckets());
        (0, $42omo.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $42omo.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $03c9dba1f478f2d1$export$828f0f29e8293a07), {
                    key: i,
                    id: i,
                    portalManager: portalManager
                })), [
            buckets
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portalsElements);
    };
}
const $07ca771f5bf2bd0c$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $42omo.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, getChildren());
};
const $07ca771f5bf2bd0c$var$PortalRenderWrapper = /*#__PURE__*/ (0, $42omo.memo)($07ca771f5bf2bd0c$export$eab0ea19ad3bed77);
$07ca771f5bf2bd0c$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
const $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender, immediate = false)=>{
            if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07ca771f5bf2bd0c$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            } else {
                const portal = /*#__PURE__*/ (0, $jTxSS.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            }
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};



var $8Yfbq = parcelRequire("8Yfbq");


var $1oCLl = parcelRequire("1oCLl");

const $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS = 50;
const $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $3a8111d444031088$var$DEFAULT_SCALE_RATIO = 0.5;
const $3a8111d444031088$var$DEFAULT_THROTTLE_DELAY = 16; // ~60fps for smooth updates
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $3a8111d444031088$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $3a8111d444031088$export$52c7ef79917c2f38 {
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($3a8111d444031088$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getOrCreateThrottledUpdater(id) {
        if (!this.throttledBucketUpdaters.has(id)) {
            const throttledUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
                this.buckets[id]?.updater?.(()=>({
                        ...this.buckets[id].portals
                    }));
            }, this.throttleDelay);
            this.throttledBucketUpdaters.set(id, throttledUpdater);
        }
        return this.throttledBucketUpdaters.get(id);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
        // Clean up throttled updater when bucket is unregistered
        if (this.throttledBucketUpdaters.has(id)) {
            this.throttledBucketUpdaters.get(id)?.cancel();
            this.throttledBucketUpdaters.delete(id);
        }
    }
    updateBuckets(id, immediate = false) {
        if (!this.throttleActivationRAFId && (0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) this.throttleActivationRAFId = requestAnimationFrame(()=>{
            this.shouldUseThrottledUpdates = true;
        });
        if (immediate || !this.shouldUseThrottledUpdates || !(0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) {
            // Cancel any pending throttled update and update immediately
            if (this.throttledBucketUpdaters.has(id)) this.throttledBucketUpdaters.get(id)?.cancel();
            this.buckets[id].updater?.(()=>({
                    ...this.buckets[id].portals
                }));
        } else // Use throttled update for smooth, regular updates
        this.getOrCreateThrottledUpdater(id)?.();
    }
    registerPortal(key, portal, immediate = false) {
        this.createBucket();
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.portalToBucketMap.set(key, id);
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[id].portals[key] !== portal) {
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].portals[key] = portal;
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        }
        //returns a function to unregister the portal
        return ()=>{
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].capacity += 1;
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.availableBuckets.add(id);
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
   * Cleans up resources used by the PortalManager. This includes clearing all portals,
   * unregistering all buckets, and resetting internal state.
   */ destroy() {
        // Cancel all pending throttled updates
        this.throttledBucketUpdaters.forEach((updater)=>{
            updater.cancel();
        });
        this.throttledBucketUpdaters.clear();
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
    constructor(initialBuckets = $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $3a8111d444031088$var$DEFAULT_SCALE_RATIO, throttleDelay = $3a8111d444031088$var$DEFAULT_THROTTLE_DELAY){
        this.maxBucketCapacity = void 0;
        this.scaleRatio = void 0;
        this.buckets = void 0;
        this.availableBuckets = void 0;
        this.portalToBucketMap = void 0;
        this.portalRendererUpdater = void 0;
        this.scaleCapacityThreshold = void 0;
        this.throttledBucketUpdaters = void 0;
        this.throttleDelay = void 0;
        /**
     * Controls whether to use throttled updates or immediate synchronous updates.
     * During initial load, we use synchronous updates to avoid delays and ensure immediate responsiveness.
     * After the initial load period (one RAF cycle), we switch to throttled updates for better performance.
     */ this.shouldUseThrottledUpdates = false;
        /**
     * RequestAnimationFrame callback ID used to transition from synchronous to throttled update mode.
     * This ensures we switch to throttled mode after the initial render cycle completes.
     */ this.throttleActivationRAFId = void 0;
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        this.throttleDelay = throttleDelay;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$3a8111d444031088$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
        this.throttledBucketUpdaters = new Map();
    }
}


function $b81f72f3142ef144$export$9b00782c24eb3d6b() {
    const portalManager = (0, $42omo.useMemo)(()=>new (0, $3a8111d444031088$export$52c7ef79917c2f38)(), []);
    const PortalRenderer = (0, $42omo.useMemo)(()=>(0, $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $42omo.useMemo)(()=>(0, $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}



var $dh538 = parcelRequire("dh538");








var $dQl1W = parcelRequire("dQl1W");


var $2xIMp = parcelRequire("2xIMp");







var $56Wjx = parcelRequire("56Wjx");


var $kckFS = parcelRequire("kckFS");


var $hWRJP = parcelRequire("hWRJP");





var $9JpPs = parcelRequire("9JpPs");

/* eslint-disable require-unicode-regexp */ 


const $1ad229e75f2927fb$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? chromeVersion >= 123 : chromeVersion >= 84) return false;
    const gecko = /gecko\/\d/i.test(userAgent);
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? geckoVersion >= 124 : geckoVersion >= 84) return false;
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? edgeVersion >= 123 : edgeVersion >= 84) return false;
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? safariVersion >= 17 : safariVersion >= 12) return false;
    return true;
};








const $090d7aafd4648237$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $auTg8.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};


class $24b7332c0d770745$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kckFS.IntlErrorBoundary), null, this.props.children);
    }
    constructor(props){
        super(props);
        this.featureFlags = void 0;
        this.browserExtensions = undefined;
        this.state = {
            error: undefined
        };
        this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $56Wjx.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $1ad229e75f2927fb$export$12d09524e028927)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            this.logException(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        };
        this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        };
        this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $ajtqX.editorAnalyticsChannel));
        };
        this.logException = (error, tags)=>{
            (0, $hWRJP.logException)(error, tags);
        };
        this.featureFlags = props.featureFlags;
    }
}
$24b7332c0d770745$export$d6d3bedcc5fc09c8.defaultProps = {
    rethrow: true,
    errorTracking: true
};
class $24b7332c0d770745$export$e34b68cf8622e9fd extends $24b7332c0d770745$export$d6d3bedcc5fc09c8 {
    constructor(props){
        super(props);
        this.context = void 0;
        this.logException = (error, tags)=>{
            const extraTags = {};
            extraTags.editorSessionId = this.context?.getAtlaskitAnalyticsContext()?.[0]?.fabricEditorCtx?.editorSessionId;
            (0, $hWRJP.logException)(error, {
                ...tags,
                ...extraTags
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$24b7332c0d770745$export$e34b68cf8622e9fd.contextType = (0, $2xIMp.default);
const $24b7332c0d770745$var$_default_1 = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('platform_editor_sentry_breadcrumbs'), (0, $090d7aafd4648237$export$cf381084b490bd31)($24b7332c0d770745$export$e34b68cf8622e9fd), (0, $090d7aafd4648237$export$cf381084b490bd31)($24b7332c0d770745$export$d6d3bedcc5fc09c8));
var $24b7332c0d770745$export$2e2bcd8739ae039 = $24b7332c0d770745$var$_default_1;



var $bn5lP = parcelRequire("bn5lP");





var $f8zg2 = parcelRequire("f8zg2");





var $2oRGU = parcelRequire("2oRGU");





var $6dGgK = parcelRequire("6dGgK");


var $aFUXX = parcelRequire("aFUXX");

// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $67f6e75f4f4df09d$var$defaultFontSize = 14;
function $67f6e75f4f4df09d$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $42omo.useMemo)(()=>({
            baseFontSize: baseFontSize || $67f6e75f4f4df09d$var$defaultFontSize,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.a), {
        theme: memoizedTheme
    }, children);
}



var $jTtEd = parcelRequire("jTtEd");

function $93c55730732033da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $93c55730732033da$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $93c55730732033da$var$DEFAULT_VALUE_PROP_TO_IGNORE = [
    'defaultValue'
];
const $93c55730732033da$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $42omo.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $b81f72f3142ef144$export$9b00782c24eb3d6b)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $b81f72f3142ef144$export$9b00782c24eb3d6b)();
    const propsToIgnore = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $93c55730732033da$var$DEFAULT_VALUE_PROP_TO_IGNORE : [
        'defaultValue'
    ];
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2oRGU.RenderTracking), {
        componentProps: props,
        action: (0, $d925B.ACTION).RE_RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: propsToIgnore,
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $24b7332c0d770745$export$2e2bcd8739ae039), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $93c55730732033da$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $auTg8.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f8zg2.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bn5lP.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017: this callback closes over the full props object and derived featureFlags; memoization is ineffective because ReactEditorViewNext is not memo()'d and deps (props, featureFlags) change every render
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $67f6e75f4f4df09d$export$3de34996b814f0f0), {
                baseFontSize: (0, $jTtEd.getBaseFontSize)(props.appearance, props.contentMode)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                onSSRMeasure: props.onSSRMeasure,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                contentMode: props.contentMode,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $9K4OG.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $9K4OG.jsx)(NodeViewPortalRenderer, null)))))));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
















function $ea8d7238f61ed9d1$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9HtP4 = parcelRequire("9HtP4");







function $04f7f6d8a5e7af43$export$2e2bcd8739ae039() {
    (0, $9HtP4.default)(()=>{
        (0, $2T4ch.startMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
    });
}


function $4672b7597b696155$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $04f7f6d8a5e7af43$export$2e2bcd8739ae039)();
    (0, $42omo.useEffect)(()=>{
        (0, $2T4ch.stopMeasure)((0, $7lreV.default).EDITOR_MOUNTED, (0, $ea8d7238f61ed9d1$export$2e2bcd8739ae039)((0, $d925B.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}





const $1b1b779d278e7645$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $42omo.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentMode: passedProps.contentMode,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            onSSRMeasure: passedProps.onSSRMeasure,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation,
            syncBlock: passedProps.syncBlock,
            syncedBlockProvider: passedProps.syncedBlockProvider,
            pasteWarningOptions: passedProps.pasteWarningOptions
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentMode,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.onSSRMeasure,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation,
        passedProps.syncBlock,
        passedProps.syncedBlockProvider,
        passedProps.pasteWarningOptions
    ]);
    return memodProps;
};
var $1b1b779d278e7645$export$2e2bcd8739ae039 = $1b1b779d278e7645$export$d9d7e48a5f16fb4d;






var $4FxUL = parcelRequire("4FxUL");


var $2XqLN = parcelRequire("2XqLN");


var $eEmxu = parcelRequire("eEmxu");

function $9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $eEmxu.default)(extensionProviders(editorActions));
    return (0, $eEmxu.default)(extensionProviders);
}
const $9b8bf99e5ea95e38$var$prepareExtensionProvider = (getEditorActions)=>(0, $2XqLN.default)((extensionProviders)=>$9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $9b8bf99e5ea95e38$export$2e2bcd8739ae039 = $9b8bf99e5ea95e38$var$prepareExtensionProvider;






var $4wH3g = parcelRequire("4wH3g");







var $2cmfr = parcelRequire("2cmfr");

var $3jQ9y = parcelRequire("3jQ9y");


var $iScNA = parcelRequire("iScNA");







/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $lWghV.findInsertLocation)(selection);
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    // @note inputMethod defaults to QUICK_INSERT if not provided
                    inputMethod: source || (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }
        });
    }
}
const $4a8f1fc352d7e11f$var$showDummyAPIWarning = (location)=>{};
const $4a8f1fc352d7e11f$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:update')
    }
};
async function $4a8f1fc352d7e11f$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $2cmfr.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
                    __loadable_id__: "N8xjw",
                    name: "Icon",
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    // Add module key so typeahead/quick-insert can identify items
                    // **locale-agnostically**! nb: we _already_ send key in analytics
                    // events, this standardises and makes our items more predictable.
                    key: item.key,
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    ...((0, $dh538.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') || (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) && {
                        priority: item.priority
                    },
                    categories: item.categories,
                    ...item.lozenge != null && {
                        lozenge: item.lozenge
                    },
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $3jQ9y.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy
                            // extension API to consumers that warns them of using the methods.
                            (0, $3jQ9y.resolveImport)(item.node($4a8f1fc352d7e11f$var$dummyExtensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
function $4a8f1fc352d7e11f$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $iScNA.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}


function $857dcb67a4f61ef1$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $4a8f1fc352d7e11f$export$6b0bb34c2583056f)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? Promise.resolve((0, $4a8f1fc352d7e11f$export$e3759a254d73dcb7)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ])) : quickInsertProvider || extensionQuickInsertProvider;
}


function $e5d3ec72975fd3ba$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}


function $6c9d292cfdbfb05b$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}


function $cf88016029b1c3dc$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $cf88016029b1c3dc$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $9b8bf99e5ea95e38$export$2e2bcd8739ae039)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $857dcb67a4f61ef1$export$2e2bcd8739ae039)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $cf88016029b1c3dc$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $42omo.useMemo)(()=>(0, $e5d3ec72975fd3ba$export$2e2bcd8739ae039)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $42omo.useRef)(new (0, $4FxUL.default)());
    const editorRef = $cf88016029b1c3dc$var$useEditorRef(props.preset);
    const preparedProviders = (0, $42omo.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $cf88016029b1c3dc$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $6c9d292cfdbfb05b$export$2e2bcd8739ae039)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}



/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $f12bc0dec21ca30e$var$Editor(passedProps) {
    const propsRef = (0, $42omo.useRef)(passedProps);
    const props = (0, $1b1b779d278e7645$export$2e2bcd8739ae039)(passedProps);
    (0, $42omo.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $auTg8.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $42omo.useMemo)(()=>new (0, $fswVK.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $42omo.useCallback)((data)=>{
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $42omo.useCallback)(()=>{
        return {
            ...(0, $6DQRK.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $42omo.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $2T4ch.startMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $2T4ch.stopMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK, (0, $ea8d7238f61ed9d1$export$2e2bcd8739ae039)((0, $d925B.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $42omo.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $4672b7597b696155$export$2e2bcd8739ae039)(props, createAnalyticsEvent);
    const providerFactory = (0, $cf88016029b1c3dc$export$2e2bcd8739ae039)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $42omo.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageAppearance = Boolean(props.appearance && [
        'full-page',
        'full-width',
        ...(0, $iu6m9.editorExperiment)('platform_synced_block', true) ? [
            'max'
        ] : []
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, isFullPageAppearance ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $32714f82364735d9$export$5942461441325be9), null) : null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $93c55730732033da$export$2617c0dabe49c335), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $42omo.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $f12bc0dec21ca30e$export$be7eaacc86ce4514(props) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorSessionId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const data = (0, $42omo.useMemo)(()=>{
        return {
            packageName: (0, $75KVc.name),
            packageVersion: (0, $75KVc.version),
            componentName: 'editorCore',
            appearance: (0, $lWghV.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ffCOo.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($f12bc0dec21ca30e$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$f12bc0dec21ca30e$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $f12bc0dec21ca30e$export$2e2bcd8739ae039 = $f12bc0dec21ca30e$export$be7eaacc86ce4514;
module.exports["CoreEditor"] = $f12bc0dec21ca30e$export$be7eaacc86ce4514;

});

parcelRegister("ajtqX", function(module, exports) {

var $k7eoe = parcelRequire("k7eoe");


var $2XqLN = parcelRequire("2XqLN");

var $59df087331ac03f0$var$_AnalyticsQueue;
class $59df087331ac03f0$export$b44c4ba8fe19bbc7 {
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
}
$59df087331ac03f0$var$_AnalyticsQueue = $59df087331ac03f0$export$b44c4ba8fe19bbc7;
$59df087331ac03f0$export$b44c4ba8fe19bbc7.get = (0, $2XqLN.default)(()=>new $59df087331ac03f0$var$_AnalyticsQueue());


const $2ca897dc13b18654$export$1467dbbb3bb418c6 = (0, $k7eoe.FabricChannel).editor;
const $2ca897dc13b18654$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $2ca897dc13b18654$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $59df087331ac03f0$export$b44c4ba8fe19bbc7).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };
module.exports["editorAnalyticsChannel"] = $2ca897dc13b18654$export$1467dbbb3bb418c6;
module.exports["fireAnalyticsEvent"] = $2ca897dc13b18654$export$c7d191551feb734;

});

parcelRegister("fswVK", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $6tl2G = parcelRequire("6tl2G");


var $lWghV = parcelRequire("lWghV");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

// Please, do not copy or use this kind of code below
// @ts-ignore
const $674469a067b8ad06$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $674469a067b8ad06$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $674469a067b8ad06$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}


function $24808638338110d5$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $24808638338110d5$export$2e2bcd8739ae039 = $24808638338110d5$var$deprecationWarnings;


const $4f0bf41d03b55c89$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $1ec3bd762a62c85b$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $1ec3bd762a62c85b$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $1ec3bd762a62c85b$export$b648602b09795358(nodeChild);
}


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $9bc21d8203f55b17$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $h9yJL = parcelRequire("h9yJL");

const $e456faba3d0c2065$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $e456faba3d0c2065$export$54fd2c36b5cc6731(node) {
    return $e456faba3d0c2065$var$transformer.encode(node);
}


// Please, do not copy or use this kind of code below
// @ts-ignore
const $982b9f7bd08d5545$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $982b9f7bd08d5545$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $982b9f7bd08d5545$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated This is deprecated and is no longer maintained.
   *
   * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
   * it has inbuilt throttling and is designed for use with `ComposableEditor`.
   *
   * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
   *
   * WARNING: this may be called repeatedly, async with care
   */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $674469a067b8ad06$export$99c45752ffdaa598)(editorView);
        const json = (0, $e456faba3d0c2065$export$54fd2c36b5cc6731)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $5SAOw.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
   * @example
    	const { editorApi, preset } = usePreset(...);
  	const extensionAPI = editorAPI?.extension?.actions?.api();
  	// Use nodeWithPos as desired
  	const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
  	const node = nodeWithPos.node;
  	const nodePos = nodeWithPos.pos;
   */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $9bc21d8203f55b17$export$947fc26275418e36)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $4f0bf41d03b55c89$export$1dc8bea8646ac811)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
   * This method will return the currently selected `Node` if the selection is a `Node`.
   * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
   */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node;
            return (0, $8m4tT.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $1ec3bd762a62c85b$export$2da47a16c0b6bcb)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `replaceDocument` found in the core plugin actions instead
   * using this will reset your Editor State which could cause some things to break (like emojis)
   * @example - use the `replaceDocument` from the core plugin actions instead
   * ```ts
   * const { editorApi, preset } = usePreset(...);
  	// where you need it
  	editorApi?.core.actions.replaceDocument(value);
  	return <ComposableEditor preset={preset} ... />
   */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $24808638338110d5$export$2e2bcd8739ae039)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $6tl2G.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $6tl2G.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $8m4tT.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.editorView = void 0;
        this.contentTransformer = void 0;
        this.contentEncode = void 0;
        this.eventDispatcher = void 0;
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
     * If editor is using new collab service,
     * we want editor to call the collab provider to
     * retrieve the final acknowledged state of the
     * editor. The final acknowledged editor state
     * refers to the latest state of editor with confirmed
     * steps.
     */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $674469a067b8ad06$export$99c45752ffdaa598)(editorView);
            const collabEditState = $982b9f7bd08d5545$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}
module.exports["default"] = $982b9f7bd08d5545$export$2e2bcd8739ae039;

});

parcelRegister("5vVM5", function(module, exports) {
class $36d44ab91368ab14$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $36d44ab91368ab14$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $36d44ab91368ab14$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($36d44ab91368ab14$var$getEventFromEventName(eventName), data);
    };
}
module.exports["EventDispatcher"] = $36d44ab91368ab14$export$ec8b666c5fe2c75a;
module.exports["createDispatch"] = $36d44ab91368ab14$export$f57f9cc7ce57b7d0;

});

parcelRegister("auTg8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f19f4e00be795c13$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $jZrBc = parcelRequire("jZrBc");


var $fswVK = parcelRequire("fswVK");

const $f19f4e00be795c13$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
class $f19f4e00be795c13$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jZrBc.EditorContext).Provider, {
            value: this.contextValue
        }, this.props.children);
    }
    constructor(props){
        super(props);
        this.editorActions = void 0;
        this.contextValue = void 0;
        this.editorActions = props.editorActions || new (0, $fswVK.default)();
        this.contextValue = {
            editorActions: this.editorActions
        };
    }
}
var $f19f4e00be795c13$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f19f4e00be795c13$export$797df872f5526664, {
        editorActions: props.editorActions
    }, props.children);
module.exports["useEditorContext"] = $f19f4e00be795c13$export$b119c82498f162a5;

});

parcelRegister("jZrBc", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ff30c9f22b7e82bd$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["EditorContext"] = $ff30c9f22b7e82bd$export$27b8dd149e32f6c7;

});

parcelRegister("6DQRK", function(module, exports) {

var $9ciHB = parcelRequire("9ciHB");

function $157ce49029366e0b$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $157ce49029366e0b$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $157ce49029366e0b$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $157ce49029366e0b$var$getSpellCheck(featureFlags)
    };
}
module.exports["createFeatureFlagsFromProps"] = $157ce49029366e0b$export$63102b0cbe181144;

});

parcelRegister("7lreV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a614873fe7dde33$export$2e2bcd8739ae039);
var $2a614873fe7dde33$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("75KVc", function(module, exports) {
const $23e0513e23b2d5c1$export$a8ff84c12d48cfa6 = "platform-pkg";
const $23e0513e23b2d5c1$export$83d89fbfd8236492 = "0.0.0-use.local";
module.exports["name"] = $23e0513e23b2d5c1$export$a8ff84c12d48cfa6;
module.exports["version"] = $23e0513e23b2d5c1$export$83d89fbfd8236492;

});

parcelRegister("56Wjx", function(module, exports) {
const $34f2b048c002519b$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $34f2b048c002519b$var$shortHash(type, isMark) {
    const code = $34f2b048c002519b$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $34f2b048c002519b$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$34f2b048c002519b$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$34f2b048c002519b$var$compactStringifier(node)).join(',');
    return marks(`${$34f2b048c002519b$var$shortHash(node.type, false)}(${content})`);
}
const $34f2b048c002519b$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $34f2b048c002519b$var$getBlockNode(doc, 0);
        if (options?.compact) return $34f2b048c002519b$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $34f2b048c002519b$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $34f2b048c002519b$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $34f2b048c002519b$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $34f2b048c002519b$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $34f2b048c002519b$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $34f2b048c002519b$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $34f2b048c002519b$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $34f2b048c002519b$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $34f2b048c002519b$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);
module.exports["getDocStructure"] = $34f2b048c002519b$export$6451b72139862cbd;

});

parcelRegister("bn5lP", function(module, exports) {
$parcel$export(module.exports, "default", () => $024596570cb688e3$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $cUcZ5 = parcelRequire("cUcZ5");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");

var $e2wMq = parcelRequire("e2wMq");


var $eTj7Y = parcelRequire("eTj7Y");


var $5vVM5 = parcelRequire("5vVM5");


var $9HtP4 = parcelRequire("9HtP4");

var $7541v = parcelRequire("7541v");


var $aAn37 = parcelRequire("aAn37");


var $92LVN = parcelRequire("92LVN");


var $9ciHB = parcelRequire("9ciHB");


var $jz9wK = parcelRequire("jz9wK");


var $8pwxt = parcelRequire("8pwxt");




const $09aa0f0eb93c969d$var$profileSSROperationImpl = (segmentName, fn, onSSRMeasure)=>{
    if (!onSSRMeasure) return fn();
    const startTimestamp = performance.now();
    try {
        return fn();
    } finally{
        onSSRMeasure({
            segmentName: segmentName,
            startTimestamp: startTimestamp,
            endTimestamp: performance.now()
        });
    }
};
const $09aa0f0eb93c969d$var$profileSSROperationNoOp = (_segmentName, fn, _onSSRMeasure)=>{
    return fn();
};
const $09aa0f0eb93c969d$export$69bfe89b2a668d26 = (0, $eTj7Y.isSSR)() ? $09aa0f0eb93c969d$var$profileSSROperationImpl : $09aa0f0eb93c969d$var$profileSSROperationNoOp;


var $lnATY = parcelRequire("lnATY");


var $a4TK8 = parcelRequire("a4TK8");


var $8Yfbq = parcelRequire("8Yfbq");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $b7atO = parcelRequire("b7atO");


var $6tl2G = parcelRequire("6tl2G");


var $gmyMu = parcelRequire("gmyMu");


var $ks2lK = parcelRequire("ks2lK");


var $1S4f7 = parcelRequire("1S4f7");

const $51c318c1c6cb814b$export$c701b355a31b2a13 = new (0, $ks2lK.PluginKey)('appearancePlugin');
const $51c318c1c6cb814b$var$DEFAULT_APPEARANCE = 'comment';
function $51c318c1c6cb814b$export$8eb39c7592eeb788(initialAppearance) {
    return new (0, $1S4f7.SafePlugin)({
        key: $51c318c1c6cb814b$export$c701b355a31b2a13,
        state: {
            init: ()=>({
                    appearance: initialAppearance ?? $51c318c1c6cb814b$var$DEFAULT_APPEARANCE
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($51c318c1c6cb814b$export$c701b355a31b2a13);
                if (meta?.appearance !== undefined) return {
                    ...pluginState,
                    appearance: meta.appearance
                };
                return pluginState;
            }
        }
    });
}



var $h9yJL = parcelRequire("h9yJL");







const $c623ea262c2cbc76$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $c623ea262c2cbc76$export$54fd2c36b5cc6731(node) {
    return $c623ea262c2cbc76$var$transformer.encode(node);
}
function $c623ea262c2cbc76$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const delayedCallbacks = [];
    const wrapperFn = (...args)=>{
        const lastArgsBefore = lastArgs;
        lastArgs = args;
        if (frameId) {
            if (lastArgsBefore) {
                const [_v, _c, _t, _f, alwaysFire] = lastArgsBefore;
                if (alwaysFire) delayedCallbacks.push(lastArgsBefore);
            }
            return;
        }
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) {
                delayedCallbacks.forEach((savedArgs)=>{
                    callback(...savedArgs);
                });
                callback(...lastArgs);
            }
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $c623ea262c2cbc76$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $c623ea262c2cbc76$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $5SAOw.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}
function $c623ea262c2cbc76$export$840661c1d4051b37(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    try {
        return $c623ea262c2cbc76$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire);
    } catch  {
        callback(undefined);
    }
}


const $9e9cac93742fed46$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $c623ea262c2cbc76$export$6a1dd68d75badcc7)((0, $c623ea262c2cbc76$export$dce79649e5264171));
    const scheduleDocumentRequestNoThrowError = (0, $c623ea262c2cbc76$export$6a1dd68d75badcc7)((0, $c623ea262c2cbc76$export$840661c1d4051b37));
    return {
        name: 'core',
        getSharedState (state) {
            const pluginState = state && (0, $51c318c1c6cb814b$export$c701b355a31b2a13).getState(state);
            return {
                schema: state?.schema,
                appearance: (0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true) ? pluginState?.appearance : undefined
            };
        },
        pmPlugins () {
            if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) return [
                {
                    name: 'appearancePlugin',
                    plugin: ()=>(0, $51c318c1c6cb814b$export$8eb39c7592eeb788)(config?.appearance)
                }
            ];
            return [];
        },
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $gmyMu.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            updateAppearance: (newAppearance)=>{
                if (!(0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) return false;
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                // Avoid dispatching a redundant transaction if appearance hasn't changed
                const currentAppearance = (0, $51c318c1c6cb814b$export$c701b355a31b2a13).getState(editorView.state)?.appearance;
                if (currentAppearance === newAppearance) return false;
                const tr = editorView.state.tr.setMeta((0, $51c318c1c6cb814b$export$c701b355a31b2a13), {
                    appearance: newAppearance
                });
                tr.setMeta('addToHistory', false);
                editorView.dispatch(tr);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $6tl2G.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $6tl2G.processRawFragmentValue)(schema, replaceValue, undefined, undefined, options?.transformer) : (0, $6tl2G.processRawValue)(schema, replaceValue, undefined, undefined, options?.transformer);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (content instanceof (0, $5SAOw.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if ((0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true)) tr.setMeta('replaceDocument', true);
                    if (options?.addToHistory === false) tr.setMeta('addToHistory', false);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr.setMeta('scrollIntoView', false));
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent, options?.alwaysFire);
            },
            requestDocumentAsync: (options)=>{
                return new Promise((resolve)=>{
                    const view = config?.getEditorView() ?? null;
                    scheduleDocumentRequestNoThrowError(view, (doc)=>{
                        resolve(doc);
                    }, options?.transformer, config?.fireAnalyticsEvent, true);
                });
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            },
            getAnchorIdForNode (node, pos) {
                const view = config?.getEditorView() ?? null;
                if (!view) return undefined;
                const nodeIdProvider = (0, $b7atO.getNodeIdProvider)(view);
                const cachedId = nodeIdProvider.getIdForNode(node);
                if (cachedId) return cachedId;
                if (pos < 0) return undefined;
                // Check DOM first to avoid generating a new ID with a collision suffix
                // when the DOM already has a valid anchor. This prevents misalignment
                // of drag handles on first focus after clicking from the title.
                const nodeDOM = view.nodeDOM(pos);
                if (nodeDOM instanceof HTMLElement) {
                    const domAnchor = nodeDOM.getAttribute('data-node-anchor');
                    if (domAnchor) {
                        // Cache the DOM anchor for this node to maintain consistency
                        // This ensures subsequent calls return the same anchor
                        nodeIdProvider.setIdForNode(node, domAnchor);
                        return domAnchor;
                    }
                }
                // Only generate a new ID if DOM doesn't have one
                const generatedId = nodeIdProvider.getOrGenerateId(node, pos);
                if (generatedId) return generatedId;
                return undefined;
            }
        }
    };
};


function $a71d406c80bedd2b$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $a71d406c80bedd2b$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $a71d406c80bedd2b$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $a71d406c80bedd2b$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $a71d406c80bedd2b$var$hasGetSharedState(plugin));
const $a71d406c80bedd2b$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$a71d406c80bedd2b$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $a71d406c80bedd2b$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $a71d406c80bedd2b$export$855252f33d470a3f {
}
class $a71d406c80bedd2b$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$export$da7528f3fb233b4a {
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (_sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$a71d406c80bedd2b$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $a71d406c80bedd2b$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $a71d406c80bedd2b$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $a71d406c80bedd2b$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
    constructor({ getEditorState: getEditorState }){
        this.getEditorState = void 0;
        this.listeners = void 0;
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
}
const $a71d406c80bedd2b$var$editorAPICache = new WeakMap();
class $a71d406c80bedd2b$export$50ccbedb1c6559a0 {
    /**
   * Returns PM plugins from internally-registered plugins (e.g. the core plugin)
   * that are not processed through the normal preset builder flow.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getInternalPMPlugins() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = [];
        const corePlugin = this.plugins.get('core');
        if (corePlugin && typeof corePlugin.pmPlugins === 'function') {
            const pmPlugins = corePlugin.pmPlugins();
            if (pmPlugins) result.push(...pmPlugins);
        }
        return result;
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, _receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$a71d406c80bedd2b$var$editorAPICache.get(this)) $a71d406c80bedd2b$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $a71d406c80bedd2b$var$editorAPICache.get(this);
    }
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent, appearance: appearance }){
        this.sharedStateAPI = void 0;
        this.actionsAPI = void 0;
        this.commandsAPI = void 0;
        this.plugins = void 0;
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $a71d406c80bedd2b$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $a71d406c80bedd2b$var$ActionsAPI();
        this.commandsAPI = new $a71d406c80bedd2b$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $9e9cac93742fed46$export$71ab138dd170c35)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent,
                appearance: appearance
            }
        }));
    }
}






var $40aJG = parcelRequire("40aJG");


var $lWghV = parcelRequire("lWghV");


var $2pjJ5 = parcelRequire("2pjJ5");





var $ftzrq = parcelRequire("ftzrq");


var $l998X = parcelRequire("l998X");

















var $4FxUL = parcelRequire("4FxUL");







const $483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView/editorSSRRenderer';
/**
 * A lightweight EditorView implementation for SSR environments.
 *
 * It's kind of aggressive right now, we need to test and see how it works.
 * Probably, we will need to implement more methods/properties in the future.
 *
 * If it doesn't work, we can extend `EditorView` directly instead of implementing `Partial<EditorView>`,
 * but it will perform some DOM operation during the construction.
 */ class $483adb45b74576fd$var$SSREditorView {
    update() {
    // No-op in SSR
    }
    setProps() {
    // No-op in SSR
    }
    dispatchEvent() {
    // No-op in SSR
    }
    dispatch() {
    // No-op in SSR
    }
    hasFocus() {
        return false;
    }
    focus() {
    // No-op in SSR
    }
    updateRoot() {
    // No-op in SSR
    }
    posAtCoords() {
        return null;
    }
    coordsAtPos() {
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
    }
    domAtPos() {
        return {
            node: this.root,
            offset: 0
        };
    }
    nodeDOM() {
        return null;
    }
    posAtDOM() {
        return 0;
    }
    endOfTextblock() {
        return false;
    }
    pasteHTML() {
        return false;
    }
    pasteText() {
        return false;
    }
    destroy() {
    // No-op in SSR
    }
    updateState() {
    // No-op in SSR
    }
    someProp() {
        return undefined;
    }
    serializeForClipboard(slice) {
        // No-op in SSR - clipboard operations are not supported
        return {
            dom: document.createElement('div'),
            text: '',
            slice: slice
        };
    }
    constructor(place, props){
        this.state = void 0;
        this.dom = void 0;
        this.editable = void 0;
        this.dragging = void 0;
        this.composing = void 0;
        this.props = void 0;
        this.root = void 0;
        this.isDestroyed = void 0;
        this.state = props.state;
        this.dom = document.createElement('div');
        this.editable = true;
        this.dragging = null;
        this.composing = false;
        this.props = props;
        this.root = document;
        this.isDestroyed = false;
    }
}
class $483adb45b74576fd$var$SSREventDispatcher extends (0, $5vVM5.EventDispatcher) {
    emit() {
    // Don't notify about events in SSR
    }
}
function $483adb45b74576fd$export$8d417ec112d5c31c({ plugins: plugins, schema: schema, doc: doc, portalProviderAPI: portalProviderAPI, intl: intl, onSSRMeasure: onSSRMeasure, onEditorStateChanged: onEditorStateChanged, ...divProps }) {
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $42omo.useRef)(performance.now());
    // PMPluginFactoryParams use `getIntl` function to get current intl instance,
    // so we don't need to add `intl` as a dependency to `useMemo`.
    // We will store intl in ref and access to it dynamically in `getIntl` function call.
    const intlRef = (0, $42omo.useRef)(intl);
    intlRef.current = intl;
    const pmPlugins = (0, $42omo.useMemo)(()=>{
        const createPMPlugins = ()=>{
            const eventDispatcher = new $483adb45b74576fd$var$SSREventDispatcher();
            const providerFactory = new (0, $4FxUL.default)();
            const pmPluginFactoryParams = {
                dispatch: (0, $5vVM5.createDispatch)(eventDispatcher),
                dispatchAnalyticsEvent: ()=>{},
                eventDispatcher: eventDispatcher,
                featureFlags: {},
                getIntl: ()=>intlRef.current,
                nodeViewPortalProviderAPI: portalProviderAPI,
                portalProviderAPI: portalProviderAPI,
                providerFactory: providerFactory,
                schema: schema
            };
            return plugins.reduce((acc, editorPlugin)=>{
                editorPlugin.pmPlugins?.().forEach(({ plugin: plugin })=>{
                    try {
                        const pmPlugin = plugin(pmPluginFactoryParams);
                        if (pmPlugin) acc.push(pmPlugin);
                    } catch  {}
                });
                return acc;
            }, []);
        };
        return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/createPMPlugins`, createPMPlugins, onSSRMeasure);
    }, [
        plugins,
        portalProviderAPI,
        schema,
        onSSRMeasure
    ]);
    const nodeViews = (0, $42omo.useMemo)(()=>{
        return pmPlugins.reduce((acc, plugin)=>{
            return Object.assign(acc, plugin.props.nodeViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const markViews = (0, $42omo.useMemo)(()=>{
        return pmPlugins.reduce((acc, plugin)=>{
            return Object.assign(acc, plugin.props.markViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const editorState = (0, $42omo.useMemo)(()=>{
        const createEditorState = ()=>{
            return (0, $ks2lK.EditorState).create({
                doc: doc,
                schema: schema,
                plugins: pmPlugins
            });
        };
        return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/createEditorState`, createEditorState, onSSRMeasure);
    }, [
        doc,
        pmPlugins,
        schema,
        onSSRMeasure
    ]);
    // In React 19 could be replaced by `useEffectEvent` hook.
    const onEditorStateChangedRef = (0, $42omo.useRef)(onEditorStateChanged);
    onEditorStateChangedRef.current = onEditorStateChanged;
    (0, $42omo.useLayoutEffect)(()=>{
        onEditorStateChangedRef.current?.(editorState);
    }, [
        editorState
    ]);
    const editorView = (0, $42omo.useMemo)(()=>{
        return new $483adb45b74576fd$var$SSREditorView(null, {
            state: editorState
        });
    }, [
        editorState
    ]);
    const { serializer: serializer, nodePositions: nodePositions } = (0, $42omo.useMemo)(()=>{
        const createSerializerAndNodePositions = ()=>{
            const nodePositions = new WeakMap();
            // ProseMirror View adds <br class="ProseMirror-trailingBreak" /> to empty nodes. Because we are using
            // DOMSerializer, we should simulate the same behaviour to get the same HTML document.
            //
            // There are a lot of conditions that check for adding `<br />` but we could implement only the case when we
            // are adding `<br />` to empty texblock, because if we add `<br />` in other cases it will change order of DOM nodes inside
            // this node (`<br />`) will be the first, after will be other nodes. It's because we are adding `<br />` to root node before
            // we are rendering child node.
            //
            // See: https://discuss.prosemirror.net/t/where-can-i-read-about-prosemirror-trailingbreak/6665
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L803
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L1365
            const addTrailingBreakIfNeeded = (node, contentDOM)=>{
                if (contentDOM && node.isTextblock && !node.lastChild) {
                    const br = document.createElement('br');
                    br.classList.add('ProseMirror-trailingBreak');
                    contentDOM.appendChild(br);
                }
            };
            const toDomNodeRenderers = Object.fromEntries(Object.entries(schema.nodes).map(([nodeName, nodeType])=>{
                return [
                    nodeName,
                    nodeType.spec.toDOM
                ];
            }).filter(([, toDOM])=>!!toDOM));
            const toDomMarkRenderers = Object.fromEntries(Object.entries(schema.marks).map(([markName, markType])=>{
                return [
                    markName,
                    markType.spec.toDOM
                ];
            }).filter(([, toDOM])=>!!toDOM));
            const nodeViewRenderers = Object.fromEntries(Object.entries(nodeViews).map(([nodeName, nodeViewFactory])=>{
                return [
                    nodeName,
                    (node)=>{
                        const nodeViewInstance = nodeViewFactory(node, editorView, ()=>nodePositions.get(node) ?? 0, [], (0, $ftzrq.DecorationSet).create(node, []));
                        addTrailingBreakIfNeeded(node, nodeViewInstance.contentDOM);
                        return {
                            dom: nodeViewInstance.dom,
                            // Leaf nodes have no content, ProseMirror will throw an error if we pass contentDOM
                            contentDOM: node.isLeaf ? undefined : nodeViewInstance.contentDOM
                        };
                    }
                ];
            }));
            // Create renderers for textblock nodes that don't have custom NodeViews (e.g. paragraph, heading)
            const textblockRenderers = Object.fromEntries(Object.entries(schema.nodes).filter(([nodeName, nodeType])=>{
                // Only handle textblock nodes
                return nodeType.spec.toDOM && nodeType.isTextblock && !nodeViews[nodeName];
            }).map(([nodeName, nodeType])=>{
                const toDOM = nodeType.spec.toDOM;
                if (!toDOM) return [
                    nodeName,
                    undefined
                ];
                return [
                    nodeName,
                    (node)=>{
                        if (!node.lastChild) {
                            const result = (0, $5SAOw.DOMSerializer).renderSpec(document, toDOM(node));
                            addTrailingBreakIfNeeded(node, result.contentDOM);
                            return result;
                        }
                        return toDOM(node);
                    }
                ];
            }).filter(([, renderer])=>!!renderer));
            const markViewRenderers = Object.fromEntries(Object.entries(markViews).map(([markName, markViewFactory])=>{
                return [
                    markName,
                    (mark)=>{
                        const markViewInstance = markViewFactory(mark, editorView, false);
                        return {
                            dom: markViewInstance.dom,
                            contentDOM: markViewInstance.contentDOM
                        };
                    }
                ];
            }));
            const serializer = new (0, $5SAOw.DOMSerializer)({
                ...toDomNodeRenderers,
                ...textblockRenderers,
                ...nodeViewRenderers,
                text: $483adb45b74576fd$var$renderText
            }, {
                ...toDomMarkRenderers,
                ...markViewRenderers
            });
            return {
                serializer: serializer,
                nodePositions: nodePositions
            };
        };
        return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/createSerializerAndNodePositions`, createSerializerAndNodePositions, onSSRMeasure);
    }, [
        editorView,
        markViews,
        nodeViews,
        schema.marks,
        schema.nodes,
        onSSRMeasure
    ]);
    const editorHTML = (0, $42omo.useMemo)(()=>{
        const serializeFragment = ()=>{
            if (!doc) return undefined;
            doc.descendants((node, pos)=>{
                nodePositions.set(node, pos);
            });
            if ((0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) {
                const fragment = serializer.serializeFragment(doc.content);
                const wrapper = document.createElement('div');
                wrapper.appendChild(fragment);
                return wrapper.innerHTML;
            } else return serializer.serializeFragment(doc.content);
        };
        try {
            return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/serializeFragment`, serializeFragment, onSSRMeasure);
        } catch  {
            return undefined;
        }
    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-usememo-deps -- Ignored via go/ees017 (to be fixed)
    }, [
        doc,
        serializer,
        nodePositions,
        onSSRMeasure
    ]);
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) {
            if (containerRef.current && editorHTML && typeof editorHTML !== 'string') {
                containerRef.current.innerHTML = '';
                containerRef.current.appendChild(editorHTML);
            }
        }
    }, [
        editorHTML
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lnATY.SSRRenderMeasure), {
        segmentName: $483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: containerRef,
            id: divProps.id,
            // eslint-disable-next-line react/no-danger -- It's intentional by design
            dangerouslySetInnerHTML: typeof editorHTML === 'string' && (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? {
                __html: editorHTML
            } : undefined,
            // For some reason on SSR, the result `class` has a trailing space, that broke UFO,
            // because ReactEditorView produces a div with `class` without space.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: divProps.className.trim(),
            "aria-label": divProps['aria-label'],
            "aria-describedby": divProps['aria-describedby'],
            "data-editor-id": divProps['data-editor-id'],
            "data-vc-ignore-if-no-layout-shift": true,
            "data-ssr-placeholder": "editor-view",
            "data-ssr-placeholder-replace": "editor-view",
            "aria-multiline": true,
            role: "textbox",
            // @ts-expect-error - contenteditable is not exist in div attributes
            contenteditable: "true",
            "data-gramm": "false",
            translate: "no"
        })
    });
}
function $483adb45b74576fd$var$renderText(node) {
    return node.text || '';
}



var $dh538 = parcelRequire("dh538");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");





var $dZ8uq = parcelRequire("dZ8uq");




const $9dc7d15a9979d8e6$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $42omo.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};



var $6DQRK = parcelRequire("6DQRK");


var $hEPfr = parcelRequire("hEPfr");

function $873158ef753fe251$export$af7be2186992199(node) {
    const nodes = {};
    const extensionKeys = {};
    const extensionNodeNames = [
        'extension',
        'bodiedExtension',
        'inlineExtension',
        'multiBodiedExtension'
    ];
    node.nodesBetween(0, node.nodeSize - 2, (currentNode)=>{
        nodes[currentNode.type.name] = (nodes[currentNode.type.name] || 0) + 1;
        if (!extensionNodeNames.includes(currentNode.type.name)) return;
        const extensionKey = currentNode.attrs?.extensionKey;
        if (!extensionKey) return;
        extensionKeys[extensionKey] = (extensionKeys[extensionKey] || 0) + 1;
    });
    return {
        nodes: nodes,
        extensionKeys: extensionKeys
    };
}


/**
 * Check if a DOM element is visible within the viewport. We deem a node visible if the top left corner coordinate is within the viewport.
 * This may not look visible, and may include a node that looks below the fold – but it's more than 0 pixels within the viewport.
 */ const $668f6e52ed8ba3c9$export$9c8a351faafa8fbb = (node)=>{
    const rect = node.getBoundingClientRect();
    const isVisible = rect.x >= 0 && rect.x < window.innerWidth && rect.y >= 0 && rect.y < window.innerHeight;
    return isVisible;
};
const $668f6e52ed8ba3c9$export$f20e3cf045904cb = (editorDom)=>{
    const MAX_NODES_TO_COUNT = 200;
    const pmNodesList = editorDom.querySelectorAll('[data-prosemirror-node-name]');
    const nodesTypeCounter = {};
    for(let i = 0; i < Math.min(MAX_NODES_TO_COUNT, pmNodesList.length); i++){
        const node = pmNodesList[i];
        const type = node.getAttribute('data-prosemirror-node-name');
        // No valid prosemirrornode type, skip.
        if (!type) continue;
        const isVisible = $668f6e52ed8ba3c9$export$9c8a351faafa8fbb(node);
        // Not a visible node, end counting.
        if (!isVisible) break;
        nodesTypeCounter[type] = (nodesTypeCounter[type] || 0) + 1;
    }
    return nodesTypeCounter;
};


function $0085cb30af154789$export$73ae01d857526945(appearance) {
    return appearance === 'chromeless';
}



var $geLSP = parcelRequire("geLSP");


var $2oRGU = parcelRequire("2oRGU");


var $7lreV = parcelRequire("7lreV");

const $769e182f77e7bc85$export$646a6982857f2cd5 = 2000;
const $769e182f77e7bc85$export$79d7eac6cbb6352d = 3000;
const $769e182f77e7bc85$export$7d7bd496a5206996 = 100;



var $dSVmA = parcelRequire("dSVmA");


var $2oGxU = parcelRequire("2oGxU");
















const $4c2f9c6d3992052f$var$injectNodeViewNodeTypeList = [
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'rule',
    'decisionList',
    'taskList',
    'layoutColumn',
    'hardBreak'
];
const $4c2f9c6d3992052f$var$injectNodeViewNodeTypeConditionalList = [
    ...$4c2f9c6d3992052f$var$injectNodeViewNodeTypeList,
    // nodes that have custom nodeView behind experiment/FG
    'layoutSection'
];
const $4c2f9c6d3992052f$var$key = new (0, $ks2lK.PluginKey)('editorNativeAnchorSupportPlugin');
const $4c2f9c6d3992052f$export$dc8df63091e87b7a = (schema)=>{
    const nodeViewEntries = [];
    const injectList = (0, $1oCLl.expValEquals)('advanced_layouts', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? $4c2f9c6d3992052f$var$injectNodeViewNodeTypeList : $4c2f9c6d3992052f$var$injectNodeViewNodeTypeConditionalList;
    schema.spec.nodes.forEach((nodeName, nodeSpec)=>{
        if (injectList.includes(nodeName)) {
            if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
                const toDOM = nodeSpec.toDOM.bind(nodeSpec);
                nodeViewEntries.push([
                    nodeName,
                    (node)=>(0, $5SAOw.DOMSerializer).renderSpec(document, toDOM(node))
                ]);
            }
        }
    });
    return new (0, $1S4f7.SafePlugin)({
        key: $4c2f9c6d3992052f$var$key,
        props: {
            nodeViews: Object.fromEntries(nodeViewEntries)
        }
    });
};








const $0857bd5143cc04f2$var$key = new (0, $ks2lK.PluginKey)('editorStateNotificationPlugin');
const $0857bd5143cc04f2$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    const transactions = [];
    return new (0, $1S4f7.SafePlugin)({
        key: $0857bd5143cc04f2$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};


function $5b9727cf4df72475$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $5b9727cf4df72475$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $5b9727cf4df72475$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $5b9727cf4df72475$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $2oGxU.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) pmPlugins.push((0, $4c2f9c6d3992052f$export$dc8df63091e87b7a)(config.schema));
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $0857bd5143cc04f2$export$e0355cecc74597d)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $5b9727cf4df72475$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $dSVmA.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}



var $1B55v = parcelRequire("1B55v");


var $9vHt3 = parcelRequire("9vHt3");





var $6VsTy = parcelRequire("6VsTy");





const $083bb79fcbe2f990$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $6VsTy.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $083bb79fcbe2f990$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $083bb79fcbe2f990$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $083bb79fcbe2f990$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $083bb79fcbe2f990$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $083bb79fcbe2f990$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $5b9727cf4df72475$export$ef6c09ff452189fa)(editorConfig.marks.sort((0, $2oGxU.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $9vHt3.sanitizeNodes)(editorConfig.nodes.sort((0, $2oGxU.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $5SAOw.Schema)({
        nodes: nodes,
        marks: marks
    });
}





const $170f814baa647977$export$3b488057bfc1868f = (0, $aXWIB.defineMessages)({
    editorAssistiveLabel: {
        id: "fabric.editor.editorAssistiveLabel",
        defaultMessage: "Main content area, start typing to enter text."
    },
    fullPageEditorAssistiveLabel: {
        id: "fabric.editor.fullPageEditorAssistiveLabel",
        defaultMessage: "Page editing area, start typing to enter text."
    }
});


function $0d3266c92e7feda8$export$32ec9f77297f7957(editorId) {
    const parentElement = document.querySelector(`[data-focus-id="${editorId}"]`);
    if (!(parentElement instanceof HTMLElement)) return;
    parentElement.focus({
        preventScroll: true
    });
}



var $d7ZU3 = parcelRequire("d7ZU3");

function $f1dc1dfba26b7751$export$11a24c7b1b4aab81() {
    const browser = (0, $d7ZU3.getBrowserInfo)();
    if (browser.chrome) return 'ua-chrome';
    else if (browser.ie) return 'ua-ie';
    else if (browser.gecko) return 'ua-firefox';
    else if (browser.safari) return 'ua-safari';
    return '';
}








function $565b25adcfad3caf$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
    // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
    // Bail out in that scenario to prevent operating on an unmounted view.
    if (view?.isDestroyed) return;
    if (!window.getSelection) {
        view?.focus();
        return;
    }
    const domSelection = window.getSelection();
    if (!domSelection || domSelection.rangeCount === 0) {
        view?.focus();
        return;
    }
    // If not mocked properly in tests, getRangeAt may not exist.
    const range = domSelection.getRangeAt?.(0);
    if (!range) return;
    // if selection is outside editor focus and exit
    try {
        if (view && range?.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
    } catch (error) {
        // If we get a SecurityError-type DOMException here, then we probably just tried to
        // access a cross-origin iframe's contents. In that case, we can ignore the error and
        // just reasonably assume the selection is outside the editor, since we can't access it.
        if (error instanceof DOMException && error.name === 'SecurityError' && (0, $1oCLl.expValEquals)('platform_editor_fix_cross_origin_editor_focus', 'isEnabled', true)) {
            if (view) {
                view.focus();
                return;
            }
        } else // re-throw other unexpected errors
        throw error;
    }
    // set cursor/selection and focus
    const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
    const head = view?.posAtDOM(range.endContainer, range.endOffset);
    // if anchor or head < 0 focus and exit
    if (anchor && anchor < 0 || head && head < 0) {
        view?.focus();
        return;
    }
    if (view && anchor) {
        const selection = (0, $ks2lK.TextSelection).create(view.state.doc, anchor, head);
        const tr = view.state.tr.setSelection(selection);
        view.dispatch(tr);
        view.focus();
    }
}








var $4VpM8 = parcelRequire("4VpM8");


var $h3X17 = parcelRequire("h3X17");


var $56Wjx = parcelRequire("56Wjx");


var $2T4ch = parcelRequire("2T4ch");

const $015e54f1cc15a3ff$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};





const $b985ded6f19ca760$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $b985ded6f19ca760$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $b985ded6f19ca760$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $b985ded6f19ca760$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($b985ded6f19ca760$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};








/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $1d60a1b0507e65ba$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;


const $a17905ab9de46c9b$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $a17905ab9de46c9b$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $a17905ab9de46c9b$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $a17905ab9de46c9b$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $a17905ab9de46c9b$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $a17905ab9de46c9b$export$735da5ee20c885d5 = false;
const $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE = 100;
const $a17905ab9de46c9b$var$noop = ()=>{};
class $a17905ab9de46c9b$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $a17905ab9de46c9b$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $a17905ab9de46c9b$var$noop,
                stopMeasure: $a17905ab9de46c9b$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $2T4ch.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $2T4ch.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $1d60a1b0507e65ba$export$a26b90db2c8f1b97)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}


const $e81162bdf75802d2$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check();
    } catch (error) {
        return false;
    }
    return true;
};
const $e81162bdf75802d2$export$996213f7c272fc6f = (nodes)=>nodes.every($e81162bdf75802d2$export$4c39e41e39b3c449);


const $f260cf531ae15748$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $42omo.useRef)(onChange);
    (0, $42omo.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $42omo.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $015e54f1cc15a3ff$export$cdc577fd3f583194)(unsafeTransaction);
        const changedNodesValid = (0, $e81162bdf75802d2$export$996213f7c272fc6f)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $b985ded6f19ca760$export$668aa008bdae439f)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                const isDirtyChange = (0, $h3X17.isDirtyTransaction)(transaction);
                (0, $2T4ch.startMeasure)((0, $a17905ab9de46c9b$export$bb82e7cfb8987f35));
                onChangeRef.current(view, {
                    source: source,
                    isDirtyChange: isDirtyChange
                });
                (0, $2T4ch.stopMeasure)((0, $a17905ab9de46c9b$export$bb82e7cfb8987f35));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $e81162bdf75802d2$export$4c39e41e39b3c449)(node)).map((node)=>(0, $56Wjx.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $4VpM8.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    isRemoteReplaceDocumentTransaction: isRemoteReplace
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};














const $2507994582b7e2f3$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $e2wMq.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $e2wMq.FULL_WIDTH_MODE).FIXED_WIDTH;
};


const $5953f1dbb50e9aa2$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $7541v.default)(appearance);
    (0, $42omo.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $2507994582b7e2f3$export$47d5b79f3ddf0b92)(previousAppearance),
                    newMode: (0, $2507994582b7e2f3$export$47d5b79f3ddf0b92)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};


const $024596570cb688e3$var$EDIT_AREA_ID = 'ak-editor-textarea';
const $024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView';
const $024596570cb688e3$var$bootStartTime = (0, $aAn37.isPerformanceAPIAvailable)() ? performance.now() : undefined;
function $024596570cb688e3$export$e7d1b1cbca007e16(props) {
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $42omo.useRef)(performance.now());
    const { preset: preset, editorProps: { onSSRMeasure: onSSRMeasure, appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const ssrEditorStateRef = (0, $42omo.useRef)(undefined);
    const editorRef = (0, $42omo.useRef)(null);
    const viewRef = (0, $42omo.useRef)();
    const focusTimeoutId = (0, $42omo.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $42omo.useRef)(true);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const eventDispatcher = (0, $42omo.useMemo)(()=>new (0, $5vVM5.EventDispatcher)(), []);
    const config = (0, $42omo.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $42omo.useRef)(undefined);
    const featureFlags = (0, $42omo.useMemo)(()=>(0, $6DQRK.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $42omo.useCallback)(()=>ssrEditorStateRef.current ?? viewRef.current?.state, []);
    const getEditorView = (0, $42omo.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $42omo.useMemo)(()=>(0, $5vVM5.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $42omo.useMemo)(()=>(0, $5b9727cf4df72475$export$e98521bb0cea2db1)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        (0, $ajtqX.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        const dispatch = (0, $5vVM5.createDispatch)(eventDispatcher);
        dispatch((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $42omo.useRef)(new (0, $a71d406c80bedd2b$export$50ccbedb1c6559a0)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent,
        appearance: nextAppearance
    }));
    const parseDoc = (0, $42omo.useCallback)((schema, api, options)=>{
        if (!options.doc) return undefined;
        // if the collabEdit API is set, skip this validation due to potential pm validation errors
        // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
        if ((0, $eTj7Y.isSSR)() || api?.collabEdit !== undefined || options.props.editorProps.skipValidation) return (0, $6tl2G.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
        else return (0, $6tl2G.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
    }, [
        dispatchAnalyticsEvent
    ]);
    const createEditorState = (0, $42omo.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
         * ReactEditorView currently does NOT handle dynamic schema,
         * We are reusing the existing schema, and rely on #reconfigureState
         * to update `this.config`
         */ schema = viewRef.current.state.schema;
            else {
                /**
         * There's presently a number of issues with changing the schema of a
         * editor inflight. A significant issue is that we lose the ability
         * to keep track of a user's history as the internal plugin state
         * keeps a list of Steps to undo/redo (which are tied to the schema).
         * Without a good way to do work around this, we prevent this for now.
         */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $5b9727cf4df72475$export$7265233e78178a4)((0, $1B55v.default)(options.props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current));
            if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) config.current.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
            schema = (0, $083bb79fcbe2f990$export$5f4ce795563f4211)(config.current);
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $5b9727cf4df72475$export$169329cb2979ef81)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        const doc = parseDoc(schema, api, options);
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $ks2lK.TextSelection)(doc.resolve(0));
                return (0, $ks2lK.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $ks2lK.Selection).atStart(doc) : (0, $ks2lK.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $ks2lK.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $ks2lK.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        parseDoc,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $42omo.useMemo)(()=>{
        if ((0, $eTj7Y.isSSR)()) // We don't need to create initial state in SSR, it would be done by EditorSSRRenderer,
        // so we can save some CPU time here.
        return undefined;
        return createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $geLSP.isFullPage)(nextAppearance)
        });
    }, // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $42omo.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $42omo.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $42omo.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local',
            isDirtyChange: false
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $9HtP4.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).STARTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $e2wMq.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $9ciHB.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    });
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) return;
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // No cleanup in SSR should happened because SSR doesn't render a real editor.
        return;
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    // Bumped after `reconfigureState` so the render prop re-reads the
    // in-place-mutated `config.current` (contentComponents / toolbar
    // components from the rebuilt preset).
    const [, bumpConfigVersion] = (0, $42omo.useState)(0);
    const reconfigureState = (0, $42omo.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const editorPlugins = (0, $1B55v.default)(props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current);
        config.current = (0, $5b9727cf4df72475$export$7265233e78178a4)(editorPlugins);
        if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) config.current.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
        const state = viewRef.current.state;
        const plugins = (0, $5b9727cf4df72475$export$169329cb2979ef81)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        const result = viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
        // EDITOR-6702: gated until we have a broader gate; reconfigure is a
        // low-level path so use NoExposure.
        if ((0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true)) bumpConfigVersion((v)=>v + 1);
        return result;
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $42omo.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $f260cf531ae15748$export$b582387940572fe7)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $9dc7d15a9979d8e6$export$e4c19534640d7866)({
        editorApi: pluginInjectionAPI.current.api(),
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $42omo.useCallback)((state)=>{
        const stateToUse = state ?? getCurrentEditorState();
        if (!stateToUse) // This should not be happened, because initialState is only inavailable in SSR,
        // but in SSR this function should never be called.
        // In SSR we should use EditorSSRRenderer instead usual ProseMirror editor.
        throw new Error('No editor state found');
        return {
            state: stateToUse,
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $42omo.useCallback)((node)=>{
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $ftzrq.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        (0, $jz9wK.measureRender)((0, $7lreV.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $lWghV.getAnalyticsEventSeverity)(duration, (0, $769e182f77e7bc85$export$646a6982857f2cd5), (0, $769e182f77e7bc85$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const nodesAndExtensionKeys = (0, $1oCLl.expValEquals)('platform_editor_prosemirror_rendered_data', 'isEnabled', true) ? (0, $873158ef753fe251$export$af7be2186992199)(viewRef.current.state.doc) : undefined;
                const nodes = nodesAndExtensionKeys?.nodes ?? (0, $hEPfr.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $8pwxt.getResponseEndTime)();
                const requestToResponseTime = (0, $8pwxt.getRequestToResponseTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                const nodesInViewport = (0, $668f6e52ed8ba3c9$export$f20e3cf045904cb)(viewRef.current.dom);
                const nodeSize = viewRef.current.state.doc.nodeSize;
                const { totalNodes: totalNodes, nodeSizeBucket: nodeSizeBucket } = (0, $1oCLl.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true) ? {
                    totalNodes: Object.values(nodes).reduce((acc, curr)=>acc + curr, 0),
                    // Computed on client for dimension bucketing in Statsig
                    nodeSizeBucket: (()=>{
                        switch(true){
                            case nodeSize < 10000:
                                return '<10000';
                            case nodeSize < 20000:
                                return '<20000';
                            case nodeSize < 30000:
                                return '<30000';
                            case nodeSize < 40000:
                                return '<40000';
                            case nodeSize < 50000:
                                return '<50000';
                            default:
                                return '50000+';
                        }
                    })()
                } : {};
                if ((0, $1oCLl.expValEquals)('platform_editor_prosemirror_rendered_data', 'isEnabled', true)) {
                    const extensionKeys = nodesAndExtensionKeys?.extensionKeys ?? {};
                    const interaction = (0, $4u5NT.getActiveInteraction)();
                    const pageLoadType = interaction?.type;
                    const pageType = interaction?.routeName;
                    const timings = (()=>{
                        if (requestToResponseTime === undefined && $024596570cb688e3$var$bootStartTime === undefined) return undefined;
                        const timingValues = {};
                        if (requestToResponseTime !== undefined) timingValues['requestStart->responseEnd'] = Math.round(requestToResponseTime);
                        if ($024596570cb688e3$var$bootStartTime !== undefined) timingValues.bootToRender = Math.round(startTime - $024596570cb688e3$var$bootStartTime);
                        return timingValues;
                    })();
                    const attributes = {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        nodesInViewport: nodesInViewport,
                        nodeSize: nodeSize,
                        nodeSizeBucket: nodeSizeBucket,
                        totalNodes: totalNodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration,
                        pageLoadType: pageLoadType,
                        pageType: pageType,
                        timings: timings,
                        extensionKeys: extensionKeys,
                        ufoInteractionId: (0, $feexy.getInteractionId)().current
                    };
                    dispatchAnalyticsEvent({
                        action: (0, $d925B.ACTION).PROSEMIRROR_RENDERED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                        attributes: attributes,
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                } else {
                    const attributes = {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        nodesInViewport: nodesInViewport,
                        nodeSize: nodeSize,
                        nodeSizeBucket: nodeSizeBucket,
                        totalNodes: totalNodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    };
                    dispatchAnalyticsEvent({
                        action: (0, $d925B.ACTION).PROSEMIRROR_RENDERED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                        attributes: attributes,
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                }
            }
        });
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $42omo.useState)(undefined);
    // Detects if the editor is nested inside an extension - ie. it is a Legacy Content Extension (LCE)
    const isNestedEditor = (0, $42omo.useRef)(null);
    const isNestedEditorCalculated = (0, $42omo.useRef)(false);
    if (editorRef.current !== null && !isNestedEditorCalculated.current) {
        isNestedEditor.current = !!editorRef.current?.closest('.extension-editable-area');
        isNestedEditorCalculated.current = true;
    }
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(!isNestedEditor.current && (0, $geLSP.isFullPage)(props.editorProps.appearance) ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $geLSP.isFullPage)(props.editorProps.appearance) && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (shouldFocus && editorView?.props.editable?.(editorView.state)) {
            if (!mitigateScrollJump) {
                const liveDocWithContent = (__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
                if (!liveDocWithContent) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(editorView);
                if ((0, $0085cb30af154789$export$73ae01d857526945)(props.editorProps.appearance)) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(editorView);
                if ((0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $dh538.fg)('cc_editor_focus_before_editor_on_load')) {
                    if (!disabled && shouldFocus && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc)) (0, $0d3266c92e7feda8$export$32ec9f77297f7957)(editorId.current);
                }
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump,
        disabled,
        props.editorProps.appearance
    ]);
    const scrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const possibleListeners = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef([]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // No event listeners should be attached to scroll element in SSR.
        return;
        return ()=>{
            if (scrollElement.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollElement.current?.removeEventListener(...possibleListener);
            scrollElement.current = null;
        };
    }, []);
    const handleEditorViewRef = (0, $42omo.useCallback)((node)=>{
        if (node) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            scrollElement.current = document.querySelector('[data-editor-scroll-container]');
            const cleanupListeners = ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current?.removeEventListener(...possibleListener);
            };
            if (scrollElement.current) {
                const wheelAbortHandler = ()=>{
                    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $4u5NT.abortAll)('new_interaction', `wheel-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('wheel', wheelAbortHandler);
                possibleListeners.current.push([
                    'wheel',
                    wheelAbortHandler
                ]);
                const scrollAbortHandler = ()=>{
                    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $4u5NT.abortAll)('new_interaction', `scroll-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('scroll', scrollAbortHandler);
                possibleListeners.current.push([
                    'scroll',
                    scrollAbortHandler
                ]);
            }
        }
        if (!viewRef.current && node) {
            (0, $92LVN.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if (mitigateScrollJump) {
                const scrollElement = document.querySelector('[data-editor-scroll-container]');
                scrollElement?.scrollTo({
                    top: originalScrollToRestore.current,
                    behavior: 'instant'
                });
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).startTransition(()=>{
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            });
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            (0, $92LVN.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const isPageAppearance = (0, $geLSP.isFullPage)(nextAppearance) || nextAppearance === 'max';
    const createEditor = (0, $42omo.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $dh538.fg)('cc_editor_focus_before_editor_on_load') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            tabIndex: -1,
            "data-focus-id": editorId.current,
            "data-testid": "react-editor-view-inital-focus-element"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $f1dc1dfba26b7751$export$11a24c7b1b4aab81)()}`,
            key: "ProseMirror",
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || (isPageAppearance && (0, $dh538.fg)('platform_editor_a11y_9262') ? props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).editorAssistiveLabel)),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $024596570cb688e3$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current,
            "data-vc-ignore-if-no-layout-shift": true,
            "data-ssr-placeholder": "editor-view",
            "data-ssr-placeholder-replace": "editor-view",
            // eslint-disable-next-line react/no-danger -- needed for SSR and hydration so react keeps the HTML untouched
            dangerouslySetInnerHTML: {
                __html: ''
            }
        }));
    }, [
        handleEditorViewRef,
        isPageAppearance,
        props.intl
    ]);
    const previousPreset = (0, $7541v.default)(preset);
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // No state reconfiguration is supported in SSR.
        return;
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $7541v.default)(disabled);
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = (__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $2pjJ5.isEmptyDocument)(viewRef.current.state.doc);
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(viewRef.current);
            if ((0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $dh538.fg)('cc_editor_focus_before_editor_on_load')) {
                if (!disabled && shouldFocus && !(0, $2pjJ5.isEmptyDocument)(viewRef.current.state.doc)) (0, $0d3266c92e7feda8$export$32ec9f77297f7957)(editorId.current);
            }
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) pluginInjectionAPI.current.api()?.core?.actions?.updateAppearance(nextAppearance);
    }, [
        nextAppearance
    ]);
    (0, $5953f1dbb50e9aa2$export$4998b7b36606f9c3)(nextAppearance, dispatchAnalyticsEvent);
    // This function uses as prop as `<EditorSSRRenderer>` so, that should be memoized,
    // to avoid extra rerenders.
    const buildDoc = (0, $42omo.useCallback)((schema)=>{
        return parseDoc(schema, undefined, {
            // Don't pass all props here, use only what you need to keep hook dependencies more stable.
            // Check what `parseDoc` consumes and pass only needed data.
            props: {
                providerFactory: props.providerFactory,
                editorProps: {
                    sanitizePrivateContent: props.editorProps.sanitizePrivateContent
                }
            },
            doc: defaultValue
        });
    }, [
        defaultValue,
        parseDoc,
        props.editorProps.sanitizePrivateContent,
        props.providerFactory
    ]);
    // We need to check `allowBlockType` in props, because it is now exist in EditorNextProps type.
    const { allowBlockType: allowBlockType } = 'allowBlockType' in props.editorProps ? props.editorProps : {
        allowBlockType: undefined
    };
    // In separate memo, because some props like `props.intl` that need only for rendering
    // changes many times, but we don't want to process plugins and ADF document for each unnecessary changes.
    const ssrDeps = (0, $42omo.useMemo)(()=>{
        if (!(0, $eTj7Y.isSSR)()) return null;
        const doCreatePluginList = ()=>(0, $1B55v.default)(props.preset, // Don't pass props.editorProps directly, because editoProps in the dependency will lead to
            // multiple repaints, because props.editorPros is not stable object.
            {
                allowBlockType: allowBlockType
            }, pluginInjectionAPI.current);
        const plugins = (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME}/createPluginsList`, doCreatePluginList, onSSRMeasure);
        const doCreateSchema = ()=>(0, $083bb79fcbe2f990$export$5f4ce795563f4211)((0, $5b9727cf4df72475$export$7265233e78178a4)(plugins));
        const schema = (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME}/createSchema`, doCreateSchema, onSSRMeasure);
        const doBuildDoc = ()=>buildDoc(schema);
        const doc = (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME}/buildDoc`, doBuildDoc, onSSRMeasure);
        return {
            plugins: plugins,
            schema: schema,
            doc: doc
        };
    }, [
        allowBlockType,
        buildDoc,
        props.preset,
        onSSRMeasure
    ]);
    const { assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy } = props.editorProps;
    const handleSsrEditorStateChanged = (0, $42omo.useCallback)((state)=>{
        ssrEditorStateRef.current = state;
        // Notify listeners about the initial SSR state
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: state,
            oldEditorState: undefined
        });
    }, [
        pluginInjectionAPI
    ]);
    const memoizedReactEditorViewContext = (0, $42omo.useMemo)(()=>({
            editorRef: editorRef,
            // Use a getter so that consumers always read the live viewRef.current at access
            // time, not a stale snapshot captured when this memo was created.
            get editorView () {
                return viewRef.current;
            },
            popupsMountPoint: props.editorProps.popupsMountPoint
        }), // viewRef is intentionally omitted from the deps array — it's a stable ref object; the getter reads
    // .current lazily so there's no stale-closure risk.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        editorRef,
        props.editorProps.popupsMountPoint
    ]);
    // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017
    const reactEditorViewContext = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedReactEditorViewContext : {
        editorRef: editorRef,
        editorView: viewRef.current,
        popupsMountPoint: props.editorProps.popupsMountPoint
    };
    const ssrEditor = (0, $42omo.useMemo)(()=>{
        if (!ssrDeps) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $483adb45b74576fd$export$8d417ec112d5c31c), {
            intl: props.intl,
            doc: ssrDeps.doc,
            schema: ssrDeps.schema,
            plugins: ssrDeps.plugins,
            portalProviderAPI: props.portalProviderAPI,
            // IMPORTANT: Keep next props in sync with div that renders a real ProseMirror editor.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $f1dc1dfba26b7751$export$11a24c7b1b4aab81)()}`,
            key: "ProseMirror",
            "aria-label": assistiveLabel || (isPageAppearance && (0, $dh538.fg)('platform_editor_a11y_9262') ? props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).editorAssistiveLabel)),
            id: $024596570cb688e3$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current,
            onSSRMeasure: onSSRMeasure,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEditorStateChanged: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? handleSsrEditorStateChanged : (state)=>{
                ssrEditorStateRef.current = state;
                // Notify listeners about the initial SSR state
                pluginInjectionAPI.current.onEditorViewUpdated({
                    newEditorState: state,
                    oldEditorState: undefined
                });
            }
        });
    }, [
        ssrDeps,
        props.intl,
        props.portalProviderAPI,
        assistiveLabel,
        isPageAppearance,
        assistiveDescribedBy,
        onSSRMeasure,
        handleSsrEditorStateChanged
    ]);
    const editor = (0, $42omo.useMemo)(()=>{
        // SSR editor will be available only in SSR environment,
        // in a browser `ssrEditor` will be `null`, and we will render a normal one ProseMirror.
        if (ssrEditor) return ssrEditor;
        return createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy);
    }, // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy,
        ssrEditor
    ]);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lnATY.SSRRenderMeasure), {
        segmentName: $024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40aJG.default).Provider, {
        value: reactEditorViewContext
    }, renderTrackingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2oRGU.RenderTracking), {
        componentProps: props,
        action: (0, $d925B.ACTION).RE_RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).REACT_EDITOR_VIEW,
        handleAnalyticsEvent: handleAnalyticsEvent,
        useShallow: true
    }), props.render ? props.render?.({
        editor: editor,
        view: viewRef.current,
        config: config.current,
        eventDispatcher: eventDispatcher,
        transformer: contentTransformer.current,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorRef: editorRef,
        editorAPI: pluginInjectionAPI.current.api()
    }) ?? editor : editor));
}
var // Preserving exact type generated by TypeScript
// eslint-disable-next-line @typescript-eslint/ban-types
$024596570cb688e3$export$2e2bcd8739ae039 = (0, $aXWIB.injectIntl)($024596570cb688e3$export$e7d1b1cbca007e16);
module.exports["ReactEditorView"] = $024596570cb688e3$export$e7d1b1cbca007e16;

});

parcelRegister("92LVN", function(module, exports) {
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $1660546fee445dc4$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $1660546fee445dc4$var$editorObservers = new WeakMap();
const $1660546fee445dc4$var$callbackMap = new WeakMap();
const $1660546fee445dc4$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.unobserve(nodeElement);
        $1660546fee445dc4$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        $1660546fee445dc4$var$callbackMap.set(observerConfig.element, observerConfig);
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($1660546fee445dc4$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($1660546fee445dc4$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $1660546fee445dc4$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback?.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $1660546fee445dc4$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.disconnect();
        $1660546fee445dc4$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};
module.exports["nodeVisibilityManager"] = $1660546fee445dc4$export$565ab8668cdfbb7c;

});

parcelRegister("lnATY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");




function $795278da5b1bd758$export$8742d3f42739b0ac({ onRender: onRender }) {
    (0, $42omo.useLayoutEffect)(()=>{
        if (onRender) onRender();
    });
    return null;
}


function $0b18bc196bae511f$var$SSRRenderMeasureImpl({ onSSRMeasure: onSSRMeasure, segmentName: segmentName, startTimestampRef: startTimestampRef, children: children }) {
    const wasMeasured = (0, $42omo.useRef)(false);
    const handleOnRender = (0, $42omo.useCallback)(()=>{
        if (wasMeasured.current) return;
        onSSRMeasure?.({
            segmentName: segmentName,
            startTimestamp: startTimestampRef.current,
            endTimestamp: performance.now()
        });
        wasMeasured.current = true;
    }, [
        onSSRMeasure,
        segmentName,
        startTimestampRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $795278da5b1bd758$export$8742d3f42739b0ac), {
        onRender: handleOnRender
    }));
}
const $0b18bc196bae511f$var$SSRRenderMeasureNoOp = /*#__PURE__*/ (0, $42omo.memo)(({ children: children })=>{
    return children;
});
const $0b18bc196bae511f$export$9f2784dd4053b8a7 = (0, $eTj7Y.isSSR)() ? $0b18bc196bae511f$var$SSRRenderMeasureImpl : $0b18bc196bae511f$var$SSRRenderMeasureNoOp;
module.exports["SSRRenderMeasure"] = $0b18bc196bae511f$export$9f2784dd4053b8a7;

});

parcelRegister("b7atO", function(module, exports) {

var $2pjJ5 = parcelRequire("2pjJ5");

const $f78ec04c0c440d6c$var$DEFAULT_CHUNK_SIZE = 4096; // Default chunk size in bits
class $f78ec04c0c440d6c$export$fdc385e5a167108c {
    set(index, value) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        if (value) bitArray[byteIndex] |= 1 << bitOffset; // set the bit
        else bitArray[byteIndex] &= ~(1 << bitOffset); // clear the bit
    }
    get(index) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        return (bitArray[byteIndex] & 1 << bitOffset) !== 0; // Check if the bit is set
    }
    getChunk(index) {
        const chunkIndex = Math.floor(index / this.chunkTotalBitSize);
        if (!this.bitArrays[chunkIndex]) this.bitArrays[chunkIndex] = new Uint8Array(this.chunkSize);
        return this.bitArrays[chunkIndex];
    }
    constructor(chunkSize = $f78ec04c0c440d6c$var$DEFAULT_CHUNK_SIZE){
        this.chunkSize = void 0;
        this.chunkTotalBitSize = void 0;
        this.bitArrays = void 0;
        this.chunkSize = chunkSize;
        this.chunkTotalBitSize = this.chunkSize * 8;
        this.bitArrays = [];
    }
}



var $vDe3Q = parcelRequire("vDe3Q");

class $5d4c6b3ff36d75ac$export$d6cb5c66663ecf49 {
    isEmptyDoc() {
        return this.emptyDoc;
    }
    setEmptyDoc(isEmpty) {
        this.emptyDoc = isEmpty;
    }
    isLimitedMode() {
        return this.limitedMode;
    }
    // We use pos to generate unique ids for each node at a specific position
    // This is to ensure the same ADF will always generate the same DOM initially
    getOrGenerateId(node, pos) {
        if (this.limitedMode) return undefined;
        if (this.cache.has(node)) return this.cache.get(node);
        let idSuffix = '';
        if (this.existingPos.get(pos)) idSuffix = `-${(this.count++).toString(36)}`;
        else this.existingPos.set(pos, true);
        const anchorName = `--anchor-${node.type.name}-${pos}${idSuffix}`;
        this.cache.set(node, anchorName);
        return anchorName;
    }
    getIdForNode(node) {
        if (this.limitedMode) return undefined;
        return this.cache.get(node);
    }
    setIdForNode(node, id) {
        if (this.limitedMode) return;
        this.cache.set(node, id);
    }
    // After set to limited mode, we clear the cache to free up memory
    // and prevent further ids from being generated
    // Once in limited mode, we won't exit it
    setLimitedMode() {
        this.limitedMode = true;
        this.cache = new WeakMap();
        this.existingPos = new (0, $f78ec04c0c440d6c$export$fdc385e5a167108c)();
        this.count = BigInt(0);
    }
    constructor(limitedMode = false, emptyDoc = false){
        this.cache = new WeakMap();
        this.count = BigInt(0);
        this.existingPos = new (0, $f78ec04c0c440d6c$export$fdc385e5a167108c)();
        this.limitedMode = false;
        this.emptyDoc = false;
        this.limitedMode = limitedMode;
        this.emptyDoc = emptyDoc;
    }
}
const $5d4c6b3ff36d75ac$var$nodeIdProviderMap = new WeakMap();
/**
 * Determines whether limited mode should be enabled.
 * This logic mirrors the limited mode plugin implementation, but lives here to avoid a circular dependency.
 * If it changes, update the matching logic in `editor-plugin-limited-mode/src/pm-plugins/main.ts`.
 *
 * Limited mode is activated when ANY of the following conditions are met:
 * 1. Document size exceeds `LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD` — checked first as O(1)
 * 2. Node count exceeds `LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD`
 * 3. Document contains a legacy-content macro (LCM)
 *
 * Performance optimisations:
 * - Doc size is checked first (O(1)) - if it exceeds threshold, we skip traversal entirely.
 * - If we find an LCM during traversal, we exit early since limited mode will be enabled.
 */ const $5d4c6b3ff36d75ac$var$isLimitedModeEnabled = (editorView)=>{
    const doc = editorView.state.doc;
    const nodeCountThreshold = (0, $vDe3Q.LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD);
    const docSizeThreshold = (0, $vDe3Q.LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD);
    // Early exit: doc size exceeds threshold - O(1), no traversal needed
    if (doc.nodeSize > docSizeThreshold) return true;
    // Single traversal for node count and LCM detection
    let nodeCount = 0;
    let hasLcm = false;
    doc.descendants((node)=>{
        nodeCount += 1;
        if (node.attrs?.extensionKey === 'legacy-content') {
            hasLcm = true;
            // Early exit: LCM found — limited mode will be enabled
            return false;
        }
    });
    // LCM condition takes precedence (if we early exited traversal, this is why)
    if (hasLcm) return true;
    // Check node count threshold
    if (nodeCount > nodeCountThreshold) return true;
    return false;
};
const $5d4c6b3ff36d75ac$export$753ee9749f6df320 = (editorView)=>{
    if (!$5d4c6b3ff36d75ac$var$nodeIdProviderMap.has(editorView)) {
        // if the limited mode flag is on, enable limited mode based on the threshold
        // only for the first time
        const limitedMode = $5d4c6b3ff36d75ac$var$isLimitedModeEnabled(editorView);
        const isEmptyDoc = (0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
        const provider = new $5d4c6b3ff36d75ac$export$d6cb5c66663ecf49(limitedMode, isEmptyDoc);
        $5d4c6b3ff36d75ac$var$nodeIdProviderMap.set(editorView, provider);
        return provider;
    }
    const nodeIdProvider = $5d4c6b3ff36d75ac$var$nodeIdProviderMap.get(editorView);
    // in some cases we need to re-check limited mode state
    // Confluence editor can start with an empty doc and then load content later
    // so we need to check first time from an empty doc to a non-empty doc
    if (nodeIdProvider.isEmptyDoc() && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc)) {
        // set empty doc to false regardless of limited mode state
        nodeIdProvider.setEmptyDoc(false);
        if (!nodeIdProvider.isLimitedMode() && $5d4c6b3ff36d75ac$var$isLimitedModeEnabled(editorView)) nodeIdProvider.setLimitedMode();
    }
    // This is based on the fact that editorView is a singleton.
    return $5d4c6b3ff36d75ac$var$nodeIdProviderMap.get(editorView);
};
module.exports["getNodeIdProvider"] = $5d4c6b3ff36d75ac$export$753ee9749f6df320;

});

parcelRegister("vDe3Q", function(module, exports) {
/** Fixed document thresholds for limited (performance) mode (previously Statsig-driven). */ const $4616e34eca06f222$export$8817b3b4a899ccd1 = 5000;
const $4616e34eca06f222$export$9a6294e90d121a22 = 30000;
const $4616e34eca06f222$export$cea4e64227747fde = true;
module.exports["LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD"] = $4616e34eca06f222$export$8817b3b4a899ccd1;
module.exports["LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD"] = $4616e34eca06f222$export$9a6294e90d121a22;

});

parcelRegister("gmyMu", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

function $42952c725d367d8e$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $42952c725d367d8e$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $42952c725d367d8e$export$95069e054e554fa9 extends (0, $ks2lK.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}
module.exports["editorCommandToPMCommand"] = $42952c725d367d8e$export$bd352a83a17b2af8;
module.exports["PassiveTransaction"] = $42952c725d367d8e$export$95069e054e554fa9;

});

parcelRegister("1S4f7", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $1oCLl = parcelRequire("1oCLl");


var $b7atO = parcelRequire("b7atO");


var $6VsTy = parcelRequire("6VsTy");


var $04H9b = parcelRequire("04H9b");

const $abdb2d00268489b8$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom, options: options })=>{
    const metadata = (0, $6VsTy.createProseMirrorMetadata)(nodeOrMark, options);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
        if (name === 'data-node-anchor' && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            // if browser doesn't support CSS anchor, won't need the style
            // Or if it supports CSS attr() function as the value of anchor-name,
            // We won't need set the style
            if (!(0, $04H9b.isCSSAnchorSupported)() || (0, $04H9b.isCSSAttrAnchorSupported)()) return;
            // otherwise, we set the CSS variable for anchor-name
            dom.style.setProperty((0, $04H9b.ANCHOR_VARIABLE_NAME), `${value}`);
            return;
        }
    });
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $abdb2d00268489b8$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    let nodeIdProvider;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    if (!nodeIdProvider && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) nodeIdProvider = (0, $b7atO.getNodeIdProvider)(view);
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if (result?.dom instanceof HTMLElement) {
                        // we only attach metadata to the dom if its position is known
                        const pos = safeGetPos();
                        const options = pos !== undefined && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? {
                            anchrorId: nodeIdProvider?.getOrGenerateId(node, pos)
                        } : undefined;
                        $abdb2d00268489b8$export$286bb6e3f51916b5({
                            nodeOrMark: node,
                            dom: result.dom,
                            options: options
                        });
                    }
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $abdb2d00268489b8$export$1d44e2741b8f180d extends (0, $ks2lK.Plugin) {
    constructor(spec){
        super($abdb2d00268489b8$var$wrapGetPosExceptions(spec));
        // This variable isn't (and shouldn't) be used anywhere. Its purpose is
        // to distinguish Plugin from SafePlugin, thus ensuring that an 'unsafe'
        // Plugin cannot be assigned as an item in EditorPlugin → pmPlugins.
        this._isATypeSafePlugin = void 0;
    }
}
module.exports["SafePlugin"] = $abdb2d00268489b8$export$1d44e2741b8f180d;

});

parcelRegister("04H9b", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $2XqLN = parcelRequire("2XqLN");

const $8c4e7e3e26200878$export$ef134ee0b603ec88 = '--ed-pm-node-anchor';
const $8c4e7e3e26200878$var$hasCssSupport = (0, $2XqLN.default)(()=>{
    if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.supports === 'function') return true;
    return false;
});
const $8c4e7e3e26200878$export$98ea10c5c22b6d19 = (0, $2XqLN.default)(()=>{
    if ($8c4e7e3e26200878$var$hasCssSupport()) return CSS.supports('anchor-name', 'attr(data-anchor-name type(<custom-ident>))');
    return false;
});
const $8c4e7e3e26200878$export$e43af301b4191f = (0, $2XqLN.default)(()=>{
    if ($8c4e7e3e26200878$var$hasCssSupport()) return CSS.supports('anchor-name', '--anchor');
});
const $8c4e7e3e26200878$export$abca45c45e682c01 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-node-anchor]': {
            anchorName: `var(${$8c4e7e3e26200878$export$ef134ee0b603ec88}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
module.exports["ANCHOR_VARIABLE_NAME"] = $8c4e7e3e26200878$export$ef134ee0b603ec88;
module.exports["isCSSAttrAnchorSupported"] = $8c4e7e3e26200878$export$98ea10c5c22b6d19;
module.exports["isCSSAnchorSupported"] = $8c4e7e3e26200878$export$e43af301b4191f;

});

parcelRegister("40aJG", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $737f8c3c28a9bc31$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
var $737f8c3c28a9bc31$export$2e2bcd8739ae039 = $737f8c3c28a9bc31$var$ReactEditorViewContext;
module.exports["default"] = $737f8c3c28a9bc31$export$2e2bcd8739ae039;

});

parcelRegister("hEPfr", function(module, exports) {
function $0f830263e94a6c1b$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}
module.exports["getNodesCount"] = $0f830263e94a6c1b$export$3674f49b2d541ad;

});

parcelRegister("geLSP", function(module, exports) {
function $636443110c5c1dfb$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}
module.exports["isFullPage"] = $636443110c5c1dfb$export$2800a15841f40ad7;

});

parcelRegister("h9Yad", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ZkPRR = parcelRequire("ZkPRR");

function $3946837408650aa8$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $42omo.useRef)();
    const renderCountRef = (0, $42omo.useRef)(zeroBasedCount ? 0 : 1);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: componentId } = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    (0, $42omo.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $ZkPRR.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $ZkPRR.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}
module.exports["useComponentRenderTracking"] = $3946837408650aa8$export$ebce6d7d8ca67353;

});

parcelRegister("ZkPRR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $88475e86f62b9e57$export$74743eda5dda3ccf = Object.keys;
const $88475e86f62b9e57$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $88475e86f62b9e57$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $88475e86f62b9e57$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $88475e86f62b9e57$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value1),
                newValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $88475e86f62b9e57$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
module.exports["getPropsDifference"] = $88475e86f62b9e57$export$d438af18e3a25d10;
module.exports["getShallowPropsDifference"] = $88475e86f62b9e57$export$418b0a935c0a0030;

});

parcelRegister("2oGxU", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $1829e3410f9040f1$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $1829e3410f9040f1$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $1829e3410f9040f1$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}
module.exports["sortByOrder"] = $1829e3410f9040f1$export$49afdc3354d5c84e;
module.exports["sortByOrderWithTypeName"] = $1829e3410f9040f1$export$b4ae7ad1c009d0a1;

});

parcelRegister("1B55v", function(module, exports) {
$parcel$export(module.exports, "default", () => $a071074fd2398ee1$export$2e2bcd8739ae039);

var $6DQRK = parcelRequire("6DQRK");


var $geLSP = parcelRequire("geLSP");

const $a071074fd2398ee1$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $a071074fd2398ee1$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $geLSP.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $a071074fd2398ee1$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent,
            pasteWarningOptions: props.pasteWarningOptions
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $a071074fd2398ee1$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.disableDefaultItems || false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web',
            autoLinkOnBlur: props.linking?.autoLinkOnBlur
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $a071074fd2398ee1$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$a071074fd2398ee1$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}
module.exports["getDefaultPresetOptionsFromEditorProps"] = $a071074fd2398ee1$export$fdea1e40b8747a5b;

});

parcelRegister("4VpM8", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");

function $62c5e4b0ecece381$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $jy7VG.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}
module.exports["getAnalyticsEventsFromTransaction"] = $62c5e4b0ecece381$export$d9985be1ece4b7ee;

});

parcelRegister("f8zg2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $2dfeb0eb8ad08222$var$useCheckIntlContext = ()=>(0, $42omo.useContext)((0, $aXWIB.IntlContext)) === null;
function $2dfeb0eb8ad08222$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $2dfeb0eb8ad08222$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: "en"
    }, children);
    return children;
}
module.exports["IntlProviderIfMissingWrapper"] = $2dfeb0eb8ad08222$export$742fe272b8921eea;

});

parcelRegister("eEmxu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b623af3ab0506ee$export$2e2bcd8739ae039);

var $iScNA = parcelRequire("iScNA");

var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $9b623af3ab0506ee$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $iScNA.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>provider?.preload?.()));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                const result = provider?.getPreloadedExtension?.(type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});

parcelRegister("6cQbn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aXWIB = parcelRequire("aXWIB");


var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $1Oo9w = parcelRequire("1Oo9w");

var $eiA8Z = parcelRequire("eiA8Z");


var $61p3e = parcelRequire("61p3e");


var $bWRlG = parcelRequire("bWRlG");


var $5Gwdo = parcelRequire("5Gwdo");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $kXpLO = parcelRequire("kXpLO");


var $45E6y = parcelRequire("45E6y");


var $axOCf = parcelRequire("axOCf");


var $3ae8F = parcelRequire("3ae8F");


var $4cy2V = parcelRequire("4cy2V");


var $1xxAs = parcelRequire("1xxAs");


var $uq7dM = parcelRequire("uq7dM");





var $cPCP8 = parcelRequire("cPCP8");


var $5ZzFz = parcelRequire("5ZzFz");


var $eUp7e = parcelRequire("eUp7e");

const $7b17ca9ed479c680$export$48156340a1673791 = ({ editorAPI: editorAPI, editorView: editorView, editorAppearance: editorAppearance, disabled: disabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>{
    const components = editorAPI?.toolbar?.actions.getComponents();
    const toolbar = components?.find((component)=>component.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR);
    if (!components || !(0, $5ZzFz.isToolbar)(toolbar)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eUp7e.ToolbarNext), {
        toolbar: toolbar,
        components: components,
        editorView: editorView,
        editorAPI: editorAPI,
        editorAppearance: editorAppearance,
        isDisabled: disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $dh538 = parcelRequire("dh538");




function $e32357fdc808702d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $e32357fdc808702d$var$akEditorMenuZIndex = 500;
const $e32357fdc808702d$var$akEditorToolbarKeylineHeight = 2;
const $e32357fdc808702d$var$mainToolbarWrapperStyleNew = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'relative',
    alignItems: 'center',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`,
    display: 'flex',
    height: 'auto',
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    boxShadow: 'none',
    paddingLeft: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type:not(style), > style:first-of-type + *': {
            marginLeft: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.block-type-btn': {
        paddingLeft: 0
    }
});
/** keep default padding for entire toolbar */ const $e32357fdc808702d$var$mainToolbarWithoutLeftPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`
});
const $e32357fdc808702d$var$mainToolbarWithPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"}`
});
const $e32357fdc808702d$var$mainToolbarTwoLineStylesNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
            flexDirection: 'column-reverse',
            alignItems: 'end',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        /* make this more explicit for a toolbar */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`@media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '> div:nth-of-type(2)': {
                    justifyContent: 'flex-end',
                    display: 'flex'
                }
            }
        }
    }
});
const $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh = {
    name: "y5dbpb",
    styles: "span svg{max-width:100%;}"
};
const $e32357fdc808702d$var$mainToolbarWithRadiusStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    borderRadius: `${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"} 0 0`
});
const $e32357fdc808702d$var$mainToolbarRadius = /*#__PURE__*/ (0, $9K4OG.css)({
    borderRadius: `${"var(--ds-radius-medium, 6px)"} ${"var(--ds-radius-medium, 6px)"} 0 0`
});
const $e32357fdc808702d$var$stickyToolbarWrapperStyleNew = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'sticky',
    paddingBottom: "var(--ds-space-100, 8px)",
    zIndex: $e32357fdc808702d$var$akEditorMenuZIndex,
    transition: 'box-shadow ease-in-out 0.2s',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: `0 ${$e32357fdc808702d$var$akEditorToolbarKeylineHeight}px 0 0 ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`
    }
});
const $e32357fdc808702d$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $42omo.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $42omo.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $e32357fdc808702d$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $e32357fdc808702d$var$mainToolbarTwoLineStylesNew,
            $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh,
            $e32357fdc808702d$var$stickyToolbarWrapperStyleNew,
            props.isNewToolbarEnabled && $e32357fdc808702d$var$mainToolbarWithPadding,
            (0, $1oCLl.expValEquals)('platform_editor_fix_comment_border', 'isEnabled', true) && (0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && $e32357fdc808702d$var$mainToolbarRadius,
            (0, $1oCLl.expValEquals)('platform_editor_fix_comment_border', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_comments_border_radius') && $e32357fdc808702d$var$mainToolbarWithRadiusStyle
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $e32357fdc808702d$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $e32357fdc808702d$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $e32357fdc808702d$var$mainToolbarTwoLineStylesNew,
            $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh,
            props.isNewToolbarEnabled && $e32357fdc808702d$var$mainToolbarWithoutLeftPadding,
            !(0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_comments_border_radius') && $e32357fdc808702d$var$mainToolbarWithRadiusStyle,
            (0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && $e32357fdc808702d$var$mainToolbarRadius
        ],
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $e32357fdc808702d$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $e32357fdc808702d$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children, isNewToolbarEnabled: isNewToolbarEnabled })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $9K4OG.jsx)($e32357fdc808702d$var$StickyToolbar, {
        ...$e32357fdc808702d$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($e32357fdc808702d$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
};


function $9cfcad4a35f316a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9cfcad4a35f316a8$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
// Remove when platform_editor_comment_editor_border_radius is cleaned up
const $9cfcad4a35f316a8$var$commentEditorStylesOld = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin > .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $9cfcad4a35f316a8$var$commentEditorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin > .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`,
    boxSizing: 'border-box',
    borderRadius: "var(--ds-radius-medium, 6px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $9cfcad4a35f316a8$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleNew = {
    name: "4cnzc6",
    styles: "display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);> div{display:flex;flex-shrink:0;}"
};
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStylePaddingOverride = {
    name: "jjyo93",
    styles: "padding-right:0"
};
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [`@media (max-width: ${$9cfcad4a35f316a8$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
        paddingRight: 0
    }
});
const $9cfcad4a35f316a8$var$appearance = 'comment';
const $9cfcad4a35f316a8$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    const { editorViewMode: editorViewMode, primaryToolbarComponentsState: primaryToolbarComponentsState, maxContentSizeReached: maxContentSizeReached } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ], (states)=>({
            maxContentSizeReached: !!states.maxContentSizeState?.maxContentSizeReached,
            primaryToolbarComponentsState: states.primaryToolbarState?.components,
            editorViewMode: states.editorViewModeState?.mode
        }));
    const primaryToolbarState = (0, $4cy2V.getPrimaryToolbarComponents)(editorAPI, primaryToolbarComponentsState);
    const { mediaState: mediaState } = (0, $1Oo9w.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $aXWIB.useIntl)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $42omo.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $42omo.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $42omo.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $42omo.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const memoizedContentAreaStyles = (0, $42omo.useMemo)(()=>[
            maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`,
                // When maxHeight is set, content area should have overflow-y explicitly set as auto
                // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                // This will cause the content area to have content overflowing the container
                // so need to set overflow-y as auto to make sure the content area is scrollable
                overflowY: 'auto'
            }) : null
        ], [
        maxHeight
    ]);
    const contentAreaStyles = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedContentAreaStyles : [
        maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `${maxHeight}px`,
            // When maxHeight is set, content area should have overflow-y explicitly set as auto
            // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
            // This will cause the content area to have content overflowing the container
            // so need to set overflow-y as auto to make sure the content area is scrollable
            overflowY: 'auto'
        }) : null
    ];
    const customToolbarSlot = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleNew,
            isTwoLineToolbarEnabled && $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew,
            isToolbarAIFCEnabled && $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStylePaddingOverride
        ]
    }, customPrimaryToolbarComponents);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $uq7dM.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            (0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) ? $9cfcad4a35f316a8$var$commentEditorStyles : $9cfcad4a35f316a8$var$commentEditorStylesOld,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e32357fdc808702d$export$f7e5e5a2fbd99270), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled,
        isNewToolbarEnabled: isToolbarAIFCEnabled
    }, isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7b17ca9ed479c680$export$48156340a1673791), {
        editorAPI: editorAPI,
        editorView: editorView,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        disabled: !!disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    }), customPrimaryToolbarComponents ? customToolbarSlot : null) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1xxAs.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $9cfcad4a35f316a8$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), customToolbarSlot)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kXpLO.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $axOCf.default), {
            ref: containerElement,
            css: contentAreaStyles,
            isScrollable: maxHeight ? true : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('ak-editor-content-area', {
                'less-margin': width < (0, $aFUXX.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewMode,
            appearance: $9cfcad4a35f316a8$var$appearance,
            useStandardNodeWidth: useStandardNodeWidth
        }, customContentComponents && 'before' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.before) : (0, $45E6y.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3ae8F.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $9cfcad4a35f316a8$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $9cfcad4a35f316a8$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, !!onSave && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $61p3e.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCancel,
        testId: "comment-cancel-button",
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $61p3e.default).cancelButton))), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$9cfcad4a35f316a8$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';
module.exports["CommentEditorWithIntl"] = $9cfcad4a35f316a8$export$7b9f3a51cd0c1967;

});

parcelRegister("1Oo9w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $50e773a4bc80d240$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $50e773a4bc80d240$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>plugins, []);
}
function $50e773a4bc80d240$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $50e773a4bc80d240$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $42omo.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $50e773a4bc80d240$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $50e773a4bc80d240$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $42omo.useState)($50e773a4bc80d240$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $42omo.useRef)({});
    const mounted = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $50e773a4bc80d240$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}
module.exports["useSharedPluginState"] = $50e773a4bc80d240$export$a4c4fd90e2b72baa;

});

parcelRegister("5Gwdo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $dK4ZR = parcelRequire("dK4ZR");


var $8aWkM = parcelRequire("8aWkM");


var $b0RMS = parcelRequire("b0RMS");


var $f9zLy = parcelRequire("f9zLy");

function $75d74c57448b9b48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $75d74c57448b9b48$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $75d74c57448b9b48$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $75d74c57448b9b48$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const selectedItemIndex = (0, $42omo.useRef)(0);
    const incrementIndex = (0, $42omo.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $42omo.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRightMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = (0, $42omo.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $dK4ZR.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $b0RMS.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                // Button component from DS removes focus ring when :focus:not(:focus-visible) is true
                // Since here we programmatically focus the first button in the toolbar (as suppose to keyboard navigation), browser does not always force focus-visible to true
                // which is why the first button in the toolbar is not shown with focus ring
                // The workaround is add a new classname so we add back focus ring when the button is focused
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: editorAppearance === 'comment' && $75d74c57448b9b48$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $8aWkM.messages).toolbarLabel),
        "aria-controls": (0, $f9zLy.EDIT_AREA_ID)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($75d74c57448b9b48$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $75d74c57448b9b48$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $75d74c57448b9b48$var$isElementOrAncestorHiddenOrDisabled(element, rootNode) {
    let currentElement = element;
    while(currentElement && currentElement !== rootNode && currentElement !== document.body){
        const style = window.getComputedStyle(currentElement);
        // Check if current element is hidden
        if (style.visibility === 'hidden' || style.display === 'none') return true;
        // Check if current element is disabled
        if (currentElement.hasAttribute('disabled') || currentElement.getAttribute('aria-disabled') === 'true' || currentElement.disabled === true) return true;
        // Move to parent element
        currentElement = currentElement.parentElement;
    }
    return false;
}
function $75d74c57448b9b48$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $75d74c57448b9b48$var$getFocusableElements(rootNode).filter((elm)=>{
        // Check if element or any ancestor is hidden or disabled
        const isHiddenOrDisabled = $75d74c57448b9b48$var$isElementOrAncestorHiddenOrDisabled(elm, rootNode);
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && !isHiddenOrDisabled;
    });
}
module.exports["KeyDownHandlerContext"] = $75d74c57448b9b48$export$5455406531e3792c;
module.exports["ToolbarArrowKeyNavigationProvider"] = $75d74c57448b9b48$export$9837e395eba6f527;

});

parcelRegister("dK4ZR", function(module, exports) {
const $75f348dd52cc6fb8$export$bc90872e265d166e = 8;
const $75f348dd52cc6fb8$export$1f1798e92fa75806 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 40,
    medium: $75f348dd52cc6fb8$export$bc90872e265d166e * 75,
    large: $75f348dd52cc6fb8$export$bc90872e265d166e * 128
};
const $75f348dd52cc6fb8$export$69bde1b03e8b5224 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 50,
    medium: $75f348dd52cc6fb8$export$1f1798e92fa75806.medium,
    large: $75f348dd52cc6fb8$export$1f1798e92fa75806.large
};
const $75f348dd52cc6fb8$export$780035d9fe48eb32 = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 25}px`;
const $75f348dd52cc6fb8$export$95b62a1773aa5ebe = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 6}px`;
const $75f348dd52cc6fb8$export$387950d54d372827 = '12px';
const $75f348dd52cc6fb8$export$51a2d6b2c009fbfd = '54px';
const $75f348dd52cc6fb8$export$df8bcac60101d466 = '20px';
const $75f348dd52cc6fb8$export$9a6bb2acef5e644a = 15;
const $75f348dd52cc6fb8$export$3b8e93b2c0f295b0 = 2;
const $75f348dd52cc6fb8$export$6d221f35db1b75aa = 60;
const $75f348dd52cc6fb8$export$ab53450bc5fd5b7d = 10;
const $75f348dd52cc6fb8$export$6ee360fa4b93ee8e = 'editor-element-browser';
const $75f348dd52cc6fb8$export$f5c254b5428bf7c6 = 'editor-element-browser-list';
module.exports["GRID_SIZE"] = $75f348dd52cc6fb8$export$bc90872e265d166e;
module.exports["DEVICE_BREAKPOINT_NUMBERS"] = $75f348dd52cc6fb8$export$1f1798e92fa75806;
module.exports["FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS"] = $75f348dd52cc6fb8$export$69bde1b03e8b5224;
module.exports["SIDEBAR_WIDTH"] = $75f348dd52cc6fb8$export$780035d9fe48eb32;
module.exports["SIDEBAR_HEADING_WRAPPER_HEIGHT"] = $75f348dd52cc6fb8$export$95b62a1773aa5ebe;
module.exports["INLINE_SIDEBAR_HEIGHT"] = $75f348dd52cc6fb8$export$51a2d6b2c009fbfd;
module.exports["SEARCH_ITEM_HEIGHT_WIDTH"] = $75f348dd52cc6fb8$export$df8bcac60101d466;
module.exports["SCROLLBAR_WIDTH"] = $75f348dd52cc6fb8$export$9a6bb2acef5e644a;
module.exports["ELEMENT_LIST_PADDING"] = $75f348dd52cc6fb8$export$3b8e93b2c0f295b0;
module.exports["ELEMENT_ITEM_HEIGHT"] = $75f348dd52cc6fb8$export$6d221f35db1b75aa;
module.exports["ELEMENT_ITEM_PADDING"] = $75f348dd52cc6fb8$export$ab53450bc5fd5b7d;
module.exports["ELEMENT_BROWSER_ID"] = $75f348dd52cc6fb8$export$6ee360fa4b93ee8e;
module.exports["ELEMENT_BROWSER_LIST_ID"] = $75f348dd52cc6fb8$export$f5c254b5428bf7c6;

});

parcelRegister("f9zLy", function(module, exports) {
const $12841799d44c3fc4$export$b16ce0826b76e795 = 'ak-editor-textarea';
module.exports["EDIT_AREA_ID"] = $12841799d44c3fc4$export$b16ce0826b76e795;

});

parcelRegister("kXpLO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $h3X17 = parcelRequire("h3X17");


var $dhoHU = parcelRequire("dhoHU");


var $1zPzM = parcelRequire("1zPzM");


var $4vlwG = parcelRequire("4vlwG");


var $45E6y = parcelRequire("45E6y");

// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $fdee4aa7754cfd6c$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $fdee4aa7754cfd6c$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $fdee4aa7754cfd6c$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $4vlwG.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $4vlwG.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $4vlwG.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = target?.parentElement?.closest(`[${(0, $45E6y.ignoreAttribute)}]`);
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $4vlwG.closestElement)(target, 'div[offset]'));
    const isAnchorButtonClicked = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'a')) || Boolean((0, $4vlwG.closestElement)(target, 'a')) || event.currentTarget?.nodeName === 'A' || target?.nodeName === 'A';
    const isButtonClicked = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'button')) || Boolean((0, $4vlwG.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON' || isAnchorButtonClicked;
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $fdee4aa7754cfd6c$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $fdee4aa7754cfd6c$export$c5a7a653c4681bfd(view, event);
};
const $fdee4aa7754cfd6c$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $dhoHU.addParagraphAtEnd)(tr);
    }
    (0, $1zPzM.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $h3X17.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};


function $d312f85c475dacb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d312f85c475dacb6$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $d312f85c475dacb6$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $d312f85c475dacb6$var$clickWrapper,
        onMouseDown: handleMouseDown,
        // This div is a presentational container that captures mouse events
        // for programmatic editor focus management, not user interaction.
        role: "presentation"
    }, children);
};
var $d312f85c475dacb6$export$2e2bcd8739ae039 = $d312f85c475dacb6$export$68468c5dbde37b99;
module.exports["default"] = $d312f85c475dacb6$export$2e2bcd8739ae039;

});

parcelRegister("dhoHU", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $afcIe = parcelRequire("afcIe");

function $1d2e8dba41928471$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $1d2e8dba41928471$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $1d2e8dba41928471$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $1d2e8dba41928471$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$b637dda807357427 = (align)=>(tr)=>{
        const { from: from, to: to } = tr.selection;
        const initialDoc = tr.doc;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === tr.doc.type.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (!tr.doc.eq(initialDoc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const parentAllowsMark = state?.schema?.nodes?.blockTaskItem && parent?.type === state?.schema?.nodes?.blockTaskItem && markType === state?.schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$8614a16deba8906f = (markType, getAttrs, allowedBlocks)=>(from, to, tr)=>{
        let markApplied = false;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const schema = tr.doc.type.schema;
            const parentAllowsMark = schema?.nodes?.blockTaskItem && parent?.type === schema?.nodes?.blockTaskItem && markType === schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(tr.doc.type.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $1d2e8dba41928471$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $7XFGZ.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$23f118e134ed2228 = (markType, getAttrs, allowedBlocks)=>(tr)=>{
        let markApplied = false;
        const toggleBlockMarkOnRange = $1d2e8dba41928471$export$8614a16deba8906f(markType, getAttrs, allowedBlocks);
        const initialDoc = tr.doc;
        const { selection: selection } = tr;
        if (selection instanceof (0, $7XFGZ.CellSelection)) selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr);
        });
        else {
            const { from: from, to: to } = selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr);
        }
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (markApplied && !initialDoc.eq(tr.doc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $ks2lK.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $1d2e8dba41928471$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $1d2e8dba41928471$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $7XFGZ.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}
module.exports["addParagraphAtEnd"] = $1d2e8dba41928471$export$fc18809329b5ff08;
module.exports["changeImageAlignment"] = $1d2e8dba41928471$export$774cc08dd90b6a6a;
module.exports["changeImageAlignmentNext"] = $1d2e8dba41928471$export$b637dda807357427;
module.exports["createToggleBlockMarkOnRange"] = $1d2e8dba41928471$export$1115c4cf51ae1924;
module.exports["createToggleBlockMarkOnRangeNext"] = $1d2e8dba41928471$export$8614a16deba8906f;
module.exports["createToggleInlineMarkOnRange"] = $1d2e8dba41928471$export$a10bb5a1a10022f6;
module.exports["toggleBlockMark"] = $1d2e8dba41928471$export$72d6145976985e8c;
module.exports["toggleBlockMarkNext"] = $1d2e8dba41928471$export$23f118e134ed2228;
module.exports["findCutBefore"] = $1d2e8dba41928471$export$ad1078cb3917e860;

});

parcelRegister("afcIe", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $fde5eb025de1bc5c$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $8m4tT.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};
module.exports["insertBlock"] = $fde5eb025de1bc5c$export$f51280337625031;

});

parcelRegister("1zPzM", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $adhil = parcelRequire("adhil");


var $1gpr6 = parcelRequire("1gpr6");

// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $4bfd6331a10a8378$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $adhil.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $adhil.Side).LEFT : (0, $adhil.Side).RIGHT;
            let position;
            if (side === (0, $adhil.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $4bfd6331a10a8378$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $4bfd6331a10a8378$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $adhil.Side).LEFT ? (0, $1gpr6.isValidTargetNode)($pos.nodeAfter) : (0, $1gpr6.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $adhil.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $adhil.GapCursorSelection)) tr.setSelection((0, $ks2lK.Selection).near($pos));
        else tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $ks2lK.Selection).findFrom($pos, cursorCoords.side === (0, $adhil.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $4bfd6331a10a8378$export$44fdd7840a0a11f2 = (position, side = (0, $adhil.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $adhil.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };
module.exports["setSelectionTopLevelBlocks"] = $4bfd6331a10a8378$export$1b305efb24649ca5;
module.exports["setGapCursorAtPos"] = $4bfd6331a10a8378$export$44fdd7840a0a11f2;

});

parcelRegister("45E6y", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $938cf1eec2ff4dc1$export$72d101e93c081651 = 'data-editor-content-component';
const $938cf1eec2ff4dc1$export$57a965c23051130d = (reactComponents)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-editor-content-component": 'true'
    }, reactComponents);
};
module.exports["ignoreAttribute"] = $938cf1eec2ff4dc1$export$72d101e93c081651;
module.exports["contentComponentClickWrapper"] = $938cf1eec2ff4dc1$export$57a965c23051130d;

});

parcelRegister("axOCf", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

var $6dGgK = parcelRequire("6dGgK");


var $d7ZU3 = parcelRequire("d7ZU3");


var $gnMzP = parcelRequire("gnMzP");

var $1zav4 = parcelRequire("1zav4");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $cOrQJ = parcelRequire("cOrQJ");


var $jTtEd = parcelRequire("jTtEd");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $30cdf9ef77478b9f$var$rotationAnimation = (0, $9K4OG.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg'
    },
    '100%': {
        '--panel-gradient-angle': '360deg'
    }
});
const $30cdf9ef77478b9f$var$rotationAnimationFirefox = (0, $9K4OG.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        backgroundPosition: '100%'
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        backgroundPosition: '-100%'
    }
});
const $30cdf9ef77478b9f$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $30cdf9ef77478b9f$var$aiPrismColorStep1Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.1']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep2Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.2']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep3Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.3']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep4Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.4']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep1Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.1']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep2Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.2']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep3Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.3']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep4Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.4']['dark'];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 12%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 24%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Light} 48%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 64%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 80%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 20%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 50%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Light} 56%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 12%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 24%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Dark} 48%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 64%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 80%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 20%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 50%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Dark} 56%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 100%)`;
const $30cdf9ef77478b9f$export$7d2a5652980d3808 = /*#__PURE__*/ (0, $9K4OG.css)({
    '@property --panel-gradient-angle': {
        syntax: '<angle>',
        initialValue: '270deg',
        inherits: false
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        /* This hides the label for the extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-label': {
            display: 'none'
        },
        /* This styles the ai panel correctly when its just sitting on the page and there
    is no user interaction */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            position: 'relative',
            boxShadow: 'none',
            overflow: 'unset',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
            // prismBorderBaseStyles
            '&::before, &::after': {
                content: "''",
                position: 'absolute',
                zIndex: -1,
                width: `calc(100% + 2px)`,
                height: `calc(100% + 2px)`,
                top: `-1px`,
                left: `-1px`,
                borderRadius: `calc(${"var(--ds-radius-small, 3px)"} + 1px)`,
                transform: 'translate3d(0, 0, 0)',
                background: $30cdf9ef77478b9f$var$prismBorderBaseBackground
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.with-hover-border': {
                '&::before, &::after': {
                    //prismBorderHoverStyles
                    background: "var(--ds-border-input, #8C8F97)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& .with-margin-styles': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
                borderRadius: "var(--ds-radius-small, 3px)"
            }
        }
    },
    /* This styles the ai panel correctly when its streaming */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                // prismBorderAnimationStyles
                animationName: $30cdf9ef77478b9f$var$rotationAnimation,
                animationDuration: '2s',
                animationTimingFunction: 'linear',
                animationIterationCount: 'infinite',
                '@media (prefers-reduced-motion)': {
                    animation: 'none'
                }
            }
        }
    },
    /* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"].danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    },
    /* This removes the margin from the action list when inside an ai panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensiontype="com.atlassian.ai-blocks"][extensionkey="ai-action-items-block:aiActionItemsBodiedExtension"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-node-type="actionList"]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
const $30cdf9ef77478b9f$export$541b06daf7fd8fce = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        '&::before, &::after': {
            background: $30cdf9ef77478b9f$var$prismBorderBaseBackgroundFirefox,
            backgroundSize: '200%'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                animationName: $30cdf9ef77478b9f$var$rotationAnimationFirefox,
                animationDirection: 'normal',
                animationDuration: '1s'
            }
        }
    }
});
const $30cdf9ef77478b9f$export$9a2d17c0df63f635 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $30cdf9ef77478b9f$var$prismBorderDarkBackground
            }
        }
    }
});
const $30cdf9ef77478b9f$export$18b242302a502e32 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $30cdf9ef77478b9f$var$prismBorderDarkBackgroundFirefox,
                backgroundSize: '200%'
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $6ESsx = parcelRequire("6ESsx");

const $e744a1f22573fa53$export$65cde0a0b7e7c1c1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}, .${(0, $6ESsx.AnnotationSharedClassNames).focus}, .${(0, $6ESsx.AnnotationSharedClassNames).draft}, .${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.card), &:has([data-inline-card])': {
                padding: '5px 0 3px 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.date-lozenger-container)': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).focus}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).draft}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)",
            cursor: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}`]: {
            background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ function $680457c62c4e856c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $680457c62c4e856c$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $680457c62c4e856c$export$e4cca17cf56e99d = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $0c8159821f1481e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidth = 1011;
// from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $0c8159821f1481e1$var$akEditorGutterPadding = 32;
const $0c8159821f1481e1$var$akEditorDefaultLayoutWidth = 760;
const $0c8159821f1481e1$var$akEditorFullWidthLayoutWidth = 1800;
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $0c8159821f1481e1$var$akEditorBreakpointForSmallDevice = `1266px`;
const $0c8159821f1481e1$var$akEditorGutterPaddingReduced = 24;
const $0c8159821f1481e1$var$akEditorFullPageNarrowBreakout = 600;
const $0c8159821f1481e1$var$akEditorUltraWideLayoutWidth = 4000;
const $0c8159821f1481e1$export$6a08aa478781aaec = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--default-gutter-padding': `${$0c8159821f1481e1$var$akEditorGutterPadding}px`,
    '--ak-editor--default-layout-width': `${$0c8159821f1481e1$var$akEditorDefaultLayoutWidth}px`,
    '--ak-editor--resizer-handle-spacing': `12px`,
    '--ak-editor--full-width-layout-width': `${$0c8159821f1481e1$var$akEditorFullWidthLayoutWidth}px`,
    /* calculate editor line length, 100cqw is the editor container width */ '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--default-layout-width))',
    '--ak-editor--max-width-layout-width': `${$0c8159821f1481e1$var$akEditorUltraWideLayoutWidth}px`,
    '--ak-editor--breakout-wide-layout-width': `${$0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidthSmallViewport}px`,
    '--ak-editor--breakout-full-page-guttering-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding))',
    '--ak-editor--breakout-fallback-width': 'calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))',
    '--ak-editor--breakout-min-width': '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--full-width-layout-width))',
        /* in full width appearances it's not possible to rely on cqw because it doesn't account for the page scrollbar, which depends on users system settings */ '--ak-editor--breakout-fallback-width': '100%',
        '--ak-editor--breakout-min-width': '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        '--ak-editor-max-container-width': 'calc(100cqw - var(--ak-editor--large-gutter-padding))',
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'var(--ak-editor-base-font-size)'
    },
    /* We can't allow nodes that are inside other nodes to bleed from the parent container */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > div[data-prosemirror-node-block] [data-prosemirror-node-block]': {
        '--ak-editor-max-container-width': '100%'
    },
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (width >= ${$0c8159821f1481e1$var$akEditorBreakpointForSmallDevice})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            '--ak-editor--breakout-wide-layout-width': `${$0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidth}px`
        }
    }
});
const $0c8159821f1481e1$export$8ccf5563eb1fc2f7 = {
    name: "1s8lswm",
    styles: ".fabric-editor--max-width-mode{--ak-editor--line-length:min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--max-width-layout-width));--ak-editor--breakout-fallback-width:100%;--ak-editor--breakout-min-width:0px;}"
};
const $0c8159821f1481e1$export$247cd720d09b9b61 = {
    name: "7glde6",
    styles: ".ProseMirror{--ak-editor-max-container-width:calc(100cqw - var(--ak-editor--large-gutter-padding)*2);}"
};
const $0c8159821f1481e1$export$9e26088fca9327a2 = {
    name: "ituy02",
    styles: "--ak-editor--large-gutter-padding:52px"
};
const $0c8159821f1481e1$export$cc6d483a79f2d275 = {
    name: "n99on3",
    styles: "--ak-editor--large-gutter-padding:72px"
};
const $0c8159821f1481e1$export$23029c6a73ca6b8c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${$0c8159821f1481e1$var$akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--large-gutter-padding': `${$0c8159821f1481e1$var$akEditorGutterPaddingReduced}px`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $7a303160bb76f51c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a303160bb76f51c$export$e561f1e4e17b129d = {
    name: "12yhdlz",
    styles: "*:not(.fabric-editor-block-mark) >, *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment):not(.fabric-editor-font-size), .fabric-editor-alignment:first-of-type:first-child, .fabric-editor-font-size:first-of-type:first-child, .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p, h1, h2, h3, h4, h5, h6, .heading-wrapper{&:first-child:not(style), style:first-child + *{margin-top:0;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $375f45f3b6bd3ab6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $375f45f3b6bd3ab6$export$610a2509037eaf6 = {
    name: "gpthf0",
    styles: ".ProseMirror{& blockquote{box-sizing:border-box;color:inherit;width:100%;display:inline-block;padding-top:0;padding-bottom:0;padding-left:var(--ds-space-200, 16px);border-left-width:var(--ds-border-width-selected, 2px);border-left-style:solid;border-left-color:var(--ds-border, #0B120E24);margin:0.75rem 0 0 0;margin-right:0;[dir=\"rtl\"] &{padding-left:0;padding-right:var(--ds-space-200, 16px);}&:first-child{margin-top:0;}&::before{content:'';}&::after{content:none;}& p{display:block;}& table, & table:last-child{display:inline-table;}> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child{display:block;}> .extensionView-content-wrap:last-child{display:block;}}.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;}> h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}}"
};
const $375f45f3b6bd3ab6$export$cf79be04c8e54f95 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror blockquote.danger': {
        backgroundColor: `${"var(--ds-background-danger, #FFECEB)"}`,
        borderLeftColor: `${"var(--ds-border-danger, #E2483D)"}`
    }
});
const $375f45f3b6bd3ab6$export$9be2adf7cb8aa3a1 = {
    name: "ihldpu",
    styles: ".ProseMirror blockquote.ak-editor-selected-node{background:var(--ds-background-accent-blue-subtler, #CFE1FD);border-left-color:var(--ds-border-selected, #1868DB);-webkit-user-select:text;&::selection, *::selection{background-color:transparent;}&::-moz-selection, *::-moz-selection{background-color:transparent;}}"
};
const $375f45f3b6bd3ab6$export$36460e974c9904b9 = {
    name: "jrdqfj",
    styles: ".ProseMirror{& h1{font:var(--editor-font-ugc-token-heading-h1);margin-bottom:0;margin-top:1.45833em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h2{font:var(--editor-font-ugc-token-heading-h2);margin-bottom:0;margin-top:1.4em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h3{font:var(--editor-font-ugc-token-heading-h3);margin-bottom:0;margin-top:1.31249em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h4{font:var(--editor-font-ugc-token-heading-h4);margin-top:1.25em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h5{font:var(--editor-font-ugc-token-heading-h5);margin-top:1.45833em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h6{font:var(--editor-font-ugc-token-heading-h6);margin-top:1.59091em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}}"
};
const $375f45f3b6bd3ab6$export$4a8301858e3f950 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h1': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(24em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(28 / 24)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h2': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(20em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(24 / 20)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.008em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h3': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(16em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(20 / 16)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.006em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h4': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(14em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 14)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.003em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h5': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(12em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 12)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h6': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(11em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 11)',
            color: "var(--ds-text-subtlest, #6B6E76)",
            fontWeight: "var(--ds-font-weight-bold, 653)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.455em',
            textTransform: 'none'
        }
    }
});
const $375f45f3b6bd3ab6$export$13d8dd04b9497c9a = {
    name: "18w6jtp",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror blockquote{padding-left:var(--ds-space-250, 20px);}.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote{padding-left:var(--ds-space-200, 16px);}"
};
// This class applies when the node is selected directly or is included in the selected range
const $375f45f3b6bd3ab6$var$isSelectedNode = `.${(0, $aFUXX.akEditorSelectedNodeClassName)}`;
const $375f45f3b6bd3ab6$var$isOuterMostSelectedNode = `${$375f45f3b6bd3ab6$var$isSelectedNode}:not(${$375f45f3b6bd3ab6$var$isSelectedNode} *)`;
const $375f45f3b6bd3ab6$var$isList = ':is(ul, ol, div[data-node-type="actionList"])';
const $375f45f3b6bd3ab6$var$isOuterMostList = `${$375f45f3b6bd3ab6$var$isList}:not(${$375f45f3b6bd3ab6$var$isList} *)`;
const $375f45f3b6bd3ab6$export$8a07948e3f1777 = /*#__PURE__*/ (0, $9K4OG.css)({
    // only apply selected styles to the outermost list to avoid nested selection styles for lists within lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isOuterMostList}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}`]: {
        background: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        WebkitUserSelect: 'text',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $375f45f3b6bd3ab6$export$adeff2341d3e8864 = /*#__PURE__*/ (0, $9K4OG.css)({
    // only apply danger styles to the outermost list to avoid nested danger styles for lists within lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isOuterMostList}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}.danger`]: {
        background: "var(--ds-background-danger, #FFECEB)"
    }
});
const $375f45f3b6bd3ab6$var$isText = `:is(p, h1, h2, h3, h4, h5, h6)`;
const $375f45f3b6bd3ab6$var$isRootText = `${$375f45f3b6bd3ab6$var$isText}:not(${$375f45f3b6bd3ab6$var$isList} ${$375f45f3b6bd3ab6$var$isText})`;
const $375f45f3b6bd3ab6$export$3683cb70e936c4c8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isRootText}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}`]: {
        background: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        WebkitUserSelect: 'text',
        boxShadow: `0 -4px 0 ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}, 0 4px 0 ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $375f45f3b6bd3ab6$export$162efa362a1cdef5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isRootText}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}.danger`]: {
        background: "var(--ds-background-danger, #FFECEB)",
        boxShadow: `0 -4px 0 ${"var(--ds-background-danger, #FFECEB)"}, 0 4px 0 ${"var(--ds-background-danger, #FFECEB)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $e93d54020f263515$export$cd7bee32f3fef345 = /*#__PURE__*/ (0, $9K4OG.css)({
    backgroundImage: `
		linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		)
	`
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $65bb5c5a687b3665$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65bb5c5a687b3665$export$a716852a0c5e54d5 = {
    name: "1fqpa4w",
    styles: "&::selection,*::selection{background-color:transparent;}&::-moz-selection,*::-moz-selection{background-color:transparent;}"
};
const $65bb5c5a687b3665$export$48dd9ca0c16e4625 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    border: `1px solid ${"var(--ds-border-selected, #1868DB)"}`,
    // Fixes ED-15246: Trello card is visible through a border of a table border
    '&::after': {
        height: '100%',
        content: "'\\00a0'",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        background: "var(--ds-border-selected, #1868DB)",
        position: 'absolute',
        right: -1,
        top: 0,
        bottom: 0,
        width: 1,
        border: 'none',
        display: 'inline-block'
    }
});
const $65bb5c5a687b3665$export$a8e8bf15b18b52a0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    borderColor: 'transparent'
});
const $65bb5c5a687b3665$export$b2937e5c446645ec = {
    name: "16c0srz",
    styles: "background-color:var(--ds-background-selected, #E9F2FE)"
};
const $65bb5c5a687b3665$export$e7c1f2908e268236 = {
    name: "na0ofp",
    styles: "position:relative;-webkit-user-select:text;&::before{position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;z-index:12;background-color:var(--ds-blanket-selected, #388BFF14);}"
};
const $65bb5c5a687b3665$export$b8cc3f8fc9e3d56a = {
    name: "105gl83",
    styles: ".ProseMirror-hideselection{*::selection{background:transparent;}*::-moz-selection{background:transparent;}}"
};
const $65bb5c5a687b3665$export$cc1dcabcf4a29354 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
const $65bb5c5a687b3665$export$a3d8f4cb8a14da43 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode:empty': {
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $65bb5c5a687b3665$export$57f48b634c3a2512 = /*#__PURE__*/ (0, $9K4OG.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
});
const $65bb5c5a687b3665$export$fd4ac125b4ba4c28 = {
    name: "74cays",
    styles: "background-color:var(--ds-background-danger, #FFECEB)"
};


function $1e5fdc47935572b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e5fdc47935572b3$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $1e5fdc47935572b3$var$fontSize14px = `${0.875}rem`;
const $1e5fdc47935572b3$var$blockNodesVerticalMargin = '0.75rem';
const $1e5fdc47935572b3$var$gutterDangerOverlay = {
    name: "110x2n0",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, #EF5C4814);}"
};
const $1e5fdc47935572b3$export$4baaed2b257b830 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            marginRight: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                display: 'block',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            display: 'flex',
            flex: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                flexGrow: 1,
                whiteSpace: 'pre'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            borderRadius: "var(--ds-radius-small, 3px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            margin: `${$1e5fdc47935572b3$var$blockNodesVerticalMargin} 0 0 0`,
            fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: 48,
            cursor: 'pointer',
            clear: 'both',
            // This is necessary to allow for arrow key navigation in/out of code blocks in Firefox.
            whiteSpace: 'normal',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                content: 'attr(data-label)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_START}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                top: 0,
                left: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_END}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                bottom: 0,
                right: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $e93d54020f263515$export$cd7bee32f3fef345),
                {
                    position: 'relative',
                    backgroundColor: "var(--ds-background-neutral, #0515240F)",
                    display: 'flex',
                    borderRadius: "var(--ds-radius-small, 3px)",
                    width: '100%',
                    counterReset: 'line',
                    overflowX: 'auto',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
                    backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%`,
                    backgroundPosition: `0 0,
	                             0 0,
                               100% 0,
                               100% 0,
                               100% 0,
                               100% 0,
	                             0 0,
	                             0 0`,
                    // Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers.
                    overflowY: 'hidden'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                backgroundColor: "var(--ds-background-neutral, #0515240F)",
                position: 'relative',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                padding: "var(--ds-space-100, 8px)",
                flexShrink: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                boxSizing: 'content-box'
            },
            // This is a fix of marker of list item with code block.
            // The list item marker in Chrome is aligned by the baseline of the text,
            // that's why we need to add a text (content: "1") to the line number gutter to align
            // the list item marker with the text.
            // Without it, the list item marker will be aligned by the bottom of the code block. */
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
                content: "'1'",
                visibility: 'hidden',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    tabSize: 4,
                    cursor: 'text',
                    color: "var(--ds-text, #292A2E)",
                    borderRadius: "var(--ds-radius-small, 3px)",
                    margin: "var(--ds-space-100, 8px)",
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: $1e5fdc47935572b3$var$fontSize14px,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5rem'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
                pointerEvents: 'none',
                userSelect: 'none',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                left: 0,
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                padding: `0px ${"var(--ds-space-100, 8px)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem',
                textAlign: 'right',
                color: "var(--ds-text-subtlest, #6B6E76)",
                boxSizing: 'content-box'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        li: {
            // if same list item has multiple code blocks we need top margin for all but first
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${$1e5fdc47935572b3$var$blockNodesVerticalMargin} 0 0 0`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .code-block:first-child, > .ProseMirror-gapcursor:first-child + .code-block': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> div:last-of-type.code-block, > pre:last-of-type.code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginBottom: $1e5fdc47935572b3$var$blockNodesVerticalMargin
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.code-block.ak-editor-selected-node:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // Danger when top level node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger.code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $1e5fdc47935572b3$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        },
        // Danger when nested node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $1e5fdc47935572b3$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});
const $1e5fdc47935572b3$export$921fec04d268c00a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                display: 'flow',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5em'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: '0.875em',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5em'
                }
            }
        }
    }
});
const $1e5fdc47935572b3$export$ddc3dd3ba723d1af = {
    name: "1pwqusk",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child, > .ProseMirror-widget:first-child + .code-block, > .ProseMirror-widget:first-child + .ProseMirror-widget + .code-block{margin:0!important;}}}"
};
const $1e5fdc47935572b3$export$50458a606d5c37d0 = {
    name: "1jcwwg4",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child{margin:0!important;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $9fb7690d6af70e31$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9fb7690d6af70e31$export$2029176b06e1b241 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        borderRadius: "var(--ds-radius-small, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #292A2E)",
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $9fb7690d6af70e31$export$a1c093cc2c35593e = {
    name: "1o0vvbu",
    styles: ".code{overflow:unset;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $8ba9ce11757ecee6$var$CommentEditorMargin = 14;
const $8ba9ce11757ecee6$var$GRID_GUTTER = 12;
const $8ba9ce11757ecee6$export$d6e7bceefcc20e27 = /*#__PURE__*/ (0, $9K4OG.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$8ba9ce11757ecee6$var$CommentEditorMargin - $8ba9ce11757ecee6$var$GRID_GUTTER}px)`
    },
    padding: "var(--ds-space-250, 20px)"
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $034503d6cd31c145$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $034503d6cd31c145$export$f21d9f928c6ae322 = {
    name: "l350f4",
    styles: ".ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}.ProseMirror:has(.ProseMirror-hide-cursor){caret-color:transparent;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



const $332bd83257b23222$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $332bd83257b23222$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        color: "var(--ds-text, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span:hover`]: {
        backgroundColor: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red`]: {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red:hover`]: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $332bd83257b23222$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $332bd83257b23222$export$f9f3f08b750aaa7d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node.danger .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
    ]
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $8c084c7e0576e8c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c084c7e0576e8c1$export$87e0522332cd3719 = {
    name: "u5gvmr",
    styles: "--editor-font-ugc-token-heading-h1:normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$95588e746468319e = {
    name: "14r7dlz",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$63adc0ebe3278d31 = {
    name: "1maftdw",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$3bdf5e0c4fe1eac4 = {
    name: "tk4rtd",
    styles: "--editor-font-ugc-token-body-small:normal 400 0.875em/1.714 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $92bd659d1ad36350$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92bd659d1ad36350$export$5a1f57c6600b90f1 = {
    name: "1tw1dm8",
    styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;position:relative;z-index:2;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");





function $64073fed169900b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64073fed169900b9$var$emojiSelectionStyles = {
    name: "1h3rhjl",
    styles: "border-radius:var(--ds-radius-xsmall, 2px)"
};
const $64073fed169900b9$export$d73b97ac20f33f4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
        background: 'no-repeat transparent',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxHeight: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        cursor: 'pointer',
        verticalAlign: 'middle',
        userSelect: 'all'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            $64073fed169900b9$var$emojiSelectionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    }
});
const $64073fed169900b9$export$3db84a979dc69b56 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
        background: 'no-repeat transparent',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        minHeight: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        minWidth: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxHeight: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxWidth: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        cursor: 'pointer',
        verticalAlign: 'middle',
        userSelect: 'all'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            $64073fed169900b9$var$emojiSelectionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH1)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH2)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH2)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH3)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH3)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH4)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH4)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.ProseMirror :is(h5, h6, p) .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.defaultEmojiHeight)}px`
    }
});
var $64073fed169900b9$var$_ref2 = {
    name: "0",
    styles: ""
};
const $64073fed169900b9$export$1cdf865bc84cef4 = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $64073fed169900b9$var$_ref2;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            minHeight: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            maxHeight: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            maxWidth: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            img: {
                width: '100%',
                height: '100%',
                objectFit: 'contain'
            }
        },
        // Scale panel icon in dense mode
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror .ak-editor-panel .ak-editor-panel__icon': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: "var(--ds-space-250, 20px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: "var(--ds-space-250, 20px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH1)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH2)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH2)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH3)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH3)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH4)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH4)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h1 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH1)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h2 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH2)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH2)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h3 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH3)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH3)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h4 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH4)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH4)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-selectors
        [`.ProseMirror :is(h5, h6, p) .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`
        }
    });
};
/**
 * Gets dynamic emoji styles that scale emoji size based on the base font size.
 * This allows emojis to scale proportionally when the base font size changes.
 * @param baseFontSize - The base font size in pixels (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with emoji size overrides if baseFontSize is provided and different from default.
 */ var $64073fed169900b9$var$_ref = {
    name: "0",
    styles: ""
};
const $64073fed169900b9$export$2a2707475ad11d76 = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $64073fed169900b9$var$_ref;
    // Calculate emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    const emojiSize = (0, $fhsiz.defaultEmojiHeight) * baseFontSize / (0, $aFUXX.akEditorFullPageDefaultFontSize);
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxHeight: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            img: {
                width: '100%',
                height: '100%',
                objectFit: 'contain'
            }
        },
        // Scale panel icon in dense mode
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror .ak-editor-panel .ak-editor-panel__icon': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: "var(--ds-space-250, 20px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: "var(--ds-space-250, 20px)"
        }
    });
};
const $64073fed169900b9$export$df03c70a9b9671c1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512),
                (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28)
            ]
        ]
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $35750f0b594d4ce9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $35750f0b594d4ce9$export$ed25ef5a9db895f7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon > div': {
        display: 'flex'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand': {
        // sharedExpandStyles.containerStyles({ expanded: false, focused: false })(),
        borderWidth: "var(--ds-border-width, 1px)",
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderRadius: "var(--ds-radius-small, 4px)",
        minHeight: '25px',
        background: "var(--ds-background-neutral-subtle, #00000000)",
        margin: `${"var(--ds-space-050, 4px)"} 0 0`,
        transition: 'background 0.3s cubic-bezier(0.15, 1, 0.3, 1), border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
        padding: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > :not(style):first-child, td > style:first-child + *': {
            marginTop: 0
        },
        cursor: 'pointer',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > &': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(90deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&.ak-editor-selected-node:not(.danger)': {
            // SelectionStyle.Blanket
            position: 'relative',
            // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
            // in Safari. Looks like it's caused by user-select: all in the emoji element
            WebkitUserSelect: 'text',
            '&::before': {
                position: 'absolute',
                content: "''",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: '100%',
                pointerEvents: 'none',
                zIndex: 12,
                // akEditorStickyheaderZIndex (11) + 1
                backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
            },
            // SelectionStyle.Border (common case)
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
            // If fg('platform_editor_nested_dnd_styles_changes') is true,
            // then we'll also need the rest of the selection styles for blanket
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            background: "var(--ds-background-danger, #FFECEB)",
            borderColor: "var(--ds-border-danger, #E2483D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__content': {
        // sharedExpandStyles.contentStyles({ expanded: false, focused: false })(),
        paddingTop: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-050, 4px)",
        display: 'flow-root',
        /* The follow rules inside @supports block are added as a part of ED-8893
    	The fix is targeting mobile bridge on iOS 12 or below,
    	We should consider remove this fix when we no longer support iOS 12 */ '@supports not (display: flow-root)': {
            width: '100%',
            boxSizing: 'border-box'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.expand-content-wrapper, .nestedExpand-content-wrapper': {
            /* We visually hide the content here to preserve the content during copy+paste */ /* Do not add text nowrap here because inline comment navigation depends on the location of the text */ width: '100%',
            display: 'block',
            height: 0,
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            userSelect: 'none'
        },
        cursor: 'text',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-expand__content--collapsed': {
            display: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
        // sharedExpandStyles.titleInputStyles(),
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #6B6E76)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #6B6E76)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-container': {
        // sharedExpandStyles.titleContainerStyles(),
        padding: 0,
        display: 'flex',
        // Omitting alignItems: 'flex-start' as it would be overridden
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        width: '100%',
        color: "var(--ds-text-subtle, #505258)",
        // Omitting overflow: 'hidden' as it would be overridden
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus': {
            outline: 0
        },
        alignItems: 'center',
        overflow: 'visible'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon-button': {
        appearance: 'none',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        border: 'none',
        borderRadius: "var(--ds-radius-small, 4px)",
        background: "var(--ds-background-neutral-subtle, #00000000)",
        padding: 0,
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:disabled': {
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
            outlineOffset: "var(--ds-space-025, 2px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:hover:not(:disabled)': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(0deg)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)};`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__expanded': {
        background: "var(--ds-background-neutral-subtle, #00000000)",
        borderColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            paddingTop: "var(--ds-space-100, 8px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-button': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-expand__icon-svg': {
                transform: 'rotate(90deg)'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__input-container': {
        width: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-expand:not(.ak-editor-expand__expanded)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            position: 'absolute',
            height: '1px',
            width: '1px',
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            whiteSpace: 'nowrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(0deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.ak-editor-selected-node):not(.danger)': {
            background: 'transparent',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: "var(--ds-border, #0B120E24)",
                background: "var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    }
});
const $35750f0b594d4ce9$export$4bb28258452e3b9a = {
    name: "1tkdo8v",
    styles: ".ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand{margin-left:var(--ds-space-negative-150, -12px);margin-right:var(--ds-space-negative-150, -12px);}"
};
/**
 * This function gets the dynamic styles that scale the expand title font size based on the base font size.
 * If the base font size is not the default font size, we want the expand title font size to match the base font size.
 * @param baseFontSize - The base font size in pixels. (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with expand title font size override if baseFontSize is provided and different from default.
 */ var $35750f0b594d4ce9$var$_ref = {
    name: "0",
    styles: ""
};
const $35750f0b594d4ce9$export$9f08fc5d3959d07e = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $35750f0b594d4ce9$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-container': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        }
    });
};
const $35750f0b594d4ce9$export$20843fd014d7530c = {
    name: "1j6g9xo",
    styles: ".ak-editor-expand__title-input{line-height:1;font-family:var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}"
};
const $35750f0b594d4ce9$export$26d7f96b2bb98b5b = {
    name: "1nxi2gf",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand{margin-left:var(--ds-space-negative-250, -20px);margin-right:var(--ds-space-negative-250, -20px);}.ak-editor-expand__expanded{.ak-editor-expand__content{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}> div.ak-editor-expand[data-node-type=\"nestedExpand\"]{margin-top:var(--ds-space-050, 4px);}}}"
};
const $35750f0b594d4ce9$export$bdee15c929dd4423 = {
    name: "vfk8pi",
    styles: ".ProseMirror > .ak-editor-expand{margin-left:0;margin-right:0;}"
};
const $35750f0b594d4ce9$export$4dd1b2c2505a38a = {
    name: "yqkk6p",
    styles: ".ak-editor-expand{&.ak-editor-selected-node:not(.danger){&::after{height:100%;content:'\\00a0';background:var(--ds-border-selected, #1868DB);position:absolute;right:-1px;top:0;bottom:0;width:1px;border:none;display:inline-block;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 












function $91793a38cb990edb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Creates the extension styles with the ability to use feature flags and experiments.
 * @returns Complete SerializedStyles including base styles and any feature-gated styles
 */ var $91793a38cb990edb$var$_ref = {
    name: "0",
    styles: ""
};
var $91793a38cb990edb$var$_ref2 = {
    name: "0",
    styles: ""
};
var $91793a38cb990edb$var$_ref3 = {
    name: "pwxs72",
    styles: ".extension-container [data-macro-name=\"toc\"] * :not(.status-lozenge-span *){font-size:var(--ak-editor-base-font-size);}.extension-container .ak-excerpt-include :not([data-inline-card-lozenge] *, code, .status-lozenge-span *, .code-block *){font-size:var(--ak-editor-base-font-size);}"
};
const $91793a38cb990edb$export$9abdb593a2600bc6 = (contentMode)=>{
    const baseExtensionStyles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.multiBodiedExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .multiBodiedExtension--container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.multiBodiedExtension--overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .multiBodiedExtension--container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.multiBodiedExtension--container': {
                width: '100%',
                maxWidth: '100%' // ensure width can't go over 100%
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.inlineExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .with-danger-overlay': {
                /* If the macro turned used to red before, not setting the background to be transparent will cause the
        danger state to have two layers of red which we don't want. */ backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            }
        },
        /* This is referenced in the toDOM of a bodied extension and is used to put
    label content into the bodied extension.
    We do this so that we don't serialise the label (which causes the label to be
    copied to the clipboard causing copy-paste issues). */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodied-extension-to-dom-label::after': {
            content: 'attr(data-bodied-extension-label)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap, .multiBodiedExtensionView-content-wrap, .bodiedExtensionView-content-wrap': {
            margin: `0.75rem 0`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-of-type': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:last-of-type': {
                marginBottom: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            /** Targets legacy content header in LCM extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .legacy-content-header': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& .status-lozenge-span > span': {
                    backgroundColor: `${"var(--ds-background-accent-red-subtle-hovered, #FD9891)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.inline': {
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap .extension-container': {
            overflow: 'hidden',
            /* Don't hide overflow for editors inside extensions. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.extension-editable-area)': {
                overflow: 'visible'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container': {
            width: '100%',
            maxWidth: '100%' // ensure width can't go over 100%
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "[data-mark-type='fragment']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                margin: '0.75rem 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > [data-mark-type='dataConsumer']": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    margin: '0.75rem 0'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginTop: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginTop: 0
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:nth-last-of-type(-n + 2):not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginBottom: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginBottom: 0
                    }
                }
            }
        }
    });
    // Dense content mode extensions styling fix - addresses EDITOR-1992
    // When cleaning up the experiment, move this logic into the baseExtensionStyles above
    const fontSize = (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') ? (0, $aFUXX.relativeFontSizeToBase16)((0, $aFUXX.akEditorFullPageDenseFontSize)) : undefined;
    const denseExtensionStyles = contentMode === 'compact' && (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $91793a38cb990edb$var$_ref3 : contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) ? /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container a span': {
            fontSize: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize
        }
    }) : $91793a38cb990edb$var$_ref2;
    const bodiedExtensionLayoutShiftFixStyles = (0, $1oCLl.expValEquals)('platform_editor_bodiedextension_layoutshift_fix', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodiedExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.bodiedExtension-content-outer-wrapper': {
                margin: '23px -1px -1px -1px' // Reserve space for lozenge (24px) then subtract 1px to account for the border of the inner wrapper preventing layoutshift
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.bodiedExtension-content-inner-wrapper': {
                margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
                padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`,
                border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                borderRadius: "var(--ds-radius-small, 3px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.extension-container': {
                // Remove styling when Prosemirror moves content inside
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.bodiedExtension-content-outer-wrapper': {
                    margin: '0'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.bodiedExtension-content-inner-wrapper': {
                    margin: 0,
                    padding: 0,
                    border: 'none',
                    borderRadius: 0
                }
            }
        }
    }) : $91793a38cb990edb$var$_ref;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    return /*#__PURE__*/ (0, $9K4OG.css)(baseExtensionStyles, denseExtensionStyles, bodiedExtensionLayoutShiftFixStyles);
};
const $91793a38cb990edb$export$c6823b394e119a7e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.show-diff-changed-decoration-node > span .extension-container`]: {
        boxShadow: `0 0 0 var(--diff-decoration-marker-ring-width, 1px) var(--diff-decoration-marker-color)`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $5MaNT = parcelRequire("5MaNT");

const $19957a194e4b6622$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match': {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `${"var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"}, inset 0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.selected-search-match': {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});
const $19957a194e4b6622$export$a5471dc947aff188 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #292A2E)"} !important`
        }
    }
});
const $19957a194e4b6622$export$fae24dca059c5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match-text.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #292A2E)"} !important`
        }
    }
});
const $19957a194e4b6622$export$2ad4be5f6c1e4bbf = /*#__PURE__*/ (0, $9K4OG.css)({
    // text - inactive match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #292A2E)"
    },
    // text - active match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"} !important`
    },
    // text - inactive match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"} !important`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // text - active match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"} !important`
    },
    // block node - inactive match - light mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0px 0px 0px 5px ${"var(--ds-border-accent-magenta, #CD519D)"}
			`
        }
    },
    // block node - active match - light mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        }
    },
    // block node - inactive match - light mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0px 0px 0px 5px ${"var(--ds-border-accent-magenta, #CD519D)"}
			`
        }
    },
    // block node - active match - light mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        }
    },
    // block node - inactive match - dark mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // block node - active match - dark mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // block node - inactive match - dark mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // block node - active match - dark mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // expand title - inactive match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text, #292A2E)"
        }
    },
    // expand title - active match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"
    },
    // expand title - inactive match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // expand title - active match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $DoNsZ = parcelRequire("DoNsZ");


var $iMS6j = parcelRequire("iMS6j");

var $cV5SN = parcelRequire("cV5SN");


const $563563a54a51d8c3$export$2d6e8a1d666d4a60 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`> .${(0, $DoNsZ.PanelSharedCssClassName).prefix}, > .${(0, $1e5fdc47935572b3$export$42659c26f026f6ea).CODEBLOCK_CONTAINER}, > .${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}, > div[data-task-list-local-id], > div[data-layout-section], > .${(0, $iMS6j.expandClassNames).prefix}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> hr:first-child, > .ProseMirror-widget:first-child + hr': {
            marginTop: 0
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $b08ecd070af20ccb$export$f06cff4aa315bcf9 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'button.first-floating-toolbar-button:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $a227b436ae91f932$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a227b436ae91f932$export$5efd6032566fe395 = {
    name: "1qqozmq",
    styles: ".ProseMirror{.fabric-editor-font-size{&[data-font-size='small']{font:var(--editor-font-ugc-token-body-small);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--editor-font-ugc-token-body-small);}[data-prosemirror-node-name='blockTaskItem']:has(.fabric-editor-font-size[data-font-size='small']){font:var(--editor-font-ugc-token-body-small);.fabric-editor-font-size{font:inherit;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $8478647a8b452658$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8478647a8b452658$export$eb88bb4706d67f65 = {
    name: "1ro9jdo",
    styles: "flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $ba96bd4668ffc758$var$gapCursorBlink = (0, $9K4OG.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $ba96bd4668ffc758$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $ba96bd4668ffc758$var$gapCursorSelector = '.ProseMirror-gapcursor';
const $ba96bd4668ffc758$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $ba96bd4668ffc758$var$wrapLeft = '[layout="wrap-left"]';
const $ba96bd4668ffc758$var$wrapRight = '[layout="wrap-right"]';
const $ba96bd4668ffc758$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $ba96bd4668ffc758$var$twoImagesSideBySideFixSelector = `
  ${$ba96bd4668ffc758$var$gapCursorSelector}${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$gapCursorSelector}${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector}`;
const $ba96bd4668ffc758$var$marginFixSelector = `
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} > div`;
const $ba96bd4668ffc758$var$floatLeftFixSelector = `
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector}`;
const $ba96bd4668ffc758$var$afterPresudoSelector = `
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft}::after,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft}::after,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft}::after`;
const $ba96bd4668ffc758$var$marginDeepChildrenFixSelector = `
${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + * > *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$prosemirrorwidgetNotBlock} + ${$ba96bd4668ffc758$var$gapCursorSelector} + *,
  ${$ba96bd4668ffc758$var$prosemirrorwidgetNotBlock} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + *`;
const $ba96bd4668ffc758$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$ba96bd4668ffc758$export$8adc5edbc4a22166}`]: {
            // Clean this up with platform_synced_block
            caretColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$ba96bd4668ffc758$var$gapCursorSelector]: {
            display: 'none',
            pointerEvents: 'none',
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span': {
                caretColor: 'transparent',
                position: 'absolute',
                height: '100%',
                width: '100%',
                display: 'block'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span::after': {
                animation: `1s ${$ba96bd4668ffc758$var$gapCursorBlink} step-start infinite`,
                borderLeft: '1px solid',
                content: "''",
                display: 'block',
                position: 'absolute',
                top: 0,
                height: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-left span::after': {
                left: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-right span::after': {
                right: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span[layout="full-width"], & span[layout="wide"], & span[layout="fixed-width"]': {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginLeft: '50%',
                transform: 'translateX(-50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`&${$ba96bd4668ffc758$var$wrapRight}`]: {
                float: 'right'
            },
            /* fix vertical alignment of gap cursor */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$ba96bd4668ffc758$var$fixVerticalAlignmentSelector]: {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ProseMirror-focused ${$ba96bd4668ffc758$var$gapCursorSelector}`]: {
            display: 'block',
            borderColor: 'transparent'
        }
    },
    /* This hack below is for two images aligned side by side */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$twoImagesSideBySideFixSelector]: {
        clear: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$marginFixSelector]: {
        marginRight: 0,
        marginLeft: 0,
        marginBottom: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$floatLeftFixSelector]: {
        float: 'left'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$afterPresudoSelector]: {
        visibility: 'hidden',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        content: "' '",
        clear: 'both',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$marginDeepChildrenFixSelector]: {
        marginTop: 0
    }
});
const $ba96bd4668ffc758$export$bfbb8fb576027812 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&:has(${$ba96bd4668ffc758$var$gapCursorSelector})`]: {
            caretColor: 'transparent'
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $3b9a5370a72c9df5$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + 24px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        zIndex: 2
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $e776189f3c3af959$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e776189f3c3af959$export$fc74cf03693076b4 = {
    name: "86ymtv",
    styles: ".ProseMirror{.fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $3b65c10c9ad50286$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b65c10c9ad50286$export$3fc32cdc53f6edeb = {
    name: "n6ftfq",
    styles: ".ProseMirror{.inlineNodeView{display:inline;user-select:all;white-space:nowrap;& > *:not(.zeroWidthSpaceContainer){white-space:pre-wrap;}& > .assistive{user-select:none;}}&.ua-safari{.inlineNodeView{&::selection, *::selection{background:transparent;}}}&.ua-chrome .inlineNodeView > span{user-select:none;}.inlineNodeViewAddZeroWidthSpace{&::after{content:'\u200B';}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



function $07d5bf3f0b10fce1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07d5bf3f0b10fce1$var$gridMediumMaxWidth = 1024;
const $07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
// Class names for the column resize divider widget — must stay in sync with main.ts in editor-plugin-layout
const $07d5bf3f0b10fce1$var$layoutColumnDividerClassName = 'layout-column-divider';
const $07d5bf3f0b10fce1$var$layoutColumnDividerRailClassName = 'layout-column-divider-rail';
const $07d5bf3f0b10fce1$var$layoutColumnDividerThumbClassName = 'layout-column-divider-thumb';
const $07d5bf3f0b10fce1$export$2e7c649d642e8659 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
        // Negative margin removes the applied 'gap' from the parent's flex box
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginInline: '-15px 0px',
        flexShrink: 0,
        boxSizing: 'content-box',
        cursor: 'col-resize',
        position: 'relative',
        zIndex: 2,
        alignSelf: 'stretch',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&:hover .${$07d5bf3f0b10fce1$var$layoutColumnDividerRailClassName}`]: {
            background: "var(--ds-background-selected, #E9F2FE)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&:hover .${$07d5bf3f0b10fce1$var$layoutColumnDividerThumbClassName}`]: {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // Rail and thumb styles intentionally mirror the breakout resize handle
    // (see .pm-breakout-resize-handle-rail and .pm-breakout-resize-handle-thumb in resizerStyles.ts).
    // If updating these styles, consider keeping both in sync.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerRailClassName}`]: {
        width: 7,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerThumbClassName}`]: {
        minWidth: 3,
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #0B120E24)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        pointerEvents: 'none',
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $07d5bf3f0b10fce1$export$ed4b77c142cd3096 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginInline: '0 -7px'
    }
});
const $07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor = '.fabric-editor--full-width-mode .ProseMirror > .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor = '.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror > .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor = '.ProseMirror .fabric-editor-breakout-mark .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector = `&.selected, &:hover, &.selected.danger, &.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`;
const $07d5bf3f0b10fce1$var$layoutSelectedSelector = `&.selected, [data-empty-layout='true'], &:hover, &.selected.danger [data-layout-section], &.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`;
const $07d5bf3f0b10fce1$export$8dd21c7c24132a82 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> [data-layout-column]': {
            margin: '0 4px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:first-of-type': {
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:last-of-type': {
            marginRight: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                margin: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`> [data-layout-column].${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                // layout column selection shorter after layout border has been removed
                '::before': {
                    width: 'calc(100% - 8px)',
                    left: 4,
                    borderRadius: "var(--ds-radius-small, 3px)"
                }
            }
        ]
    }
});
const $07d5bf3f0b10fce1$export$67aba4052ecc5648 = {
    name: "svgls9",
    styles: ".ProseMirror [data-layout-section]{> [data-layout-column][style*=\"--column-width\"]{flex-basis:var(--column-resize-width, var(--column-width));flex:var(--column-resize-flex, 1);}}"
};
const $07d5bf3f0b10fce1$export$fe39d5414c0135d3 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-column] + [data-layout-column]': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: 8
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                marginLeft: 0
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$55890fd3e3be7f1b = {
    name: "4jflbi",
    styles: ".ProseMirror [data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $07d5bf3f0b10fce1$export$d9912ef7f698aab8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .layout-section-container [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .ProseMirror-widget': {
            flex: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'contents !important',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-blocks-drag-handle-container] div': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                display: 'contents !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-blocks-drop-target-container]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                display: 'block !important',
                margin: "var(--ds-space-negative-050, -4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '[data-drop-target-for-element]': {
                    position: 'absolute'
                }
            },
            // Column resize divider: always in DOM, hidden via opacity by default
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                display: 'block !important',
                flex: 'none',
                opacity: 0,
                transition: 'opacity 0.2s'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& + [data-layout-column]': {
                margin: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> [data-layout-column]': {
            margin: 0
        }
    },
    // On hover: fade in drag divider and hide the 1px separator
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror .layoutSectionView-content-wrap:hover .layout-section-container [data-layout-section]`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`> .ProseMirror-widget.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`> .ProseMirror-widget.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName} ~ [data-layout-column] [data-layout-content]::before`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        }
    }
});
const $07d5bf3f0b10fce1$export$17d7fe9c8be65e97 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`& > .${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
            flex: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $07d5bf3f0b10fce1$export$cdcbf2d4bffabda6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // Shows the border when cursor is inside a layout
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected [data-layout-column], &:hover [data-layout-column]': {
                border: `1px solid ${"var(--ds-border, #0B120E24)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-column]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                borderColor: "var(--ds-border-danger, #E2483D)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$48dd9ca0c16e4625),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                    {
                        '::after': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
// TODO: ED-28075 - inline rowSeparatorBaseStyles to unblock Compiled CSS migration
const $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
        content: "''",
        borderTop: `1px solid ${"var(--ds-border, #0B120E24)"}`,
        position: 'absolute',
        width: 'calc(100% - 32px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: -13,
        // clear styles for column separator
        borderLeft: 'unset',
        marginLeft: 'unset',
        height: 'unset'
    }
});
const $07d5bf3f0b10fce1$export$fe59793079ccb11a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$07d5bf3f0b10fce1$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    content: "''",
                    borderLeft: `1px solid ${"var(--ds-border, #0B120E24)"}`,
                    position: 'absolute',
                    height: 'calc(100% - 24px)',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                    marginLeft: -25
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                borderRadius: "var(--ds-radius-small, 4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                    {
                        border: 0,
                        '::before': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$1ce35d5e797e3173 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                boxShadow: `inset 0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `inset 0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$c1454bb6dd8837f5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:724px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:788px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:820px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$203a03d09c37c555 = /*#__PURE__*/ (0, $9K4OG.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$ce383b8d82e44bf5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            margin: `${"var(--ds-space-100, 8px)"} -12px 0`,
            transition: 'border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
            cursor: 'pointer',
            // Inner cursor located 26px from left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column]': {
                flex: 1,
                position: 'relative',
                minWidth: 0,
                /* disable 4 borders when in view mode and advanced layouts is on */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                padding: "var(--ds-space-150, 12px)",
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> div': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .embedCardView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .mediaSingleView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor.-right:first-child + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor.-right + .mediaSingleView-content-wrap .rich-media-item, > .ProseMirror-gapcursor.-right:first-of-type + .embedCardView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor + span + .mediaSingleView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down and shrinking layout's node selectable area (leniency margin)
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "> [data-node-type='decisionList']": {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                        'li:first-of-type [data-decision-wrapper]': {
                            marginTop: 0
                        }
                    }
                },
                // Make the 'content' fill the entire height of the layout column to allow click handler of layout section nodeview to target only data-layout-column
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '[data-layout-content]': {
                    height: '100%',
                    cursor: 'text',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '.mediaGroupView-content-wrap': {
                        clear: 'both'
                    }
                }
            }
        }
    },
    // hide separator when element is dragging on top of a layout column
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode .ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-table-container': {
                margin: '0 2px'
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$4921bd0cd96a70c2 = {
    name: "1k5f3br",
    styles: ".ProseMirror{[data-layout-section]{[data-layout-column]{> div{.pm-table-container{width:100% !important;}}}}}"
};
const $07d5bf3f0b10fce1$export$74ce03ae8f7cbe1a = {
    name: "14on7sz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column]{border:0;}"
};
const $07d5bf3f0b10fce1$export$4d009f8d3cbd5535 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -20px 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section] [data-layout-column]': {
        padding: '12px 20px'
    }
});
const $07d5bf3f0b10fce1$export$b371e818feeb9ba8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // Apply -20px margin to all sections
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -20px 0`
    },
    // Reset to default margin when inside bodied sync block
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-prosemirror-node-name="bodiedSyncBlock"] [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -12px 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section] [data-layout-column]': {
        padding: '12px 20px'
    }
});
const $07d5bf3f0b10fce1$export$20e6a345585c5c3c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
            [$07d5bf3f0b10fce1$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    borderLeft: 0
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                boxShadow: `0 0 0 0 ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 0 ${"var(--ds-border-selected, #1868DB)"}`
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$70038a77af1ac7b5 = {
    name: "1nqe1o0",
    styles: ".ProseMirror{[data-layout-section], .layoutSectionView-content-wrap{&.selected [data-layout-column], &:hover [data-layout-column]{border:0;}}}"
};
const $07d5bf3f0b10fce1$export$ec8bdd18ecbadae7 = {
    name: "1xloaqb",
    styles: ".ProseMirror{[data-layout-section]{cursor:default;[data-layout-column]{border:0;}}}"
};
const $07d5bf3f0b10fce1$export$c60086c81c0ffabf = {
    name: "1gk7267",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}}"
};
const $07d5bf3f0b10fce1$export$598dd68f26eb7eff = {
    name: "uvfuhz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :not(style):first-child, > style:first-child + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + span + *{margin-top:0;}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $9be63d8bc680ee45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9be63d8bc680ee45$export$4ea5976125a01ffa = {
    name: "aj1leh",
    styles: ".ProseMirror a.blockLink{display:block;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $9be63d8bc680ee45$export$889b949305b162f9 = {
    name: "1cwtun1",
    styles: ".hyperlink-floating-toolbar{padding:0;}"
};
const $9be63d8bc680ee45$export$e696625219a66da6 = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $7ea00528076df401$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $7ea00528076df401$var$akEditorLineHeight = 1.714;
// copied from packages/editor/editor-common/src/styles/shared/smart-card.ts
const $7ea00528076df401$var$BLOCK_CARD_CONTAINER = 'blockCardView-content-wrap';
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $7ea00528076df401$var$blockNodesVerticalMargin = '0.75rem';
const $7ea00528076df401$export$5f95d55c83a3b7bc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* =============== INDENTATION SPACING ========= */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            boxSizing: 'border-box',
            paddingLeft: `var(--ed--list--item-counter--padding, 24px)`
        },
        // Firefox does not handle empty block element inside li tag.
        // If there is not block element inside li tag,	then firefox sets inherited height to li
        // However, if there is any block element and if it's empty	(or has empty inline element) then
        // firefox sets li tag height to zero.
        //
        // More details at
        // https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            'ul, ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                'li p:empty, li p > span:empty': {
                    display: 'inline-block'
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-ol, .ak-ul': {
            // Ensures list item content adheres to the list's margin instead
            // of filling the entire block row. This is important to allow
            // clicking interactive elements which are floated next to a list.
            //
            // For some history and context on this block, see PRs related to tickets.:
            // @see ED-6551 - original issue.
            // @see ED-7015 - follow up issue.
            // @see ED-7447 - flow-root change.
            //
            // @see https://css-tricks.com/display-flow-root/
            //
            // For older browsers the do not support flow-root. */
            // stylelint-disable declaration-block-no-duplicate-properties */
            display: 'flow-root'
        },
        /* =============== INDENTATION AESTHETICS ========= */ // We support nested lists up to six levels deep.
        /*  ======== LEGACY LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ul ul ul ul': {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul, ul ul ul ul ul': {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul ul, ul ul ul ul ul ul': {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol, ol ol ol ol': {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol, ol ol ol ol ol': {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol ol, ol ol ol ol ol ol': {
            listStyleType: 'lower-roman'
        },
        /* ======== PREDICTABLE LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='1'], ol[data-indent-level='4']": {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='2'], ol[data-indent-level='5']": {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='3'], ol[data-indent-level='6']": {
            listStyleType: 'lower-roman'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='1'], ul[data-indent-level='4']": {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='2'], ul[data-indent-level='5']": {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='3'], ul[data-indent-level='6']": {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        li: {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > p:not(:first-child)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${"var(--ds-space-050, 4px)"} 0 0 0`
            },
            /* In SSR the above rule will apply to all p tags because first-child would be a style tag.
      	The following rule resets the first p tag back to its original margin
      	defined in packages/editor/editor-common/src/styles/shared/paragraph.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > style:first-child + p': {
                marginTop: $7ea00528076df401$var$blockNodesVerticalMargin
            }
        }
    }
});
const $7ea00528076df401$export$b5b1b7a81c86d94e = {
    name: "2ngyxg",
    styles: "li[data-testid=\"show-diff-changed-decoration-node\"]::marker{color:var(--diff-decoration-marker-color);}"
};
const $7ea00528076df401$export$3861aadd8944b16f = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Root lists: 12px top margin (design system value), except first content child. Uses :not(:nth-child(1 of ...)) to exclude first content lists.
        // A more complex selector is used here to ensure this style is not applied to block quotes and panels, as they do not have a margin-top property already, and this will incorrectly add a margin-top to them.
        // This is unlike tables and expands, which do have a margin-top property already, and this style would not change their top margin, even without the :not(:nth-child(1 of ...)) selector.
        // This targeted approach reduces the blast radius of the fix. Instead of modifying numerous existing styles, we add this single selector until the issue with bundle.css & aui-reset.less is fixed.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'ul:not(li > ul):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))), ol:not(li > ol):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)))': {
            marginTop: `var(--ds-space-150, 12px)`
        },
        // Nested lists: 4px top margin (design system value)
        // Applies to both OL and UL nested inside list items
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'li > ol, li > ul': {
            marginTop: `var(--ds-space-050, 4px)`
        }
    }
});
const $7ea00528076df401$export$dba87c9b43c1033d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li::before`]: {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        lineHeight: $7ea00528076df401$var$akEditorLineHeight
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > p:first-child, .ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > .code-block:first-child, .ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > .ProseMirror-gapcursor:first-child + .code-block`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: `-${$7ea00528076df401$var$akEditorLineHeight}em !important`
    }
});
const $7ea00528076df401$export$b9f4317d28be80aa = `max(0px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * (4 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
var $7ea00528076df401$var$_ref = {
    name: "0",
    styles: ""
};
const $7ea00528076df401$export$dc36e8e603594c1d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $7ea00528076df401$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ '.ProseMirror': {
            // Adjacent list items
            'li + li': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $7ea00528076df401$export$b9f4317d28be80aa
            },
            // Nested lists directly under an li (unordered and ordered)
            'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $7ea00528076df401$export$b9f4317d28be80aa
            }
        }
    });
};
const $7ea00528076df401$export$66dd3b7a524cdd20 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Hide markers and remove spacing for wrapper list items (items containing only nested lists)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'li:has(> ul:only-child), li:has(> ol:only-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            listStyleType: 'none !important',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: '0 !important',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginBottom: '0 !important'
        },
        // Remove margin from nested lists inside wrapper list items to avoid double spacing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: '0 !important'
        },
        // Remove top margin from nested taskLists not preceded by a sibling taskItem.
        // The base rule (tasksAndDecisionsStyles) sets margin-top on all nested taskLists,
        // but with flexible indentation a taskList can be the first child with no taskItem above.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-task-list-local-id] > div[data-task-list-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: '0 !important'
        },
        // Restore margin when a nested taskList follows a taskItem
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-task-local-id] + div[data-task-list-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: `${"var(--ds-space-050, 4px)"} !important`
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $fhm10 = parcelRequire("fhm10");


var $gAARK = parcelRequire("gAARK");


var $ag6aQ = parcelRequire("ag6aQ");







var $jTudT = parcelRequire("jTudT");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $fDGbV = parcelRequire("fDGbV");


var $ieXGd = parcelRequire("ieXGd");

var $b38UX = parcelRequire("b38UX");

/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $4bc6aca00a4d4c4d$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${selected ? (0, $ieXGd.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      border-radius: ${"var(--ds-radius-small, 3px)"};
      ${selected ? (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $4bc6aca00a4d4c4d$export$70bc5d30fe886af = 'media-card-inline-player';
const $4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $9K4OG.css)("width:", (0, $fDGbV.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $fDGbV.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:var(--ds-radius-small, 3px);position:relative;max-width:100%;max-height:100%;", $4bc6aca00a4d4c4d$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';


var $8jrlU = parcelRequire("8jrlU");


function $8b8a9e34027bcb70$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint = 410;
/**
 * Reference Heights
 *
 * These heights enforce consistent sizes with media inline nodes due to
 * inconsistencies with center aligned inline nodes and text.
 *
 * There is conversation about refactoring media inline nodes to conform to
 * aligning correctly with the surrounding text.
 *
 * These constants originally came from `headingSizes` from the `theme` package
 * and have been copied here to remove this package.
 */ const $8b8a9e34027bcb70$var$referenceHeights = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
const $8b8a9e34027bcb70$var$inlineImageSelector = `> .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}`;
const $8b8a9e34027bcb70$export$abd2efc27ac7e809 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`li .${0, $gnMzP.richMediaClassName}`]: {
            margin: 0
        },
        // Hack for chrome to fix media single position inside a list when media is the first child
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex),
            maxWidth: '100%',
            /* overwrite default Prosemirror setting making it clear: both */ clear: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`table .${0, $gnMzP.richMediaClassName}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left`]: {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-right, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media all and (max-width: ${$8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& [layout='full-width'] .${0, $gnMzP.richMediaClassName}, & [layout='wide'] .${0, $gnMzP.richMediaClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".media-extended-resize-experience[layout^='wrap-']": {
            // override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
            // to prevent scroll bar
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            overflow: 'visible !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [layout^='wrap-'] + [layout^='wrap-']": {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& + p, & + div[class^='fabric-editor-align'], & + ul, & + ol, & + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles,@atlaskit/ui-styling-standard/no-unsafe-values
                clear: 'both !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${0, $gnMzP.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        // Shifting the mediaInline image component (renders image) to align nicely with
        // mediaInline (renders text) is a bit of a testing ground. This numbers represent
        // shift in top and bottom and size adjustments to make up for lack of 1to1 size
        //  mapping
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: $8b8a9e34027bcb70$var$referenceHeights['p'],
            transform: 'translateY(-2px)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h1,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h2,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h3,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h4: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h4,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h5: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h5,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h6: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h6,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right'] + .mediaSingleView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        },
        // Larger margins for resize handlers when at depth 0 of the document
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .mediaSingleView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-left': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $ag6aQ.ClassNames).FLOATING_TOOLBAR_COMPONENT}`]: {
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right, .richMedia-resize-handle-left': {
        display: 'flex',
        flexDirection: 'column',
        /* vertical align */ justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right': {
        alignItems: 'flex-end',
        paddingRight: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-left': {
        alignItems: 'flex-start',
        paddingLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
        content: "' '",
        display: 'flex',
        width: 3,
        height: 64,
        borderRadius: "var(--ds-radius-medium, 6px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-right::after`]: {
        background: "var(--ds-border, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after, .${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-right:hover::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-left:hover::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after`]: {
        background: "var(--ds-border-focused, #4688EC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.__resizable_base__': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        left: 'unset !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: 'auto !important'
    },
    // Danger when top level node for smart cards / inline links
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger > div > div > .media-card-frame, .danger > span > a': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: `0px 0px 0px ${(0, $aFUXX.akEditorSelectedBorderBoldSize)}px, ${"var(--ds-border-danger, #E2483D)"}`,
        transition: 'background-color 0s, box-shadow 0s'
    },
    // Danger when nested node or common
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // Media single video player
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $4bc6aca00a4d4c4d$export$70bc5d30fe886af}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // New file experience
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
        },
        // Media resize legacy handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Media resize new handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Smart cards
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame, .inlineCardView-content-wrap > span > a': {
            backgroundColor: `${"var(--ds-blanket-danger, #EF5C4814)"}`,
            transition: `background-color 0s`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame::after': {
            boxShadow: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.warning': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E06C00)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $4bc6aca00a4d4c4d$export$70bc5d30fe886af}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E06C00)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-warning, #E06C00)"} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-warning, #E06C00)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.media-filmstrip-list-item': {
        cursor: 'pointer'
    },
    // When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.mediaGroupView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName} #newFileExperienceWrapper`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: (0, $aFUXX.akEditorSelectedBoxShadow)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-no-interaction #newFileExperienceWrapper': {
        boxShadow: 'none'
    }
});
const $8b8a9e34027bcb70$export$c47a18e5da2466ef = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.mediaInlineView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [` .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            '>span> span[role="button"]': [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.mediaGroupView-content-wrap.danger #newFileExperienceWrapper`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        [
            (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
        ]
    }
});
const $8b8a9e34027bcb70$export$cbc2f5b7ba4a5b45 = {
    name: "efqvbk",
    styles: ".mediaGroupView-content-wrap ul{padding:0;}"
};
const $8b8a9e34027bcb70$export$228abfa0106fa708 = {
    name: "1u86ffv",
    styles: ".fabric-editor-block-mark[class^=\"fabric-editor-align\"]{clear:none;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block, .extension-container, .multiBodiedExtension--container{max-width:100%;}}}"
};
const $8b8a9e34027bcb70$export$1cac2710e369d647 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.mediaSingleView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`span#${0, $gAARK.CAPTION_PLACEHOLDER_ID}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'var(--ak-editor-base-font-size)'
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $1d1e174580119dab$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};






function $d6f1b5d8b6185b26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* need to specify dark text colour because personal mentions
(in dark blue) have white text by default */ const $d6f1b5d8b6185b26$var$mentionsSelectedColor = {
    name: "5703k4",
    styles: "color:var(--ds-text-subtle, #505258)"
};
const $d6f1b5d8b6185b26$export$1445f2e2b3a1d9c8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER}`]: {
        // TODO: ED-28075 - refactor selection styles to unblock Compiled CSS migration
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $aFUXX.akEditorSelectedNodeClassName} [data-mention-id] > span`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER}.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span > span > span': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER} > span > span > span`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            color: "var(--ds-text-subtle, #505258)"
        }
    }
});
const $d6f1b5d8b6185b26$export$5fb9b21e3678e9ac = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: "var(--ds-radius-full, 9999px)",
        cursor: 'pointer',
        padding: '1px 0.3em 1px 0.23em',
        // To match `packages/elements/mention/src/components/Mention/PrimitiveMention.tsx` implementation
        // we match the line height exactly
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.714',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #0515240F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #505258)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #080F214A)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #7D818A)"}`,
        color: "var(--ds-text, #292A2E)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #1868DB)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #1558BC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #144794)"
        }
    }
});
const $d6f1b5d8b6185b26$export$8697a9554aac2a5a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    }
});
const $d6f1b5d8b6185b26$export$13ab2f17ccaf48f6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.search-match-block)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ]
    }
});
const $d6f1b5d8b6185b26$export$1091a37fb36d77e5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.search-match-block).danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            (0, $65bb5c5a687b3665$export$57f48b634c3a2512),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28)
        ]
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $9add2684ad964103$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9add2684ad964103$export$8290cf129669d0cb = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            cursor: 'pointer',
            /* Danger when top level node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                }
            },
            // panelSharedStyles()
            // panelSharedStylesWithoutPrefix()
            borderRadius: "var(--ds-radius-small, 3px)",
            margin: `0.75rem 0 0`,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            minWidth: '48px',
            display: 'flex',
            position: 'relative',
            alignItems: 'normal',
            wordBreak: 'break-word',
            // mainDynamicStyles(PanelType.INFO)
            // > getPanelTypeBackground(PanelType.INFO)
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
            color: 'inherit',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                flexShrink: 0,
                height: "var(--ds-space-300, 24px)",
                width: "var(--ds-space-300, 24px)",
                boxSizing: 'content-box',
                paddingRight: "var(--ds-space-100, 8px)",
                textAlign: 'center',
                userSelect: 'none',
                MozUserSelect: 'none',
                WebkitUserSelect: 'none',
                msUserSelect: 'none',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginTop: '0.1em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> span': {
                    verticalAlign: 'middle',
                    display: 'inline-flex'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-sprite': {
                    verticalAlign: '-2px' // -(8*3-20)/2 [px]
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-image': {
                    verticalAlign: '-3px',
                    // panelEmojiSpriteVerticalAlignment - 1 [px]
                    /* Vertical align only works for inline-block elements in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '@-moz-document url-prefix()': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        img: {
                            display: 'inline-block'
                        }
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content': {
                margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
                flex: '1 0 0',
                /*
        	https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
        	The default value for min-width is auto, which is computed to zero.
        	When an element is a flex item, the value of min-width doesn’t compute to zero.
        	The minimum size of a flex item is equal to the size of its contents.
        */ minWidth: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                // mainDynamicStyles(PanelType.NOTE)
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="tip"]': {
                // mainDynamicStyles(PanelType.TIP)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                // mainDynamicStyles(PanelType.WARNING)
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                // mainDynamicStyles(PanelType.ERROR)
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                // mainDynamicStyles(PanelType.SUCCESS)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            cursor: 'text'
        },
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-panel.ak-editor-selected-node:not(.danger)': {
        // getSelectionStyles([SelectionStyle.BoxShadow, SelectionStyle.Blanket]),
        // SelectionStyle.BoxShadow
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
        borderColor: 'transparent',
        // SelectionStyle.Blanket
        position: 'relative',
        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        WebkitUserSelect: 'text',
        '&::before': {
            position: 'absolute',
            content: '""',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            pointerEvents: 'none',
            zIndex: 12,
            // akEditorSmallZIndex
            backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
        },
        // hideNativeSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $9add2684ad964103$export$fb05379f8218158 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            // Support nested panel
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content .ak-editor-panel': {
                border: `1px solid ${"var(--ds-border, #0B120E24)"}`
            }
        }
    }
});
const $9add2684ad964103$export$1bea98aa89006044 = {
    name: "icrrk4",
    styles: ".ProseMirror{.ak-editor-panel{&.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}}.ak-editor-content-area.appearance-full-page .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-150, 12px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-left:var(--ds-space-250, 20px);padding-right:var(--ds-space-250, 20px);}}.ak-editor-content-area .ak-editor-content-area .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-100, 8px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}"
};
const $9add2684ad964103$export$59d3d90d4141195 = {
    name: "1rtu9jn",
    styles: ".ProseMirror{.ak-editor-panel{&[data-panel-type=\"info\"]{.ak-editor-panel__icon[data-panel-type=\"info\"]{color:var(--ds-icon-information, #357DE8);}}&[data-panel-type=\"note\"]{.ak-editor-panel__icon[data-panel-type=\"note\"]{color:var(--ds-icon-discovery, #AF59E1);}}&[data-panel-type=\"tip\"]{.ak-editor-panel__icon[data-panel-type=\"tip\"]{color:var(--ds-icon-success, #6A9A23);}}&[data-panel-type=\"warning\"]{.ak-editor-panel__icon[data-panel-type=\"warning\"]{color:var(--ds-icon-warning, #E06C00);}}&[data-panel-type=\"error\"]{.ak-editor-panel__icon[data-panel-type=\"error\"]{color:var(--ds-icon-danger, #C9372C);}}&[data-panel-type=\"success\"]{.ak-editor-panel__icon[data-panel-type=\"success\"]{color:var(--ds-icon-success, #6A9A23);}}}}"
};
const $9add2684ad964103$export$21dc022a1db4e807 = {
    name: "5hfp5c",
    styles: ".panelView-content-wrap{box-sizing:border-box;}"
};
const $9add2684ad964103$export$9addcfe7a096a01d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="info"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="info"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="note"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="success"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="warning"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="error"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $b0ef43f6c63956f4$var$blockNodesVerticalMargin = '0.75rem';
const $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin = '0.75em';
const $b0ef43f6c63956f4$export$63635a8b56f58eca = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$3de2f7ce686aadc2 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $b0ef43f6c63956f4$export$29f6e72d2a83d55a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$a251c8dae8d8433a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$855ac5a16d662324 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $56a35bdc54338480$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $56a35bdc54338480$var$placeholderFadeInKeyframes = (0, $9K4OG.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $56a35bdc54338480$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #6B6E76)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #6B6E76)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder.ak-editor-selected-node': {
        // ...backgroundSelectionStyles
        backgroundColor: "var(--ds-background-selected, #E9F2FE)",
        // ...backgroundSelectionStyles -> hideNativeBrowserTextSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection,*::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection,*::-moz-selection': {
            backgroundColor: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text[data-placeholder]::after': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        cursor: 'text',
        content: 'attr(data-placeholder)',
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor::after': {
            content: '""',
            display: 'inline',
            top: 0,
            position: 'absolute',
            borderRight: `1px solid ${"var(--ds-border, #0B120E24)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-selection': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative',
            // Follow the system highlight colour to match native text selection
            backgroundColor: 'Highlight',
            // We should also match the text colour to the system highlight text colour.
            // That way if the system highlight background is dark, the text will still be readable.
            color: 'HighlightText'
        }
    }
});
const $56a35bdc54338480$export$d3bdc0d52bb6c2c8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .placeholder-decoration': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        width: '100%',
        pointerEvents: 'none',
        userSelect: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.placeholder-android': {
            pointerEvents: 'none',
            outline: 'none',
            userSelect: 'none',
            position: 'absolute'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .placeholder-decoration-fade-in': {
        animation: `${$56a35bdc54338480$var$placeholderFadeInKeyframes} 300ms ease-out forwards`
    }
});
const $56a35bdc54338480$export$ec7b3b2c50356d2e = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $56a35bdc54338480$export$959bd343ec1d44de = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $8ca5e17fea10ef42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ca5e17fea10ef42$export$a06160db3520e5a2 = 'resizer-item';
const $8ca5e17fea10ef42$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $8ca5e17fea10ef42$export$10b67c6ff1748bd = 'resizer-is-extended';
const $8ca5e17fea10ef42$export$6afc20f0ff6d041 = 'resizer-handle';
const $8ca5e17fea10ef42$export$a5792d7e2a486d41 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-track`;
const $8ca5e17fea10ef42$export$2201bc1aaee73f36 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-thumb`;
const $8ca5e17fea10ef42$export$97a99610b6f0a178 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-danger`;
const $8ca5e17fea10ef42$export$b5fa87f62ced4967 = 3;
const $8ca5e17fea10ef42$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $8ca5e17fea10ef42$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$a06160db3520e5a2}`]: {
        willChange: 'width',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:hover, &.display-handle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& > .${$8ca5e17fea10ef42$export$b123b2c8a2536d05} > .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
                visibility: 'visible',
                opacity: 1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.is-resizing': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #4688EC)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8ca5e17fea10ef42$export$97a99610b6f0a178}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                transition: 'none',
                background: "var(--ds-icon-danger, #C9372C)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
        display: 'flex',
        visibility: 'hidden',
        opacity: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 7,
        transition: 'visibility 0.2s, opacity 0.2s',
        // NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
        // into the tooltip
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& div[role='presentation']": {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: "var(--ds-space-negative-200, -16px)",
            whiteSpace: 'normal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.left': {
            alignItems: 'flex-start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.right': {
            alignItems: 'flex-end'
        },
        // Handle Sizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.small': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 43
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.medium': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 64
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.large': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 96
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.clamped': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 'clamp(43px, calc(100% - 32px), 96px)'
            }
        },
        // Handle Alignment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.sticky': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                position: 'sticky',
                top: "var(--ds-space-150, 12px)",
                bottom: "var(--ds-space-150, 12px)"
            }
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #4688EC)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$a5792d7e2a486d41}`]: {
                visibility: 'visible',
                opacity: 0.5
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        content: "' '",
        display: 'flex',
        width: 3,
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        height: 64,
        transition: 'background-color 0.2s',
        borderRadius: "var(--ds-radius-medium, 6px)",
        border: 0,
        padding: 0,
        zIndex: 2,
        outline: 'none',
        minHeight: 24,
        background: "var(--ds-border, #0B120E24)",
        '&:hover': {
            cursor: 'col-resize'
        },
        '&:focus': {
            background: "var(--ds-border-selected, #1868DB)",
            '&::after': {
                content: "''",
                position: 'absolute',
                top: "var(--ds-space-negative-050, -4px)",
                right: "var(--ds-space-negative-050, -4px)",
                bottom: "var(--ds-space-negative-050, -4px)",
                left: "var(--ds-space-negative-050, -4px)",
                border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
                borderRadius: 'inherit',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$a5792d7e2a486d41}`]: {
        visibility: 'hidden',
        position: 'absolute',
        width: 7,
        height: 'calc(100% - 40px)',
        borderRadius: "var(--ds-radius-small, 4px)",
        opacity: 0,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.none': {
            background: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.shadow': {
            background: "var(--ds-background-selected, #E9F2FE)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.full-height': {
            background: "var(--ds-background-selected, #E9F2FE)",
            height: '100%',
            minHeight: 36
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ak-editor-no-interaction .ak-editor-selected-node .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}:not(:hover) .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        background: "var(--ds-border, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$c42cdcfd48254bda}`]: {
        position: 'relative',
        display: 'flow-root',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8ca5e17fea10ef42$export$10b67c6ff1748bd}`]: {
            padding: `0 ${"var(--ds-space-150, 12px)"}`,
            left: "var(--ds-space-negative-150, -12px)"
        }
    },
    // This below style is here to make sure the image width is correct when nested in a table
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`table .${$8ca5e17fea10ef42$export$c42cdcfd48254bda}, table .${$8ca5e17fea10ef42$export$c42cdcfd48254bda}.${$8ca5e17fea10ef42$export$10b67c6ff1748bd}`]: {
        padding: 'unset',
        left: 'unset'
    }
});
const $8ca5e17fea10ef42$export$21b363e15a3a4b0b = {
    name: "1rqtth7",
    styles: ".pm-breakout-resize-handle-rail-wrapper{display:flex;align-items:center;justify-content:center;height:100%;cursor:col-resize;border-radius:var(--ds-radius-small, 4px);z-index:2;[role=\"presentation\"]{height:100%;width:100%;}.pm-breakout-resize-handle-rail-inside-tooltip{height:100%;}}"
};
const $8ca5e17fea10ef42$export$241444dc11ae22d6 = {
    name: "zqeg2w",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"layoutSection\"].first-node-in-document){> .pm-breakout-resize-handle-container{height:calc(100% - 8px);}}}"
};
const $8ca5e17fea10ef42$export$10ee78d9e73a5e96 = {
    name: "1itvsdi",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"codeBlock\"]){> .pm-breakout-resize-handle-container--left{left:-5px;}> .pm-breakout-resize-handle-container--right{right:-5px;}> .pm-breakout-resize-handle-container{height:calc(100% - 12px);}}&:has(.first-node-in-document){> .pm-breakout-resize-handle-container{height:100%;}}}"
};
const $8ca5e17fea10ef42$export$d199c4fcac4ebc3a = {
    name: "38i0y8",
    styles: ".fabric-editor-breakout-mark{&:has(> .fabric-editor-breakout-mark-dom > [data-prosemirror-node-name=\"codeBlock\"]){> .pm-breakout-resize-handle-container--left{left:-5px;}> .pm-breakout-resize-handle-container--right{right:-5px;}> .pm-breakout-resize-handle-container{height:calc(100% - 12px);}}&:has(.first-node-in-document.first-node-in-document){> .pm-breakout-resize-handle-container{height:100%;}}}"
};
const $8ca5e17fea10ef42$export$62cd5dfd9881f590 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-25px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-25px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // Rail and thumb styles intentionally mirror the layout column divider
    // (see layoutColumnDividerRailClassName and layoutColumnDividerThumbClassName in layout.ts).
    // If updating these styles, consider keeping both in sync.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #4688EC)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FE)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $8ca5e17fea10ef42$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #0B120E24)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $8ca5e17fea10ef42$export$f4810475f3f405bd = {
    name: "riwidy",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"syncBlock\"]), &:has([data-prosemirror-node-name=\"bodiedSyncBlock\"]){> .pm-breakout-resize-handle-container--left{left:-24px;}> .pm-breakout-resize-handle-container--right{right:-24px;}> .pm-breakout-resize-handle-container{height:calc(100% - 12px);}}}"
};
const $8ca5e17fea10ef42$export$2785010673d864e4 = /*#__PURE__*/ (0, $9K4OG.css)({
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-editor-breakout-mark': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                [`.${$8ca5e17fea10ef42$export$a06160db3520e5a2}`]: {
                    willChange: 'width',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '&:hover, &.display-handle': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                        [`& > .${$8ca5e17fea10ef42$export$b123b2c8a2536d05} > .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
                            visibility: 'hidden',
                            opacity: 0
                        }
                    }
                }
            }
        }
    }
});


/* eslint-disable @atlaskit/design-system/use-tokens-shape -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





const $0e823357fa8df654$export$2413e968422424ec = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        height: '2px',
        borderRadius: '1px',
        // this should use token('radius.full') but cannot since the element has padding which increases its height beyond 2px
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        margin: `${"var(--ds-space-300, 24px)"} 0`,
        backgroundClip: 'content-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        outline: 'none',
        backgroundColor: "var(--ds-border-selected, #1868DB)"
    }
});
const $0e823357fa8df654$export$e425548b5cacd57 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
        backgroundColor: "var(--ds-border-danger, #E2483D)"
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $887f0254bcb2b3a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $887f0254bcb2b3a0$export$b2380b18b089518f = {
    name: "18ng4c4",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #292A2E);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #3B3D42);}"
};



/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ 


const $14a90d57d6df814c$var$fadeIn = (0, $9K4OG.keyframes)({
    from: {
        opacity: 0,
        transform: 'translateY(16px)'
    },
    to: {
        opacity: 1,
        transform: 'translateY(0)'
    }
});
const $14a90d57d6df814c$export$1629cb32bbba3a7e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[aria-label='Selection toolbar']": {
        animationName: $14a90d57d6df814c$var$fadeIn,
        animationDuration: `0.2s`,
        animationTimingFunction: `cubic-bezier(0.6, 0, 0, 1)`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $f08f86940ab6d6a2$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
const $f08f86940ab6d6a2$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $f08f86940ab6d6a2$export$9750a92ac0203c10 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::before, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: 2,
            width: 8,
            content: "''",
            height: 'calc(100%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before`]: {
            background: `linear-gradient(to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px)`,
            top: 0,
            left: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px)`,
            right: 0,
            top: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$1cbe0bb16052178d.SENTINEL_LEFT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$1cbe0bb16052178d.SENTINEL_RIGHT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 






const $535dd5d33c38cc84$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $535dd5d33c38cc84$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $535dd5d33c38cc84$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $535dd5d33c38cc84$export$f64b12e3fb171ebc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0
        }
    }
});
const $535dd5d33c38cc84$export$1fef993256efc96e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&[data-testid="show-diff-changed-decoration-node"] .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 var(--diff-decoration-marker-ring-width, 1px) var(--diff-decoration-marker-color)`,
            borderColor: 'transparent'
        }
    }
});
const $535dd5d33c38cc84$export$4d8f0e547724198 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER}`]: {
            opacity: 0.6
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.6
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.6
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node': {
        textDecoration: 'line-through'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="embedCard"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    }
});
const $535dd5d33c38cc84$export$5e70718283e43349 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER}`]: {
            opacity: 0.8
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.8
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 var(--diff-decoration-marker-ring-width, 1px) ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.8
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node': {
        textDecoration: 'line-through'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="embedCard"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    }
});
const $535dd5d33c38cc84$export$b346a5d6d598424c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            marginBottom: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$56d86af0724ad29e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            marginBottom: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$42b66ad40efe5bbe = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            marginBottom: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block):not(.danger) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$fefb174a4d9f4c0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
            marginTop: "var(--ds-space-150, 12px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ]
    }
});
const $535dd5d33c38cc84$export$cb0683bb9c4e1322 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    }
});
const $535dd5d33c38cc84$export$1a87a16059da4299 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}:not(.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER})`]: {
        // EDM-11991: Fix list plugin adding padding to ADS AvatarGroup
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $8daea92ba3be6a6e$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-table-cell-content-wrap, .pm-table-header-content-wrap, [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap': {
            maxWidth: '100%',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > span': {
                width: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > span': {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0 // Prevent responsive layouts increasing height of container.
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.status-lozenge-span > span': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: 'rgba(255, 189, 173, 0.5)' // akEditorDeleteBackgroundWithOpacity
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.status-lozenge-span > span': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 653)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $8daea92ba3be6a6e$export$7c209f30e9068068 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $8daea92ba3be6a6e$export$8b4cca12f7a094c7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $8daea92ba3be6a6e$export$bd58d1bcb934912c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node.danger .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $8daea92ba3be6a6e$export$dc185896d75d4b4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #505258)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #803FA5)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #1558BC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #9E4C00)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #EFFFD6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #4C6B1F)"
    }
});
const $8daea92ba3be6a6e$export$60b421c3da7a2a99 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #505258)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #803FA5)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #1558BC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #9E4C00)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #EFFFD6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #4C6B1F)"
    }
});
const $8daea92ba3be6a6e$export$5bacb3eba124de20 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        paddingBlockStart: "var(--ds-space-025, 2px)",
        paddingBlockEnd: "var(--ds-space-025, 2px)",
        paddingInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        height: '1.25rem',
        border: `solid ${"var(--ds-border-width, 1px)"} transparent`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    },
    /* Border, background and text colors
   * These colors are copied from @atlaskit/lozenge
   * DST is currently using oklch with different light and dark lightness factors
   * and suggest using hex colors until the design tokens are added
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#CACBCF'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#63666B'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text, #292A2E)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery-subtler, #EED7FC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#D8A0F7'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#803FA5'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery-bolder, #48245D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information-subtler, #CFE1FD)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#8FB8F6'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#1558BC'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information-bolder, #123263)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger-subtler, #FFD5D2)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#FD9891'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#AE2E24'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger-bolder, #5D1F1A)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning-subtler, #FCE4A6)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#FBC828'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#9E4C00'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning-bolder, #693200)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success-subtler, #D3F1A7)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#B3DF72'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#4C6B1F'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success-bolder, #37471F)"
    },
    /* Find and Replace Styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.statusView-content-wrap:not(.search-match-block).ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $e6n00 = parcelRequire("e6n00");

const $7a476f61d60131cb$export$9ce40bb672aef33b = /*#__PURE__*/ (0, $9K4OG.css)({
    '@property --angle': {
        syntax: '"<angle>"',
        initialValue: '0deg',
        inherits: 'false'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            position: 'relative',
            cursor: 'pointer',
            borderRadius: "var(--ds-radius-small, 3px)",
            marginBottom: 0,
            marginTop: "var(--ds-space-075, 6px)",
            paddingBlock: "var(--ds-space-150, 12px)",
            color: 'inherit',
            /* Hover state */ '&:hover': {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`,
                transition: 'box-shadow 200ms ease-in',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible',
                    transition: 'opacity 200ms ease-in, visibility 200ms ease-in'
                }
            },
            /* Selection state when cursor inside sync block */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).selectionInside}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible'
                }
            },
            /* Node selection state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.ak-editor-selected-node': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #4688EC)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible',
                    backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                    top: '-14px',
                    paddingBottom: "var(--ds-space-050, 4px)",
                    paddingTop: "var(--ds-space-050, 4px)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '> span': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                        color: `${"var(--ds-text-selected, #1868DB)"} !important`
                    }
                }
            },
            /* Danger state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    top: '-14px',
                    paddingBottom: "var(--ds-space-050, 4px)",
                    paddingTop: "var(--ds-space-050, 4px)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '> span': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                        color: `${"var(--ds-text-danger, #AE2E24)"} !important`
                    }
                }
            },
            /* Node disabled state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).disabledClassName}`]: {
                backgroundColor: "var(--ds-background-disabled, #17171708)",
                boxShadow: `0 0 0 1px ${"var(--ds-border-disabled, #0515240F)"}`,
                userSelect: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,  @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    backgroundColor: "var(--ds-surface, #FFFFFF)",
                    '&::before': {
                        border: 'none'
                    }
                }
            },
            /* Creation loading state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).creationLoadingClassName}`]: {
                animation: `${(0, $9K4OG.keyframes)({
                    from: {
                        '--angle': '0deg'
                    },
                    to: {
                        '--angle': '360deg'
                    }
                })} 2s linear infinite`,
                border: '1px solid transparent',
                background: `linear-gradient(${"var(--ds-surface, #FFFFFF)"}, ${"var(--ds-surface, #FFFFFF)"}) padding-box, conic-gradient(from var(--angle), #1868DB, ${"var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)"}, #3279E0, #1868DB) border-box`,
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'none',
                transition: 'boxShadow 200ms ease-in',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,  @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    display: 'none'
                }
            },
            /* Error state */ /* In error state sync block should have disabled background colour */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`:has(.${(0, $e6n00.SyncBlockSharedCssClassName).error})`]: {
                backgroundColor: "var(--ds-background-disabled, #17171708)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`:has(.${(0, $e6n00.SyncBlockSharedCssClassName).loading})`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            /* Live doc view mode state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).viewModeClassName}`]: {
                boxShadow: 'none',
                backgroundColor: 'unset',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            /* Dragging state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).draggingClassName}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`]: {
                paddingTop: 0,
                paddingBottom: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingLeft: '19px',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingRight: '18px',
                cursor: 'text'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
                paddingTop: 0,
                paddingBottom: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingLeft: '19px',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingRight: '18px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`]: {
            // First child node that has drag handle widget next to it is overridden with marginTop: 0, see globalStyles in editor-plugin-block-controls/src/ui/global-styles.tsx
            // Hence we set marginTop: 0 when by default to avoid flickering when hovering on and off the first node
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
            // First child node in bodiedSyncBlock is overridden with marginTop: 0, hence apply the same style to syncBlock for consistency
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-renderer-document > :first-child': {
                marginTop: 0
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        position: 'absolute',
        gap: "var(--ds-space-050, 4px)",
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        opacity: 0,
        visibility: 'hidden',
        boxShadow: 'none',
        zIndex: 1,
        paddingLeft: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-100, 8px)",
        top: '-10px',
        right: "var(--ds-space-150, 12px)",
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        maxWidth: '140px'
    }
});
const $7a476f61d60131cb$export$2ef961ae194ff4dc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            marginRight: `-19px`,
            marginLeft: `-19px`
        }
    }
});
const $7a476f61d60131cb$export$bb6880bfac80a2d6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`]: {
            // Contain floated elements (wrap-left/wrap-right) within synced block borders
            // Use display: flow-root to create a block formatting context without clipping other content e.g. telepointers
            display: 'flow-root'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
            // Contain floated elements (wrap-left/wrap-right) within synced block borders
            // Use display: flow-root to create a block formatting context without clipping other content e.g. telepointers
            display: 'flow-root'
        }
    }
});
const $7a476f61d60131cb$export$15f9ecbc224279eb = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror > .fabric-editor-breakout-mark:first-child`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            marginTop: 0
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



function $e5ba48b9f959e381$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e5ba48b9f959e381$export$696afa9d8a2fe544 = {
    name: "p382o5",
    styles: ".pm-table-header-content-wrap :not(.fabric-editor-alignment), .pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark, .pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}"
};
const $e5ba48b9f959e381$export$b216471059d2ae73 = {
    name: "1hbwduk",
    styles: ".pm-table-header-content-wrap :not(.fabric-editor-alignment, .fabric-editor-font-size), .pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark, .pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}"
};
const $e5ba48b9f959e381$export$5dc8ab529dc33316 = {
    name: "mlsake",
    styles: "margin-left:0;margin-right:0"
};
const $e5ba48b9f959e381$export$61a2da566f69d1df = /*#__PURE__*/ (0, $9K4OG.css)({
    // TODO: ED-28075 - refactor array include to unblock Compiled CSS migration
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .pm-table-wrapper > table`]: [
        $e5ba48b9f959e381$export$5dc8ab529dc33316,
        (0, $887f0254bcb2b3a0$export$b2380b18b089518f)
    ]
});
const $e5ba48b9f959e381$export$d4422e89f15370f2 = {
    name: "1c5wbsb",
    styles: ".ProseMirror .pm-table-wrapper{max-width:100%;overflow-x:auto;width:100%;box-sizing:border-box;}.ProseMirror .pm-table-wrapper.pm-table-wrapper-no-overflow{overflow-x:visible;}.ProseMirror .pm-table-wrapper table{max-width:100%;width:100%;table-layout:fixed;min-width:auto;}"
};
const $e5ba48b9f959e381$export$97207509673d0dfa = {
    name: "1091p55",
    styles: ".ProseMirror .pm-table-wrapper{.pm-table-cell-content-wrap, .pm-table-header-content-wrap{p:empty{min-height:1.714em;}}}"
};
const $e5ba48b9f959e381$export$f19584fc2286b857 = {
    name: "1u49qsn",
    styles: ".pm-table-resizer-container:has(table[data-initial-width-mode=\"content\"]){width:max-content !important;--ak-editor-table-width:max-content;}.resizer-item:has(table[data-initial-width-mode=\"content\"]){width:max-content !important;}.resizer-item:has(table[data-initial-width-mode=\"content\"]) > .resizer-hover-zone.resizer-is-extended{padding:unset;left:unset;}.ProseMirror .pm-table-wrapper table[data-initial-width-mode=\"content\"]{table-layout:auto;width:max-content !important;}.ProseMirror .pm-table-wrapper table[data-initial-width-mode=\"content\"] > colgroup > col{width:unset !important;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 







function $b92d63900d735dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b92d63900d735dfd$var$akEditorLineHeight = 1.714;
const $b92d63900d735dfd$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $b92d63900d735dfd$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $b92d63900d735dfd$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.taskItemView-content-wrap, .${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: 48
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "span[contenteditable='false']": {
                height: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: $b92d63900d735dfd$var$akEditorLineHeight
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false']": {
            height: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false'] + div": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    // When action list is inside panel
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $b92d63900d735dfd$var$TASKLIST_CONTAINER_MARGIN_DENSE = `max(0px, calc(10px + (var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * (2 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $b92d63900d735dfd$var$_ref = {
    name: "0",
    styles: ""
};
const $b92d63900d735dfd$export$715995201f735e2d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $b92d63900d735dfd$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '.ProseMirror': {
            // Task lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER]: {
                // Task lists: container top margin
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $b92d63900d735dfd$var$TASKLIST_CONTAINER_MARGIN_DENSE
            },
            // Task lists: sibling items and nested lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} > * + *`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $7ea00528076df401$export$b9f4317d28be80aa)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} ${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER}, .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER} .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $7ea00528076df401$export$b9f4317d28be80aa)
            }
        }
    });
};
const $b92d63900d735dfd$export$c2f467e1dc47f4f1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName} > [data-decision-wrapper], ol[data-node-type='decisionList'].${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [
        {
            borderRadius: "var(--ds-radius-small, 4px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
    ],
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
            '&::after': {
                content: 'none' // reset the Blanket selection style
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #505258)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #6A9A23)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $b92d63900d735dfd$export$27a4e7e55add38c4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}.danger > [data-decision-wrapper], ol[data-node-type='decisionList'].${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}.danger`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28),
        (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
    ]
});
const $b92d63900d735dfd$export$e237513ae3de60b5 = {
    name: "b3ew8y",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $b92d63900d735dfd$export$921eec0bd8c26b90 = {
    name: "s6v8rd",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $b92d63900d735dfd$export$2a9fa9bb25fe40d2 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $b92d63900d735dfd$export$7356f32af3715d83 = /*#__PURE__*/ (0, $9K4OG.css)({
    /**
   * Background
   */ '--local-background': "var(--ds-background-input, #FFFFFF)",
    '--local-background-active': "var(--ds-background-input-pressed, #FFFFFF)",
    '--local-background-checked': "var(--ds-background-selected-bold, #1868DB)",
    '--local-background-checked-hover': "var(--ds-background-selected-bold-hovered, #1558BC)",
    '--local-background-disabled': "var(--ds-background-disabled, #17171708)",
    '--local-background-hover': "var(--ds-background-input-hovered, #F8F8F8)",
    /**
   * Border
   */ '--local-border': "var(--ds-border-input, #8C8F97)",
    '--local-border-active': "var(--ds-border, #0B120E24)",
    '--local-border-checked': "var(--ds-background-selected-bold, #1868DB)",
    '--local-border-checked-hover': "var(--ds-background-selected-bold-hovered, #1558BC)",
    '--local-border-checked-invalid': "var(--ds-border-danger, #E2483D)",
    '--local-border-disabled': "var(--ds-background-disabled, #17171708)",
    '--local-border-focus': "var(--ds-border-focused, #4688EC)",
    '--local-border-hover': "var(--ds-border-input, #8C8F97)",
    '--local-border-invalid': "var(--ds-border-danger, #E2483D)",
    /**
   * Tick
   */ '--local-tick-active': "var(--ds-icon-inverse, #FFFFFF)",
    '--local-tick-checked': "var(--ds-icon-inverse, #FFFFFF)",
    '--local-tick-disabled': "var(--ds-icon-disabled, #080F214A)",
    '--local-tick-rest': 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name="taskItem"] .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}, [data-prosemirror-node-name="blockTaskItem"] .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            opacity: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& + svg': {
                '--checkbox-background-color': 'var(--local-background)',
                '--checkbox-border-color': 'var(--local-border)',
                '--checkbox-tick-color': 'var(--local-tick-rest)',
                color: 'var(--checkbox-background-color)',
                fill: 'var(--checkbox-tick-color)',
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                boxSizing: 'border-box',
                display: 'inline',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                'rect:first-of-type': {
                    stroke: 'var(--checkbox-border-color)',
                    strokeWidth: "var(--ds-border-width, 1px)",
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:focus + svg, &:checked:focus + svg': {
                borderRadius: "var(--ds-radius-small, 0.25rem)",
                outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + svg': {
                '--checkbox-background-color': 'var(--local-background-hover)',
                '--checkbox-border-color': 'var(--local-border-hover)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + svg': {
                '--checkbox-background-color': 'var(--local-background-checked-hover)',
                '--checkbox-border-color': 'var(--local-border-checked-hover)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked + svg': {
                '--checkbox-background-color': 'var(--local-background-checked)',
                '--checkbox-border-color': 'var(--local-border-checked)',
                '--checkbox-tick-color': 'var(--local-tick-checked)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:active + svg': {
                '--checkbox-background-color': 'var(--local-background-active)',
                '--checkbox-border-color': 'var(--local-border-active)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:active + svg': {
                '--checkbox-background-color': 'var(--local-background-active)',
                '--checkbox-border-color': 'var(--local-border-active)',
                '--checkbox-tick-color': 'var(--local-tick-active)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'var(--local-background-disabled)',
                '--checkbox-border-color': 'var(--local-border-disabled)',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:disabled:checked + svg': {
                '--checkbox-tick-color': 'var(--local-tick-disabled)'
            }
        }
    }
});
const $b92d63900d735dfd$export$a261a5b04a85ad9c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"], [data-prosemirror-node-name="blockTaskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"], [data-prosemirror-node-name="blockTaskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"], [data-prosemirror-node-name="blockTaskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder'], [data-prosemirror-node-name='blockTaskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"], [data-prosemirror-node-name="blockTaskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $4287605bd9e53ba0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4287605bd9e53ba0$var$pulseIn = (0, $9K4OG.keyframes)({
    '0%, 100%': {
        transform: 'scaleX(0)',
        opacity: 0
    },
    '10%': {
        transform: 'scaleX(1.4)',
        opacity: 1
    },
    '15%, 85%': {
        transform: 'scaleX(1)',
        opacity: 1
    }
});
const $4287605bd9e53ba0$var$pulseOut = (0, $9K4OG.keyframes)({
    '0%, 90%, 100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '10%, 80%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$var$pulseInDuringTr = (0, $9K4OG.keyframes)({
    '0%, 95%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$var$pulseOutDuringTr = (0, $9K4OG.keyframes)({
    '100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '0%, 90%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$export$3f28e75e37279280 = {
    name: "ig2c5x",
    styles: ".ProseMirror .telepointer{position:relative;transition:opacity 200ms;&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-dim{opacity:0.2;}&.color-0{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-red-bolder, #C9372C);}&.color-1{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-blue-bolder, #1868DB);}&.color-2{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-green-bolder, #1F845A);}&.color-3{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-bolder, #946F00);}&.color-4{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-purple-bolder, #964AC0);}&.color-5{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-bolder, #AE4787);}&.color-6{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-teal-bolder, #227D9B);}&.color-7{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-orange-bolder, #BD5B00);}&.color-8{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-lime-bolder, #5B7F24);}&.color-9{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-gray-bolder, #6B6E76);}&.color-10{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-blue-subtle, #669DF1);}&.color-11{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-red-subtle, #F87168);}&.color-12{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-orange-subtle, #FCA700);}&.color-13{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-subtle, #EED12B);}&.color-14{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-green-subtle, #4BCE97);}&.color-15{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-teal-subtle, #6CC3E0);}&.color-16{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-purple-subtle, #C97CF4);}&.color-17{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-subtle, #E774BB);}html:not([data-color-mode=dark]) &{--telepointer-participant-background-first-stop:-850000%;--telepointer-participant-background-second-stop:150000%;}html[data-color-mode=dark] &{--telepointer-participant-background-first-stop:-800000%;--telepointer-participant-background-second-stop:200000%;}&[class*=\"color-\"]{background:linear-gradient(to bottom, var(--telepointer-participant-bg-color) var(--telepointer-participant-background-first-stop), transparent var(--telepointer-participant-background-second-stop));&::after{background-color:var(--telepointer-participant-bg-color);color:var(--telepointer-participant-text-color);border-color:var(--telepointer-participant-bg-color);}}}"
};
const $4287605bd9e53ba0$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $9K4OG.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge': {
            '.telepointer-initial, .telepointer-fullname': {
                position: 'absolute',
                display: 'block',
                userSelect: 'none',
                whiteSpace: 'pre',
                top: -14,
                left: 0,
                font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                paddingLeft: "var(--ds-space-050, 4px)",
                paddingRight: "var(--ds-space-050, 4px)",
                borderRadius: `0 ${"var(--ds-radius-xsmall, 2px)"} ${"var(--ds-radius-xsmall, 2px)"} 0`
            },
            '.telepointer-initial': {
                opacity: 1,
                transition: 'opacity 0.15s ease-out'
            },
            '.telepointer-fullname': {
                opacity: 0,
                transform: 'scaleX(0)',
                transformOrigin: 'top left',
                transition: 'transform 0.15s ease-out, opacity 0.15s ease-out'
            }
        },
        '&.telepointer-pulse-animate': {
            '.telepointer-initial': {
                animation: `${$4287605bd9e53ba0$var$pulseOut} 2.5s ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$4287605bd9e53ba0$var$pulseIn} 2.5s ease-in-out`
            }
        },
        '&.telepointer-pulse-during-tr': {
            '.telepointer-initial': {
                animation: `${$4287605bd9e53ba0$var$pulseOutDuringTr} 7500ms ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$4287605bd9e53ba0$var$pulseInDuringTr} 7500ms ease-in-out`
            }
        },
        '&:hover': {
            '.telepointer-initial': {
                opacity: 0,
                transitionDelay: '150ms'
            },
            '.telepointer-fullname': {
                transform: 'scaleX(1)',
                opacity: 1,
                zIndex: 1
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $d945351f1977281b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d945351f1977281b$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $1fcafd3026b21a26$export$b286500adc7d91cd = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.text-highlight': {
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        borderBottom: `2px solid ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



const $6b97cbd24a9f84ae$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $6b97cbd24a9f84ae$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, .${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
        cursor: 'pointer'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$48dd9ca0c16e4625),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
                border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $c13a16cba860d543$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c13a16cba860d543$export$2ee83b65ab9fac74 = {
    name: "1e3eb5t",
    styles: ".ProseMirror{word-wrap:break-word;white-space:pre-wrap;}"
};


const $ad78489f7c19358a$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $ad78489f7c19358a$var$alignMultipleWrappedImageInLayoutStyles = {
    '.ProseMirror [data-layout-section] [data-layout-column] > div': {
        // apply marginTop to wrapped mediaSingle that has preceding wrapped mediaSingle (even when there's gap cursor in between them)
        // Given the first wrapped mediaSingle in layout has 0 marginTop, this is needed to make sure fellow wrapped mediaSingle align with it horizontally
        '.mediaSingleView-content-wrap[layout^=wrap] + .mediaSingleView-content-wrap[layout^=wrap], .mediaSingleView-content-wrap[layout^=wrap] + .ProseMirror-gapcursor + .mediaSingleView-content-wrap[layout^=wrap]': {
            '.rich-media-item': {
                marginTop: 0
            }
        },
        // Due to the above rule, wrapped mediaSingle (not the first node in layout) that are followed by wrapped mediaSingle should also have 0 marginTop
        // so it's aligned with the following wrapped mediaSingle
        '.mediaSingleView-content-wrap[layout^=wrap]:has( + .mediaSingleView-content-wrap[layout^=wrap])': {
            '.rich-media-item': {
                marginTop: 0
            }
        }
    }
};
const $ad78489f7c19358a$var$firstWrappedMediaStyles = {
    '.ProseMirror': {
        // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
        "& [layout^='wrap-']:has(+ [layout^='wrap-']), & [layout^='wrap-']:has(+ .ProseMirror-gapcursor + [layout^='wrap-'])": {
            [`& .${0, $gnMzP.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        }
    }
};
/**
 * EditorContentStyles is a wrapper component that applies styles to its children
 * based on the provided feature flags, view mode, and other props.
 * It uses Emotion for styling and supports scrollable content.
 *
 * This will be used in near future to replace the current editor content styles from index.tsx
 */ const $ad78489f7c19358a$var$EditorContentContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode, useStandardNodeWidth: useStandardNodeWidth } = props;
    const theme = (0, $6dGgK.u)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width' || ((0, $dZ8uq.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max';
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const baseFontSize = (0, $jTtEd.getBaseFontSize)(appearance, contentMode);
    const style = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: theme
        })}px`
    } : {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: theme
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor--large-gutter-padding': `${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px`
    };
    const browser = (0, $d7ZU3.getBrowserInfo)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$6a08aa478781aaec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$8ccf5563eb1fc2f7),
            (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$247cd720d09b9b61),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dh538.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$cc6d483a79f2d275) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$9e26088fca9327a2),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$23029c6a73ca6b8c),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $c13a16cba860d543$export$2ee83b65ab9fac74),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e776189f3c3af959$export$fc74cf03693076b4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && (0, $a227b436ae91f932$export$5efd6032566fe395),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $f08f86940ab6d6a2$export$9750a92ac0203c10),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3b65c10c9ad50286$export$3fc32cdc53f6edeb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b8cc3f8fc9e3d56a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$cc1dcabcf4a29354),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a3d8f4cb8a14da43),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $034503d6cd31c145$export$f21d9f928c6ae322),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b08ecd070af20ccb$export$f06cff4aa315bcf9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$56bce713f2cb8aa7),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$d3bdc0d52bb6c2c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $56a35bdc54338480$export$ec7b3b2c50356d2e),
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_quick_insert_placeholder') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$959bd343ec1d44de),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$4baaed2b257b830),
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$921fec04d268c00a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $dh538.fg)('platform_editor_typography_ugc') && (0, $8c084c7e0576e8c1$export$87e0522332cd3719),
            (0, $dh538.fg)('platform_editor_typography_ugc') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8c084c7e0576e8c1$export$63adc0ebe3278d31),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && (0, $8c084c7e0576e8c1$export$3bdf5e0c4fe1eac4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$610a2509037eaf6),
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$9be2adf7cb8aa3a1),
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$8a07948e3f1777),
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$3683cb70e936c4c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$36460e974c9904b9) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$4a8301858e3f950),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$13d8dd04b9497c9a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9fb7690d6af70e31$export$2029176b06e1b241),
            (0, $1oCLl.expValEquals)('platform_editor_a11y_scrollable_region', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9fb7690d6af70e31$export$a1c093cc2c35593e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d945351f1977281b$export$a518ea5d00002b38),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $680457c62c4e856c$export$e4cca17cf56e99d),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $680457c62c4e856c$export$a365082c2a191514),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$5f95d55c83a3b7bc),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$66dd3b7a524cdd20),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$b5b1b7a81c86d94e),
            // Condense vertical spacing between list items when content mode dense is active
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$dc36e8e603594c1d)(baseFontSize),
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'listLayoutShiftFix', true) && isFullPage && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$3861aadd8944b16f),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0e823357fa8df654$export$2413e968422424ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$1fef993256efc96e),
            (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$5e70718283e43349) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$4d8f0e547724198),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$abd2efc27ac7e809),
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$1cac2710e369d647),
            // merge firstWrappedMediaStyles with mediaStyles when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $ad78489f7c19358a$var$firstWrappedMediaStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4287605bd9e53ba0$export$c94087d6ea5127ad),
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4287605bd9e53ba0$export$3f28e75e37279280),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ba96bd4668ffc758$export$f6b9d90c2745834e),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ba96bd4668ffc758$export$bfbb8fb576027812),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$8290cf129669d0cb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$fb05379f8218158),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$1bea98aa89006044),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$59d3d90d4141195),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$1445f2e2b3a1d9c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$df437277fbc8b4f5),
            // condense vertical spacing between tasks/decisions items when content mode dense is active
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$715995201f735e2d)(baseFontSize),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3b9a5370a72c9df5$export$61d0da483c72dda3),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a303160bb76f51c$export$e561f1e4e17b129d),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $332bd83257b23222$export$37579fbc35dcc1a9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $91793a38cb990edb$export$9abdb593a2600bc6)(contentMode),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $91793a38cb990edb$export$c6823b394e119a7e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$ed25ef5a9db895f7),
            // Apply expand delta styles conditionally based on useStandardNodeWidth (negative margins or not)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !useStandardNodeWidth && (0, $35750f0b594d4ce9$export$4bb28258452e3b9a),
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$9f08fc5d3959d07e)(baseFontSize),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$26d7f96b2bb98b5b) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$4dd1b2c2505a38a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$20843fd014d7530c),
            isChromeless && (0, $1oCLl.expValEquals)('platform_editor_chromeless_expand_fix', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$bdee15c929dd4423),
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$2ad4be5f6c1e4bbf) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$c5ceb9c726010930),
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$fae24dca059c5),
            !(0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$a5471dc947aff188),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1fcafd3026b21a26$export$b286500adc7d91cd),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$c2f467e1dc47f4f1),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$a261a5b04a85ad9c) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$2a9fa9bb25fe40d2),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$7356f32af3715d83),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$e237513ae3de60b5),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$79c8c9ad308bbe07),
            (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$5bacb3eba124de20) : (0, $dh538.fg)('platform-component-visual-refresh') ? (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$8b4cca12f7a094c7) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$7c209f30e9068068) : (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$60b421c3da7a2a99) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$dc185896d75d4b4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e744a1f22573fa53$export$65cde0a0b7e7c1c1),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$42b66ad40efe5bbe) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$56d86af0724ad29e) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$b346a5d6d598424c),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$fefb174a4d9f4c0),
            ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$f64b12e3fb171ebc),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92bd659d1ad36350$export$5a1f57c6600b90f1),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6b97cbd24a9f84ae$export$637bcb89343f7ef4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$ce55ec61aa49b942),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$ce383b8d82e44bf5),
            (0, $1oCLl.expValEquals)('platform_editor_table_excerpts_fix', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$4921bd0cd96a70c2),
            // merge alignMultipleWrappedImageInLayoutStyles with layoutBaseStyles when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $ad78489f7c19358a$var$alignMultipleWrappedImageInLayoutStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a476f61d60131cb$export$9ce40bb672aef33b),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // Apply sync block delta styles conditionally based on useStandardNodeWidth (negative margins or not)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !useStandardNodeWidth && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a476f61d60131cb$export$2ef961ae194ff4dc),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && (0, $7a476f61d60131cb$export$bb6880bfac80a2d6),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a476f61d60131cb$export$15f9ecbc224279eb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$74ce03ae8f7cbe1a),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$d9912ef7f698aab8) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$17d7fe9c8be65e97),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$2e7c649d642e8659),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$ed4b77c142cd3096),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$8dd21c7c24132a82) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$fe39d5414c0135d3),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$67aba4052ecc5648),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$fe59793079ccb11a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$cdcbf2d4bffabda6),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$1ce35d5e797e3173),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$55890fd3e3be7f1b),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$c1454bb6dd8837f5),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && ((0, $iu6m9.editorExperiment)('platform_synced_block', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$b371e818feeb9ba8) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$4d009f8d3cbd5535)),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$c60086c81c0ffabf) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$598dd68f26eb7eff),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$cb0683bb9c4e1322),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$1a87a16059da4299),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $332bd83257b23222$export$b89fadc5134d50fa),
            (0, $dh538.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$63635a8b56f58eca) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$29f6e72d2a83d55a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$3de2f7ce686aadc2) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$855ac5a16d662324),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9be63d8bc680ee45$export$4ea5976125a01ffa),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            browser.safari && (0, $7ea00528076df401$export$dba87c9b43c1033d),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$f4810475f3f405bd),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$62cd5dfd9881f590) : undefined,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$d199c4fcac4ebc3a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$10ee78d9e73a5e96) : undefined,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$241444dc11ae22d6),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$21b363e15a3a4b0b),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && ((0, $iu6m9.editorExperiment)('advanced_layouts', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$2785010673d864e4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $30cdf9ef77478b9f$export$7d2a5652980d3808),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $ad78489f7c19358a$var$isFirefox && (0, $30cdf9ef77478b9f$export$541b06daf7fd8fce),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && (0, $30cdf9ef77478b9f$export$9a2d17c0df63f635),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && $ad78489f7c19358a$var$isFirefox && (0, $30cdf9ef77478b9f$export$18b242302a502e32),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $07d5bf3f0b10fce1$export$ec8bdd18ecbadae7),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$20e6a345585c5c3c),
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', false) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$70038a77af1ac7b5),
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$203a03d09c37c555),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $8ba9ce11757ecee6$export$d6e7bceefcc20e27),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $e5ba48b9f959e381$export$61a2da566f69d1df),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $8478647a8b452658$export$eb88bb4706d67f65),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $887f0254bcb2b3a0$export$b2380b18b089518f),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$ddc3dd3ba723d1af) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$50458a606d5c37d0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $563563a54a51d8c3$export$2d6e8a1d666d4a60),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$5fb9b21e3678e9ac),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$13ab2f17ccaf48f6) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$8697a9554aac2a5a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$3db84a979dc69b56) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$d73b97ac20f33f4),
            // Dense emoji scaling based on base font size
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$1cdf865bc84cef4)(baseFontSize) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$2a2707475ad11d76)(baseFontSize) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$21dc022a1db4e807),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$cbc2f5b7ba4a5b45),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$228abfa0106fa708),
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$b216471059d2ae73) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$696afa9d8a2fe544),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$d4422e89f15370f2),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1zav4.tableSharedStyle)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$97207509673d0dfa),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$f19584fc2286b857),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9be63d8bc680ee45$export$889b949305b162f9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $14a90d57d6df814c$export$1629cb32bbba3a7e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $375f45f3b6bd3ab6$export$cf79be04c8e54f95),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $375f45f3b6bd3ab6$export$162efa362a1cdef5),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $375f45f3b6bd3ab6$export$adeff2341d3e8864),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $332bd83257b23222$export$f9f3f08b750aaa7d),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $64073fed169900b9$export$df03c70a9b9671c1),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $d6f1b5d8b6185b26$export$1091a37fb36d77e5),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $b92d63900d735dfd$export$27a4e7e55add38c4),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $8daea92ba3be6a6e$export$bd58d1bcb934912c),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $0e823357fa8df654$export$e425548b5cacd57),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $8b8a9e34027bcb70$export$c47a18e5da2466ef),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $9add2684ad964103$export$9addcfe7a096a01d)
            ]
        ],
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tabIndex: isScrollable ? 0 : undefined,
        role: isScrollable ? 'region' : undefined
    }, children);
});
var $ad78489f7c19358a$export$2e2bcd8739ae039 = $ad78489f7c19358a$var$EditorContentContainer;
module.exports["default"] = $ad78489f7c19358a$export$2e2bcd8739ae039;

});

parcelRegister("6ESsx", function(module, exports) {
const $a4c21b9fb66bf546$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $a4c21b9fb66bf546$export$b0aeb22a160e5b4c = {
    focus: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-focus`,
    blur: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-blur`,
    draft: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-draft`,
    hover: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-hover`
};
const $a4c21b9fb66bf546$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $a4c21b9fb66bf546$export$ac15f3ad21fefeac = {
    focus: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-focus`,
    blur: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-blur`,
    draft: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-draft`
};
module.exports["AnnotationSharedClassNames"] = $a4c21b9fb66bf546$export$b0aeb22a160e5b4c;
module.exports["BlockAnnotationSharedClassNames"] = $a4c21b9fb66bf546$export$ac15f3ad21fefeac;

});

parcelRegister("iMS6j", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $76cf05f628aba256$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $76cf05f628aba256$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $76cf05f628aba256$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $76cf05f628aba256$var$prefix = 'ak-editor-expand';
const $76cf05f628aba256$export$6ba39aa0ead007b7 = {
    prefix: $76cf05f628aba256$var$prefix,
    expanded: `${$76cf05f628aba256$var$prefix}__expanded`,
    titleContainer: `${$76cf05f628aba256$var$prefix}__title-container`,
    inputContainer: `${$76cf05f628aba256$var$prefix}__input-container`,
    iconContainer: `${$76cf05f628aba256$var$prefix}__icon-container`,
    icon: `${$76cf05f628aba256$var$prefix}__icon`,
    iconButton: `${$76cf05f628aba256$var$prefix}__icon-button`,
    iconSvg: `${$76cf05f628aba256$var$prefix}__icon-svg`,
    titleInput: `${$76cf05f628aba256$var$prefix}__title-input`,
    content: `${$76cf05f628aba256$var$prefix}__content`,
    contentCollapsed: `${$76cf05f628aba256$var$prefix}__content--collapsed`,
    type: (type)=>`${$76cf05f628aba256$var$prefix}__type-${type}`
};
module.exports["expandIconContainerStyle"] = $76cf05f628aba256$export$2e9dabdcf16aeb54;
module.exports["expandClassNames"] = $76cf05f628aba256$export$6ba39aa0ead007b7;

});

parcelRegister("ieXGd", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $b38UX = parcelRequire("b38UX");

const $097d317d23b8bcc9$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$097d317d23b8bcc9$var$getSelectionStyle(selectionStyle)).concat($097d317d23b8bcc9$export$a716852a0c5e54d5).join('\n');
const $097d317d23b8bcc9$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $097d317d23b8bcc9$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $b38UX.SelectionStyle).Border:
            return `
        border: ${0, $aFUXX.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $aFUXX.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $b38UX.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $aFUXX.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $b38UX.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FE)"};`;
        case (0, $b38UX.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $aFUXX.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};
module.exports["getSelectionStyles"] = $097d317d23b8bcc9$export$fb186b651805ffe4;
module.exports["hideNativeBrowserTextSelectionStyles"] = $097d317d23b8bcc9$export$a716852a0c5e54d5;

});

parcelRegister("b38UX", function(module, exports) {
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $5e118ec333d708f7$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});
module.exports["SelectionStyle"] = $5e118ec333d708f7$export$80010201b36a8290;

});

parcelRegister("3ae8F", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $d925B = parcelRequire("d925B");


var $aeAfU = parcelRequire("aeAfU");








var $hWRJP = parcelRequire("hWRJP");

class $ea497c7b8855fd08$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}





function $e83111829c538b72$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $e83111829c538b72$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e83111829c538b72$var$MountPluginHook, {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: key,
            usePluginHook: usePluginHook,
            editorView: editorView,
            containerElement: containerElement
        })));
}


function $4a2d94567ed6726c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a2d94567ed6726c$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
const $4a2d94567ed6726c$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ea497c7b8855fd08$export$e926676385687eaf), {
        component: (0, $d925B.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e83111829c538b72$export$a9224552b63e3fe8), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $4a2d94567ed6726c$var$pluginsComponentsWrapper,
        "data-testid": (0, $aeAfU.expVal)('platform_editor_experience_tracking', 'isEnabled', false) ? 'plugins-components-wrapper' : undefined
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(element, props);
    })));
};
const $4a2d94567ed6726c$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($4a2d94567ed6726c$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
$4a2d94567ed6726c$var$PluginSlotComponent.displayName = 'PluginSlot';
var $4a2d94567ed6726c$export$2e2bcd8739ae039 = $4a2d94567ed6726c$var$PluginSlotComponent;
module.exports["default"] = $4a2d94567ed6726c$export$2e2bcd8739ae039;

});

parcelRegister("aeAfU", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");


var $7Rqpr = parcelRequire("7Rqpr");


var $8ihu7 = parcelRequire("8ihu7");

function $92366aa0166a9d31$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $7Rqpr.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $8ihu7._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $8ihu7._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    if (!(0, $8ihu7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $8ihu7._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
}
function $92366aa0166a9d31$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
 * Use to check a any param value for an experiment without firing an exposure event
 *
 * **Note**: this will return the default value when the experiment;
 * - is not being served to the client (ie. pre start)
 * - or is not configured in experiments-config
 *
 * @example
 * ```ts
 * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
 * await new Promise(res => setTimeout(res, delay)
 * ```
 */ 
function $92366aa0166a9d31$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}
module.exports["expVal"] = $92366aa0166a9d31$export$9db1624a8af791a4;
module.exports["expValNoExposure"] = $92366aa0166a9d31$export$94f132839aec533f;

});

parcelRegister("4cy2V", function(module, exports) {
const $6c9f12e5c59418a8$export$f454e86f6cef71f4 = (editorAPI, components)=>{
    return {
        components: components ?? editorAPI?.primaryToolbar?.sharedState.currentState()?.components
    };
};
module.exports["getPrimaryToolbarComponents"] = $6c9f12e5c59418a8$export$f454e86f6cef71f4;

});

parcelRegister("1xxAs", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eTj7Y = parcelRequire("eTj7Y");


var $zMjD6 = parcelRequire("zMjD6");


var $iu6m9 = parcelRequire("iu6m9");


var $4JDbp = parcelRequire("4JDbp");


var $geLSP = parcelRequire("geLSP");





var $dh538 = parcelRequire("dh538");

const $3aec2ffe9f521610$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!skip && ref.current && !(0, $dh538.fg)('platform_editor_prevent_toolbar_width_reflow')) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};



var $eUp7e = parcelRequire("eUp7e");










// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $bd42a2364528a44b$var$toolbarSizesFullPageNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizesFullPage = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizes = [
    {
        width: (0, $zMjD6.ToolbarWidths).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidths).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidths).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesForAppearance = (appearance)=>(0, $geLSP.isFullPage)(appearance) ? (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesFullPageNext : $bd42a2364528a44b$var$toolbarSizesFullPage : (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesNext : $bd42a2364528a44b$var$toolbarSizes;
const $bd42a2364528a44b$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $zMjD6.ToolbarWidths).S
    }).width;
};
const $bd42a2364528a44b$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $zMjD6.ToolbarSize).XXXS
    }).size;
};


function $4b0c8fc583dabeb9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b0c8fc583dabeb9$var$toolbar = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $4b0c8fc583dabeb9$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    const elementWidth = (0, $3aec2ffe9f521610$export$1217913212f99c7)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $eTj7Y.isSSR)() && (0, $geLSP.isFullPage)(props.appearance) ? (0, $zMjD6.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $bd42a2364528a44b$export$886398ab6922a80f)(width || elementWidth, props.appearance);
    const minWidthValue = (0, $42omo.useMemo)(()=>{
        if (props.hasMinWidth) {
            const toolbarWidth = (0, $geLSP.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $zMjD6.ToolbarSize).S : (0, $zMjD6.ToolbarSize).M;
            return `${(0, $bd42a2364528a44b$export$df8e48f984163082)(toolbarWidth, props.appearance)}px`;
        } else {
            const isPreviewPanelResponsivenessEnabled = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            });
            return isPreviewPanelResponsivenessEnabled ? 'fit-content' : '254px';
        }
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $4b0c8fc583dabeb9$var$toolbar,
        style: {
            minWidth: minWidthValue
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4JDbp.default), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eUp7e.Toolbar), {
        toolbarSize: toolbarSize,
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: props.twoLineEditorToolbar
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref
    }));
};
module.exports["ToolbarWithSizeDetector"] = $4b0c8fc583dabeb9$export$6bb21858343ac39d;

});

parcelRegister("eUp7e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $gzUv9 = parcelRequire("gzUv9");

var $biAkr = parcelRequire("biAkr");


var $zMjD6 = parcelRequire("zMjD6");


var $91bcx = parcelRequire("91bcx");


var $kDB94 = parcelRequire("kDB94");

var $6UWPx = parcelRequire("6UWPx");

var $48SU7 = parcelRequire("48SU7");


var $cf8NL = parcelRequire("cf8NL");


var $1oCLl = parcelRequire("1oCLl");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $eTj7Y = parcelRequire("eTj7Y");


var $aFUXX = parcelRequire("aFUXX");

const $85ca23d15eecf4ef$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $85ca23d15eecf4ef$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $eTj7Y.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $85ca23d15eecf4ef$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(element, {
                key: key
            });
        }));
    }
}


const $ba8f28fe8c9d2747$var$TOOLBAR_FALLBACKS = {
    group: (0, $kDB94.ToolbarButtonGroup),
    section: (0, $48SU7.ToolbarSection),
    menuSection: (0, $6UWPx.ToolbarDropdownItemSection)
};
const $ba8f28fe8c9d2747$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85ca23d15eecf4ef$export$7c77e89663c6a665), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $zMjD6.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};
const $ba8f28fe8c9d2747$var$usePluginState = (api)=>{
    return (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'editorViewMode',
        'userPreferences'
    ], (state)=>{
        return {
            connectivityStateMode: state.connectivityState?.mode,
            editorViewMode: state.editorViewModeState?.mode,
            editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition
        };
    });
};
const $ba8f28fe8c9d2747$export$1606f8c5fd0ac145 = ({ toolbar: toolbar, components: components, editorView: editorView, editorAPI: editorAPI, popupsMountPoint: popupsMountPoint, editorAppearance: editorAppearance, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isDisabled: isDisabled })=>{
    const { connectivityStateMode: connectivityStateMode, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference } = $ba8f28fe8c9d2747$var$usePluginState(editorAPI);
    // remove offline check when patch6Enabled is cleaned up
    const isOffline = (0, $91bcx.isOfflineMode)(connectivityStateMode);
    const memoizedFireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        editorAPI?.analytics?.actions.fireAnalyticsEvent(payload);
    }, [
        editorAPI
    ]);
    const fireAnalyticsEvent = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedFireAnalyticsEvent : (payload)=>memoizedFireAnalyticsEvent(payload);
    const fallbacks = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $ba8f28fe8c9d2747$var$TOOLBAR_FALLBACKS : {
        group: (0, $kDB94.ToolbarButtonGroup),
        section: (0, $48SU7.ToolbarSection),
        menuSection: (0, $6UWPx.ToolbarDropdownItemSection)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gzUv9.EditorToolbarProvider), {
        editorView: editorView ?? null,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode ?? 'edit',
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biAkr.EditorToolbarUIProvider), {
        api: editorAPI,
        isDisabled: isDisabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf8NL.ToolbarModelRenderer), {
        toolbar: toolbar,
        components: components,
        fallbacks: fallbacks
    })));
};
module.exports["Toolbar"] = $ba8f28fe8c9d2747$export$4c260019440d418f;
module.exports["ToolbarNext"] = $ba8f28fe8c9d2747$export$1606f8c5fd0ac145;

});

parcelRegister("gzUv9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");

const $0cf4befb56ebc307$var$EditorToolbarContext = /*#__PURE__*/ (0, $42omo.createContext)({
    editorView: null,
    editorAppearance: undefined,
    editorViewMode: undefined,
    editorToolbarDockingPreference: undefined
});
const $0cf4befb56ebc307$export$d463571cb9040a24 = ()=>{
    const context = (0, $42omo.useContext)($0cf4befb56ebc307$var$EditorToolbarContext);
    if (!context) throw new Error('useEditorToolbar must be used within EditorToolbarContext');
    return context;
};
const $0cf4befb56ebc307$export$847624ff5ecdfe6d = ({ children: children, editorView: editorView, editorAppearance: editorAppearance, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        }), [
        editorView,
        editorAppearance,
        editorViewMode,
        editorToolbarDockingPreference,
        isOffline
    ]);
    const contextValue = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedValue : {
        editorView: editorView,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0cf4befb56ebc307$var$EditorToolbarContext.Provider, {
        value: contextValue
    }, children);
};
module.exports["useEditorToolbar"] = $0cf4befb56ebc307$export$d463571cb9040a24;
module.exports["EditorToolbarProvider"] = $0cf4befb56ebc307$export$847624ff5ecdfe6d;

});

parcelRegister("biAkr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $f5cc64b6f3991f95$export$54b6b74e939729c = ({ children: children, api: api, isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    const onDropdownOpenChanged = (0, $42omo.useCallback)(({ isOpen: isOpen, event: event })=>{
        if (!isOpen) {
            // Only refocus the editor when the dropdown closes via mouse or programmatic close.
            // When closed via keyboard Escape, keep focus on the trigger for better keyboard UX.
            const isKeyboardEscape = event instanceof KeyboardEvent && event.key === 'Escape';
            const shouldFocusEditor = !isKeyboardEscape;
            if (shouldFocusEditor) // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
            // Hence, `.focus()` should also be called in requestAnimationFrame
            setTimeout(()=>requestAnimationFrame(()=>{
                    api?.core.actions.focus({
                        scrollIntoView: false
                    });
                }), 1);
        }
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hoW2.ToolbarUIProvider), {
        onDropdownOpenChanged: onDropdownOpenChanged,
        preventDefaultOnMouseDown: true,
        isDisabled: isDisabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent,
        keyboardNavigation: keyboardNavigation
    }, children);
};
module.exports["EditorToolbarUIProvider"] = $f5cc64b6f3991f95$export$54b6b74e939729c;

});

parcelRegister("91bcx", function(module, exports) {
const $c002f590834c9ab4$export$a73e10b357da8876 = (mode)=>{
    return mode === 'offline' || mode === 'collab-offline' || mode === 'internet-offline';
};
module.exports["isOfflineMode"] = $c002f590834c9ab4$export$a73e10b357da8876;

});

parcelRegister("cf8NL", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");

const $8c4aad5c55711194$export$671f8dfe06a9af10 = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>(a.parents.find((p)=>p.key === parentKey)?.rank || 0) - (b.parents.find((p)=>p.key === parentKey)?.rank || 0));
const $8c4aad5c55711194$export$7fc4381d95dc76c8 = (props)=>null;
const $8c4aad5c55711194$export$fc1acc9190910d14 = (component)=>{
    return component.type === 'section';
};


const $0f156ffd6dbbb817$var$hasParents = (component)=>{
    return component.type !== 'toolbar';
};
const $0f156ffd6dbbb817$var$getChildTypesForParent = (parentType)=>{
    switch(parentType){
        case 'toolbar':
            return [
                'section'
            ];
        case 'section':
            return [
                'group'
            ];
        case 'group':
            return [
                'button',
                'menu'
            ];
        case 'menu':
        case 'nested-menu':
            return [
                'menu-section'
            ];
        case 'menu-section':
            return [
                'menu-item',
                'nested-menu'
            ];
        default:
            return [];
    }
};
const $0f156ffd6dbbb817$var$getFallbackComponent = (type, fallbacks)=>{
    switch(type){
        case 'group':
            return fallbacks.group;
        case 'menu-section':
            return fallbacks.menuSection;
        case 'section':
            return fallbacks.section;
        default:
            return 0, $8c4aad5c55711194$export$7fc4381d95dc76c8;
    }
};
const $0f156ffd6dbbb817$var$hasMenuItems = (menuSections, allComponents)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', true)) return menuSections.some((menuSection)=>{
        return allComponents.some((component)=>{
            return component.type === 'menu-item' && component.parents.some((parent)=>parent.key === menuSection.key) && (!('isHidden' in component) || !component.isHidden?.());
        });
    });
    return menuSections.some((menuSection)=>{
        return allComponents.some((component)=>component.type === 'menu-item' && component.parents.some((parent)=>parent.key === menuSection.key));
    });
};
const $0f156ffd6dbbb817$var$shouldHideEmptyComponent = (component, children, allComponents)=>{
    if (component.type === 'menu') {
        const menuSections = children.filter((child)=>child.type === 'menu-section');
        return menuSections.length === 0 || !$0f156ffd6dbbb817$var$hasMenuItems(menuSections, allComponents);
    }
    if (component.type === 'group' || component.type === 'nested-menu' || component.type === 'menu-section') return children.length === 0;
    return false;
};
const $0f156ffd6dbbb817$var$ComponentRenderer = ({ component: component, parents: parents, allComponents: allComponents, fallbacks: fallbacks })=>{
    const childTypes = $0f156ffd6dbbb817$var$getChildTypesForParent(component.type);
    const children = (0, $8c4aad5c55711194$export$671f8dfe06a9af10)(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    allComponents.filter((comp)=>childTypes.includes(comp.type)), component.key);
    if ($0f156ffd6dbbb817$var$shouldHideEmptyComponent(component, children, allComponents)) return null;
    const Component = component.component || $0f156ffd6dbbb817$var$getFallbackComponent(component.type, fallbacks);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (children.length === 0) return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        parents: parents,
        children: null
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        parents: parents,
        children: children.map((child)=>/*#__PURE__*/ (0, $l998X.jsx)($0f156ffd6dbbb817$var$ComponentRenderer, {
                component: child,
                parents: newParents,
                allComponents: allComponents,
                fallbacks: fallbacks
            }, child.key))
    });
};
const $0f156ffd6dbbb817$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const ToolbarComponent = toolbar.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const sections = (0, $8c4aad5c55711194$export$671f8dfe06a9af10)(components.filter((0, $8c4aad5c55711194$export$fc1acc9190910d14)), toolbar.key);
    return /*#__PURE__*/ (0, $l998X.jsx)(ToolbarComponent, {
        children: sections.map((section)=>/*#__PURE__*/ (0, $l998X.jsx)($0f156ffd6dbbb817$var$ComponentRenderer, {
                component: section,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                parents: [
                    {
                        key: toolbar.key,
                        type: toolbar.type
                    }
                ],
                // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
                allComponents: components.filter($0f156ffd6dbbb817$var$hasParents),
                fallbacks: fallbacks
            }, section.key))
    });
};
module.exports["ToolbarModelRenderer"] = $0f156ffd6dbbb817$export$9ceb2742df82af54;

});

parcelRegister("cPCP8", function(module, exports) {
const $a7f594e2fbd530f1$export$cc1c18c6e6b6ecaf = {
    INLINE_TEXT_TOOLBAR: 'inline-text-toolbar',
    PRIMARY_TOOLBAR: 'primary-toolbar'
};
const $a7f594e2fbd530f1$export$78ec0124ca63fa02 = {
    key: 'ai-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$124d2ee606ccdfdc = {
    key: 'ai-view-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$6d5407fbb0bc912e = {
    key: 'ai-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$ea53d97c37cdede3 = {
    key: 'ai-section-full-page-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dcbeb7730f347566 = {
    key: 'ai-section-comment-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$ab61657fb37116be = {
    key: 'rovo-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b0e50b17917e2523 = {
    key: 'rovo-group-view',
    type: 'group'
};
const $a7f594e2fbd530f1$export$67ae7e5d398cd98 = {
    key: 'rovo-group-primary-toolbar',
    type: 'group'
};
const $a7f594e2fbd530f1$export$393a27a1587c4748 = {
    key: 'rovo-group-display-small',
    type: 'group'
};
const $a7f594e2fbd530f1$export$164a0130b2b649c6 = {
    key: 'improve-writing-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e7c291289ee98d9 = {
    key: 'improve-writing-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$50fb6fd780a8da5a = {
    key: 'hero-prompt-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6ea8ae73b826b63e = {
    key: 'hero-prompt-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$3d823cd1493e8383 = {
    key: 'rovo-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$bc3c6b8bbdf543d6 = {
    key: 'rovo-write-button-primary-toolbar',
    type: 'button'
};
const $a7f594e2fbd530f1$export$4532eefb6fdb660c = {
    key: 'rovo-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$245b51779748026d = {
    key: 'rovo-menu-display-small',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$f157764a2d8d74e6 = {
    key: 'rovo-prompt-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$8be015e65f184637 = {
    key: 'rovo-prompt-menu-section-display-small',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$c9c5b3ece9aa9724 = {
    key: 'improve-writing-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1ede5932cecaa59 = {
    key: 'hero-prompt-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4799f439258ea378 = {
    key: 'make-shorter-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$b82c17edba0c6a9e = {
    key: 'make-longer-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1356bd5d76f7fc4 = {
    key: 'change-tone-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$ba297ac76e077190 = {
    key: 'spelling-and-grammar-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$86a7882cf39bf1df = {
    key: 'change-tone-default-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$d868febccc6870c7 = {
    key: 'more-professional-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4a7c57dd33fc4a14 = {
    key: 'more-casual-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$3758b89123aa4456 = {
    key: 'more-empathetic-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$76118e0d25ac1fef = {
    key: 'translate-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$a526b8293dafd11c = {
    key: 'translate-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$5836877aa3028c9d = {
    key: 'define-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$92f779590a87713f = {
    key: 'define-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$8bfe594eeaed8635 = {
    key: 'define-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8d0a77a358b8b557 = {
    key: 'add-polish-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$46f6ca06869869c = {
    key: 'text-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$9821adc8accbec40 = {
    key: 'text-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$65db33ca2d38a784 = {
    key: 'text-section-collapsed',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dbb8e55d66b9ce7c = {
    key: 'text-collapsed-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$50e256f5fa0723b1 = {
    key: 'text-collapsed-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$17de14a70389be62 = {
    key: 'text-styles-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e3c7868e9e7f30f = {
    key: 'text-styles-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$61c471f0e406c6cd = {
    key: 'text-styles-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$a0d395bab4f77bed = {
    key: 'normal-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$e01e7ae5367e3f41 = {
    key: 'small-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$2469e8506da598d3 = {
    key: 'heading-1-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$a065aede28a4fa60 = {
    key: 'heading-2-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$85070b7c6d42e3bb = {
    key: 'heading-3-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$e78c2531f67b545f = {
    key: 'heading-4-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$a92294de346392be = {
    key: 'heading-5-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9c3cdc8e6d51ce82 = {
    key: 'heading-6-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$f4b89f87980eb537 = {
    key: 'block-quote-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$acdcd8bfebadff8e = {
    key: 'text-formatting-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$3efe78988280adb3 = {
    key: 'text-formatting-group-collapsed',
    type: 'group'
};
const $a7f594e2fbd530f1$export$d709b777a6a93241 = {
    key: 'text-formatting-group-inline',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e54b89ebe974229a = {
    key: 'bold-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$eb8680bccd13ec29 = {
    key: 'underline-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b1308631b6ed4b3 = {
    key: 'text-formatting-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$1f2df85e05c78a28 = {
    key: 'text-formatting-hero-button-collapsed',
    type: 'button'
};
const $a7f594e2fbd530f1$export$512cce888b603a21 = {
    key: 'bold-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8ba429f81350a9a5 = {
    key: 'underline-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6ed8e5719ec9c8ca = {
    key: 'text-formatting-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$8bc14fdbfc88e3d = {
    key: 'bold-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$55cababf49d70434 = {
    key: 'italic-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$74aa4c917d0fb179 = {
    key: 'underline-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9caef6162846aa5f = {
    key: 'strike-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$33821ea6eceb9d13 = {
    key: 'code-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$ee8cb7d7ef764bfe = {
    key: 'subscript-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$85ead1ec02f87839 = {
    key: 'superscript-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$6f16936b77c05f44 = {
    key: 'text-formatting-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$2d7a9246359565f = {
    key: 'clear-formatting-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$2577e452f5468087 = {
    key: 'clear-formatting-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$eb99509879c4d1a6 = {
    key: 'text-color-highlight-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$126ef012ef4d8c5f = {
    key: 'text-color-highlight-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$70638f1e77085913 = {
    key: 'text-color-highlight-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$ebd1271b08f151b0 = {
    key: 'text-color-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$bae2fe42c2b86102 = {
    key: 'highlight-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$267f9526bd36c2c = {
    key: 'clear-color-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$36cf1d476157a47d = {
    key: 'alignment-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b9d75d8ec913c411 = {
    key: 'alignment-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$a7d30f7c1c00dd6e = {
    key: 'alignment-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$fb5e83c02abc1116 = {
    key: 'align-left-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$920b9c1f02074883 = {
    key: 'align-center-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$77c582b2c8fa437c = {
    key: 'align-right-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$cfa2bcff371b7719 = {
    key: 'lists-indentation-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e24e846ad969dbb4 = {
    key: 'lists-indentation-group-collapsed',
    type: 'group'
};
const $a7f594e2fbd530f1$export$18e3c58ea662f7ad = {
    key: 'lists-indentation-group-inline',
    type: 'group'
};
const $a7f594e2fbd530f1$export$93963c53c29fc835 = {
    key: 'bullet-list-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6c8387a14e0128fe = {
    key: 'bullet-list-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f625e29dbd38e447 = {
    key: 'lists-indentation-hero-button-collapsed',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8709d937e93456c5 = {
    key: 'lists-indentation-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$77b7fc28d250a53f = {
    key: 'lists-indentation-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$21a99ac537934e71 = {
    key: 'lists-indendation-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$fc39a5dc74747fed = {
    key: 'bullet-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9d64032e4ea1097c = {
    key: 'numbered-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$d6bac99c24b8cdfd = {
    key: 'task-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$87678574248a0249 = {
    key: 'indent-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$8fc4080aa2f8adc2 = {
    key: 'outdent-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$8be58f85d6f2b208 = {
    key: 'insert-block-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$a55d93db15cde50c = {
    key: 'code-block-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$22d0f50f2ec2f1a8 = {
    key: 'code-block-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6265c903e79c43eb = {
    key: 'task-list-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$9634f504f88ede38 = {
    key: 'task-list-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$ce4671f9066f5c48 = {
    key: 'media-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$37025ad4bfe1d2aa = {
    key: 'media-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f4c921ea7ce3d48a = {
    key: 'mention-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$450b9a588cdf3949 = {
    key: 'mention-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6ca7976638436c6 = {
    key: 'emoji-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$a4310034b096a4ad = {
    key: 'emoji-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f746b10bd135ebe5 = {
    key: 'layout-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$bc099bce567fd020 = {
    key: 'layout-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$19b0175d8da45496 = {
    key: 'table-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$c37ae5d099679682 = {
    key: 'table-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$c796ec87818935d5 = {
    key: 'table-size-picker',
    type: 'button'
};
const $a7f594e2fbd530f1$export$2db6abe323bf312e = {
    key: 'insert-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$2b79c1387bf4ea1b = {
    key: 'insert-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$1fc1401e9e5d8a = {
    key: 'linking-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$87f2f2ff3eb62f79 = {
    key: 'linking-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$3d214445dcf942f2 = {
    key: 'linking-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8d13eb2ec1e19466 = {
    key: 'synced-block-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f7a124e17ae9698f = {
    key: 'synced-block-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$796e931612f154e7 = {
    key: 'synced-block-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$457818231baddd40 = {
    key: 'collab-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$8978fe8e689744cc = {
    key: 'comment-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f97beb46382b3388 = {
    key: 'comment-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$d757fc54a1831d82 = {
    key: 'apps-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$c3f44bc1025dceb2 = {
    key: 'track-changes-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$b3d4f2cdc057cba1 = {
    key: 'undo-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f13c32a4c68c0806 = {
    key: 'undo-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$e149a5154bb9b44 = {
    key: 'redo-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$1fb249ec6ca34dd0 = {
    key: 'redo-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8e3cd3ec14c6efc = {
    key: 'track-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$9cfd2622f07061e0 = {
    key: 'track-changes-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$cb18e5ae740a3f22 = {
    key: 'overflow-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$932f82408ad2af53 = {
    key: 'overflow-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6583eb3a2765795b = {
    key: 'overflow-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$cefae60670d357d0 = {
    key: 'pin-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$76d22fa71bc28346 = {
    key: 'pin-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1b5ea0d5074f7d18 = {
    key: 'overflow-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$a481b12c04259be8 = {
    key: 'overflow-group-primary-toolbar',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b0bb124d5687709e = {
    key: 'overflow-menu-primary-toolbar',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$6d497f3df1049a22 = {
    key: 'pin-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$762436e7516a2365 = {
    key: 'pin-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$cfefbb6355b14379 = {
    key: 'pin-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$68f7a2de17e9e39d = {
    key: 'view-mode-toggle-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dd76f40d6548a654 = {
    key: 'loom-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$4ac3fd1884a40118 = {
    key: 'loom-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$debff7788300c3ff = {
    key: 'selection-extension-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$3752412f1cf2bc0e = {
    key: 'overflow-extensions-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$41bea16b66da911 = {
    key: 'first-party-extensions-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4b664282d7b95d2c = {
    key: 'external-extensions-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$b4e8aaf730259f83 = {
    key: 'paste-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$76da35b5d1c35bbe = {
    key: 'paste-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$5646e8ff118a2c3f = {
    key: 'paste-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$4a6eb83eeeb712a = {
    key: 'paste-menu-nested-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$7528e3cffa17b456 = {
    key: 'rich-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$d10c0f4ac46a1253 = {
    key: 'markdown-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$ef2727de8c063819 = {
    key: 'plain-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4d6ba29b72804f46 = {
    key: 'ai-paste-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$7897566b2299aaf5 = {
    INSERT: 'editor-toolbar-insert-button',
    EMOJI: 'editor-toolbar-emoji-button',
    IMAGE: 'editor-toolbar-image-button',
    MEDIA: 'editor-toolbar-media-button',
    TABLE: 'Table',
    TABLE_SELECTOR: 'editor-toolbar-table-selector-button',
    MENTION: 'editor-toolbar-mention-button',
    LAYOUT: 'editor-toolbar-layout-button',
    TASK_LIST: 'editor-toolbar-task-list-button'
};
module.exports["TOOLBARS"] = $a7f594e2fbd530f1$export$cc1c18c6e6b6ecaf;
module.exports["AI_SECTION"] = $a7f594e2fbd530f1$export$78ec0124ca63fa02;
module.exports["AI_VIEW_SECTION"] = $a7f594e2fbd530f1$export$124d2ee606ccdfdc;
module.exports["AI_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$6d5407fbb0bc912e;
module.exports["AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$ea53d97c37cdede3;
module.exports["AI_SECTION_COMMENT_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$dcbeb7730f347566;
module.exports["ROVO_GROUP"] = $a7f594e2fbd530f1$export$ab61657fb37116be;
module.exports["ROVO_GROUP_VIEW"] = $a7f594e2fbd530f1$export$b0e50b17917e2523;
module.exports["ROVO_GROUP_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$67ae7e5d398cd98;
module.exports["ROVO_GROUP_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$393a27a1587c4748;
module.exports["IMPROVE_WRITING_GROUP"] = $a7f594e2fbd530f1$export$164a0130b2b649c6;
module.exports["IMPROVE_WRITING_BUTTON"] = $a7f594e2fbd530f1$export$e7c291289ee98d9;
module.exports["HERO_PROMPT_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$50fb6fd780a8da5a;
module.exports["HERO_PROMPT_BUTTON"] = $a7f594e2fbd530f1$export$6ea8ae73b826b63e;
module.exports["ROVO_HERO_BUTTON"] = $a7f594e2fbd530f1$export$3d823cd1493e8383;
module.exports["ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$bc3c6b8bbdf543d6;
module.exports["ROVO_MENU"] = $a7f594e2fbd530f1$export$4532eefb6fdb660c;
module.exports["ROVO_MENU_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$245b51779748026d;
module.exports["ROVO_PROMPT_MENU_SECTION"] = $a7f594e2fbd530f1$export$f157764a2d8d74e6;
module.exports["ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$8be015e65f184637;
module.exports["IMPROVE_WRITING_MENU_ITEM"] = $a7f594e2fbd530f1$export$c9c5b3ece9aa9724;
module.exports["HERO_PROMPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$1ede5932cecaa59;
module.exports["MAKE_SHORTER_MENU_ITEM"] = $a7f594e2fbd530f1$export$4799f439258ea378;
module.exports["MAKE_LONGER_MENU_ITEM"] = $a7f594e2fbd530f1$export$b82c17edba0c6a9e;
module.exports["CHANGE_TONE_NESTED_MENU"] = $a7f594e2fbd530f1$export$1356bd5d76f7fc4;
module.exports["SPELLING_AND_GRAMMAR_MENU_ITEM"] = $a7f594e2fbd530f1$export$ba297ac76e077190;
module.exports["CHANGE_TONE_MENU_SECTION"] = $a7f594e2fbd530f1$export$86a7882cf39bf1df;
module.exports["MORE_PROFESSIONAL_MENU_ITEM"] = $a7f594e2fbd530f1$export$d868febccc6870c7;
module.exports["MORE_CASUAL_MENU_ITEM"] = $a7f594e2fbd530f1$export$4a7c57dd33fc4a14;
module.exports["MORE_EMPATHETIC_MENU_ITEM"] = $a7f594e2fbd530f1$export$3758b89123aa4456;
module.exports["TRANSLATE_NESTED_MENU"] = $a7f594e2fbd530f1$export$76118e0d25ac1fef;
module.exports["TRANSLATE_MENU_SECTION"] = $a7f594e2fbd530f1$export$a526b8293dafd11c;
module.exports["DEFINE_MENU_ITEM"] = $a7f594e2fbd530f1$export$5836877aa3028c9d;
module.exports["DEFINE_GROUP"] = $a7f594e2fbd530f1$export$92f779590a87713f;
module.exports["DEFINE_BUTTON"] = $a7f594e2fbd530f1$export$8bfe594eeaed8635;
module.exports["ADD_POLISH_MENU_ITEM"] = $a7f594e2fbd530f1$export$8d0a77a358b8b557;
module.exports["TEXT_SECTION"] = $a7f594e2fbd530f1$export$46f6ca06869869c;
module.exports["TEXT_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$9821adc8accbec40;
module.exports["TEXT_SECTION_COLLAPSED"] = $a7f594e2fbd530f1$export$65db33ca2d38a784;
module.exports["TEXT_COLLAPSED_GROUP"] = $a7f594e2fbd530f1$export$dbb8e55d66b9ce7c;
module.exports["TEXT_COLLAPSED_MENU"] = $a7f594e2fbd530f1$export$50e256f5fa0723b1;
module.exports["TEXT_STYLES_GROUP"] = $a7f594e2fbd530f1$export$17de14a70389be62;
module.exports["TEXT_STYLES_MENU"] = $a7f594e2fbd530f1$export$e3c7868e9e7f30f;
module.exports["TEXT_STYLES_MENU_SECTION"] = $a7f594e2fbd530f1$export$61c471f0e406c6cd;
module.exports["NORMAL_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$a0d395bab4f77bed;
module.exports["SMALL_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$e01e7ae5367e3f41;
module.exports["HEADING_1_MENU_ITEM"] = $a7f594e2fbd530f1$export$2469e8506da598d3;
module.exports["HEADING_2_MENU_ITEM"] = $a7f594e2fbd530f1$export$a065aede28a4fa60;
module.exports["HEADING_3_MENU_ITEM"] = $a7f594e2fbd530f1$export$85070b7c6d42e3bb;
module.exports["HEADING_4_MENU_ITEM"] = $a7f594e2fbd530f1$export$e78c2531f67b545f;
module.exports["HEADING_5_MENU_ITEM"] = $a7f594e2fbd530f1$export$a92294de346392be;
module.exports["HEADING_6_MENU_ITEM"] = $a7f594e2fbd530f1$export$9c3cdc8e6d51ce82;
module.exports["BLOCK_QUOTE_MENU_ITEM"] = $a7f594e2fbd530f1$export$f4b89f87980eb537;
module.exports["TEXT_FORMATTING_GROUP"] = $a7f594e2fbd530f1$export$acdcd8bfebadff8e;
module.exports["TEXT_FORMATTING_GROUP_COLLAPSED"] = $a7f594e2fbd530f1$export$3efe78988280adb3;
module.exports["TEXT_FORMATTING_GROUP_INLINE"] = $a7f594e2fbd530f1$export$d709b777a6a93241;
module.exports["BOLD_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$e54b89ebe974229a;
module.exports["UNDERLINE_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$eb8680bccd13ec29;
module.exports["TEXT_FORMATTING_HERO_BUTTON"] = $a7f594e2fbd530f1$export$b1308631b6ed4b3;
module.exports["TEXT_FORMATTING_HERO_BUTTON_COLLAPSED"] = $a7f594e2fbd530f1$export$1f2df85e05c78a28;
module.exports["BOLD_BUTTON"] = $a7f594e2fbd530f1$export$512cce888b603a21;
module.exports["UNDERLINE_BUTTON"] = $a7f594e2fbd530f1$export$8ba429f81350a9a5;
module.exports["TEXT_FORMATTING_MENU"] = $a7f594e2fbd530f1$export$6ed8e5719ec9c8ca;
module.exports["BOLD_MENU_ITEM"] = $a7f594e2fbd530f1$export$8bc14fdbfc88e3d;
module.exports["ITALIC_MENU_ITEM"] = $a7f594e2fbd530f1$export$55cababf49d70434;
module.exports["UNDERLINE_MENU_ITEM"] = $a7f594e2fbd530f1$export$74aa4c917d0fb179;
module.exports["STRIKE_MENU_ITEM"] = $a7f594e2fbd530f1$export$9caef6162846aa5f;
module.exports["CODE_MENU_ITEM"] = $a7f594e2fbd530f1$export$33821ea6eceb9d13;
module.exports["SUBSCRIPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$ee8cb7d7ef764bfe;
module.exports["SUPERSCRIPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$85ead1ec02f87839;
module.exports["TEXT_FORMATTING_MENU_SECTION"] = $a7f594e2fbd530f1$export$6f16936b77c05f44;
module.exports["CLEAR_FORMARTTING_MENU_SECTION"] = $a7f594e2fbd530f1$export$2d7a9246359565f;
module.exports["CLEAR_FORMATTING_MENU_ITEM"] = $a7f594e2fbd530f1$export$2577e452f5468087;
module.exports["TEXT_COLOR_HIGHLIGHT_GROUP"] = $a7f594e2fbd530f1$export$eb99509879c4d1a6;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU"] = $a7f594e2fbd530f1$export$126ef012ef4d8c5f;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_SECTION"] = $a7f594e2fbd530f1$export$70638f1e77085913;
module.exports["TEXT_COLOR_MENU_ITEM"] = $a7f594e2fbd530f1$export$ebd1271b08f151b0;
module.exports["HIGHLIGHT_MENU_ITEM"] = $a7f594e2fbd530f1$export$bae2fe42c2b86102;
module.exports["CLEAR_COLOR_MENU_ITEM"] = $a7f594e2fbd530f1$export$267f9526bd36c2c;
module.exports["ALIGNMENT_GROUP"] = $a7f594e2fbd530f1$export$36cf1d476157a47d;
module.exports["ALIGNMENT_MENU"] = $a7f594e2fbd530f1$export$b9d75d8ec913c411;
module.exports["ALIGNMENT_MENU_SECTION"] = $a7f594e2fbd530f1$export$a7d30f7c1c00dd6e;
module.exports["ALIGN_LEFT_MENU_ITEM"] = $a7f594e2fbd530f1$export$fb5e83c02abc1116;
module.exports["ALIGN_CENTER_MENU_ITEM"] = $a7f594e2fbd530f1$export$920b9c1f02074883;
module.exports["ALIGN_RIGHT_MENU_ITEM"] = $a7f594e2fbd530f1$export$77c582b2c8fa437c;
module.exports["LISTS_INDENTATION_GROUP"] = $a7f594e2fbd530f1$export$cfa2bcff371b7719;
module.exports["LISTS_INDENTATION_GROUP_COLLAPSED"] = $a7f594e2fbd530f1$export$e24e846ad969dbb4;
module.exports["LISTS_INDENTATION_GROUP_INLINE"] = $a7f594e2fbd530f1$export$18e3c58ea662f7ad;
module.exports["BULLETED_LIST_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$93963c53c29fc835;
module.exports["BULLETED_LIST_BUTTON"] = $a7f594e2fbd530f1$export$6c8387a14e0128fe;
module.exports["LISTS_INDENTATION_HERO_BUTTON_COLLAPSED"] = $a7f594e2fbd530f1$export$f625e29dbd38e447;
module.exports["LISTS_INDENTATION_HERO_BUTTON"] = $a7f594e2fbd530f1$export$8709d937e93456c5;
module.exports["LISTS_INDENTATION_MENU"] = $a7f594e2fbd530f1$export$77b7fc28d250a53f;
module.exports["LISTS_INDENTATION_MENU_SECTION"] = $a7f594e2fbd530f1$export$21a99ac537934e71;
module.exports["BULLETED_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$fc39a5dc74747fed;
module.exports["NUMBERED_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$9d64032e4ea1097c;
module.exports["TASK_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$d6bac99c24b8cdfd;
module.exports["INDENT_MENU_ITEM"] = $a7f594e2fbd530f1$export$87678574248a0249;
module.exports["OUTDENT_MENU_ITEM"] = $a7f594e2fbd530f1$export$8fc4080aa2f8adc2;
module.exports["INSERT_BLOCK_SECTION"] = $a7f594e2fbd530f1$export$8be58f85d6f2b208;
module.exports["CODE_BLOCK_GROUP"] = $a7f594e2fbd530f1$export$a55d93db15cde50c;
module.exports["CODE_BLOCK_BUTTON"] = $a7f594e2fbd530f1$export$22d0f50f2ec2f1a8;
module.exports["TASK_LIST_GROUP"] = $a7f594e2fbd530f1$export$6265c903e79c43eb;
module.exports["TASK_LIST_BUTTON"] = $a7f594e2fbd530f1$export$9634f504f88ede38;
module.exports["MEDIA_GROUP"] = $a7f594e2fbd530f1$export$ce4671f9066f5c48;
module.exports["MEDIA_BUTTON"] = $a7f594e2fbd530f1$export$37025ad4bfe1d2aa;
module.exports["MENTION_GROUP"] = $a7f594e2fbd530f1$export$f4c921ea7ce3d48a;
module.exports["MENTION_BUTTON"] = $a7f594e2fbd530f1$export$450b9a588cdf3949;
module.exports["EMOJI_GROUP"] = $a7f594e2fbd530f1$export$6ca7976638436c6;
module.exports["EMOJI_BUTTON"] = $a7f594e2fbd530f1$export$a4310034b096a4ad;
module.exports["LAYOUT_GROUP"] = $a7f594e2fbd530f1$export$f746b10bd135ebe5;
module.exports["LAYOUT_BUTTON"] = $a7f594e2fbd530f1$export$bc099bce567fd020;
module.exports["TABLE_GROUP"] = $a7f594e2fbd530f1$export$19b0175d8da45496;
module.exports["TABLE_BUTTON"] = $a7f594e2fbd530f1$export$c37ae5d099679682;
module.exports["TABLE_SIZE_PICKER"] = $a7f594e2fbd530f1$export$c796ec87818935d5;
module.exports["INSERT_GROUP"] = $a7f594e2fbd530f1$export$2db6abe323bf312e;
module.exports["INSERT_BUTTON"] = $a7f594e2fbd530f1$export$2b79c1387bf4ea1b;
module.exports["LINKING_SECTION"] = $a7f594e2fbd530f1$export$1fc1401e9e5d8a;
module.exports["LINKING_GROUP"] = $a7f594e2fbd530f1$export$87f2f2ff3eb62f79;
module.exports["LINKING_BUTTON"] = $a7f594e2fbd530f1$export$3d214445dcf942f2;
module.exports["SYNCED_BLOCK_GROUP"] = $a7f594e2fbd530f1$export$8d13eb2ec1e19466;
module.exports["SYNCED_BLOCK_BUTTON"] = $a7f594e2fbd530f1$export$f7a124e17ae9698f;
module.exports["SYNCED_BLOCK_SECTION"] = $a7f594e2fbd530f1$export$796e931612f154e7;
module.exports["COLLAB_SECTION"] = $a7f594e2fbd530f1$export$457818231baddd40;
module.exports["COMMENT_GROUP"] = $a7f594e2fbd530f1$export$8978fe8e689744cc;
module.exports["COMMENT_HERO_BUTTON"] = $a7f594e2fbd530f1$export$f97beb46382b3388;
module.exports["APPS_SECTION"] = $a7f594e2fbd530f1$export$d757fc54a1831d82;
module.exports["TRACK_CHANGES_SECTION"] = $a7f594e2fbd530f1$export$c3f44bc1025dceb2;
module.exports["UNDO_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$b3d4f2cdc057cba1;
module.exports["UNDO_BUTTON"] = $a7f594e2fbd530f1$export$f13c32a4c68c0806;
module.exports["REDO_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$e149a5154bb9b44;
module.exports["REDO_BUTTON"] = $a7f594e2fbd530f1$export$1fb249ec6ca34dd0;
module.exports["TRACK_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$8e3cd3ec14c6efc;
module.exports["TRACK_CHANGES_BUTTON"] = $a7f594e2fbd530f1$export$9cfd2622f07061e0;
module.exports["OVERFLOW_SECTION"] = $a7f594e2fbd530f1$export$cb18e5ae740a3f22;
module.exports["OVERFLOW_GROUP"] = $a7f594e2fbd530f1$export$932f82408ad2af53;
module.exports["OVERFLOW_MENU"] = $a7f594e2fbd530f1$export$6583eb3a2765795b;
module.exports["PIN_MENU_SECTION"] = $a7f594e2fbd530f1$export$cefae60670d357d0;
module.exports["PIN_MENU_ITEM"] = $a7f594e2fbd530f1$export$76d22fa71bc28346;
module.exports["OVERFLOW_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$1b5ea0d5074f7d18;
module.exports["OVERFLOW_GROUP_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$a481b12c04259be8;
module.exports["OVERFLOW_MENU_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$b0bb124d5687709e;
module.exports["PIN_SECTION"] = $a7f594e2fbd530f1$export$6d497f3df1049a22;
module.exports["PIN_GROUP"] = $a7f594e2fbd530f1$export$762436e7516a2365;
module.exports["PIN_BUTTON"] = $a7f594e2fbd530f1$export$cfefbb6355b14379;
module.exports["VIEW_MODE_TOGGLE_SECTION"] = $a7f594e2fbd530f1$export$68f7a2de17e9e39d;
module.exports["LOOM_MENU_SECTION"] = $a7f594e2fbd530f1$export$dd76f40d6548a654;
module.exports["LOOM_MENU_ITEM"] = $a7f594e2fbd530f1$export$4ac3fd1884a40118;
module.exports["SELECTION_EXTENSION_MENU_SECTION"] = $a7f594e2fbd530f1$export$debff7788300c3ff;
module.exports["OVERFLOW_EXTENSIONS_MENU_SECTION"] = $a7f594e2fbd530f1$export$3752412f1cf2bc0e;
module.exports["FIRST_PARTY_EXTENSIONS_MENU_ITEM"] = $a7f594e2fbd530f1$export$41bea16b66da911;
module.exports["EXTERNAL_EXTENSIONS_MENU_ITEM"] = $a7f594e2fbd530f1$export$4b664282d7b95d2c;
module.exports["PASTE_MENU"] = $a7f594e2fbd530f1$export$b4e8aaf730259f83;
module.exports["PASTE_MENU_SECTION"] = $a7f594e2fbd530f1$export$76da35b5d1c35bbe;
module.exports["PASTE_NESTED_MENU"] = $a7f594e2fbd530f1$export$5646e8ff118a2c3f;
module.exports["PASTE_MENU_NESTED_SECTION"] = $a7f594e2fbd530f1$export$4a6eb83eeeb712a;
module.exports["PASTE_RICH_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$7528e3cffa17b456;
module.exports["PASTE_MARKDOWN_MENU_ITEM"] = $a7f594e2fbd530f1$export$d10c0f4ac46a1253;
module.exports["PASTE_PLAIN_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$ef2727de8c063819;
module.exports["AI_PASTE_MENU_SECTION"] = $a7f594e2fbd530f1$export$4d6ba29b72804f46;
module.exports["TOOLBAR_BUTTON_TEST_ID"] = $a7f594e2fbd530f1$export$7897566b2299aaf5;

});

parcelRegister("5ZzFz", function(module, exports) {
const $bc040982397de978$export$75279ffd74fef67b = (component)=>{
    return component?.type === 'toolbar';
};
module.exports["isToolbar"] = $bc040982397de978$export$75279ffd74fef67b;

});

parcelRegister("1PKpt", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eiA8Z = parcelRequire("eiA8Z");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $axOCf = parcelRequire("axOCf");


var $3ae8F = parcelRequire("3ae8F");


var $uq7dM = parcelRequire("uq7dM");

function $949a60155d5990f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $949a60155d5990f5$var$scrollbarStylesNew = {
    name: "18ng4c4",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #292A2E);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #3B3D42);}"
};
const $949a60155d5990f5$var$chromelessEditorStylesNew = {
    name: "zwat44",
    styles: "line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 8px);}}.ProseMirror{& > p:last-of-type{margin-bottom:var(--ds-space-0, 0px);}}"
};
class $949a60155d5990f5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)($949a60155d5990f5$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args);
        this.appearance = 'chromeless';
        this.containerElement = null;
        this.setContainerElement = (ref)=>{
            this.containerElement = ref;
        };
        this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = (0, $eiA8Z.useSharedPluginStateWithSelector)(this.props.editorAPI, [
                'editorViewMode'
            ], (states)=>states?.editorViewModeState?.mode);
            const containerRef = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? this.setContainerElement : (ref)=>this.containerElement = ref;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $uq7dM.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($949a60155d5990f5$export$5ffd32ebea3773c5, {
                maxHeight: maxHeight,
                minHeight: minHeight,
                containerRef: containerRef
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $axOCf.default), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewMode,
                appearance: this.appearance
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3ae8F.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
$949a60155d5990f5$export$2e2bcd8739ae039.displayName = 'ChromelessEditorAppearance';
function $949a60155d5990f5$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    'use no memo';
    // renderChrome should be changed to called as a component not a function
    const maxContentSizeReached = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize'
    ], (states)=>states?.maxContentSizeState?.maxContentSizeReached);
    const maxContentSize = maxContentSizeReached === undefined ? undefined : {
        maxContentSizeReached: maxContentSizeReached
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, renderChrome({
        maxContentSize: maxContentSize
    }));
}
function $949a60155d5990f5$export$5ffd32ebea3773c5({ maxHeight: maxHeight, minHeight: minHeight, children: children, containerRef: containerRef }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $949a60155d5990f5$var$chromelessEditorStylesNew,
            $949a60155d5990f5$var$scrollbarStylesNew
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dh538.fg)('platform_editor_chromeless_akeditor_class') || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true) ? 'akEditor' : undefined,
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        ref: containerRef
    }, children);
}
module.exports["default"] = $949a60155d5990f5$export$2e2bcd8739ae039;

});

parcelRegister("grmt9", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $8kPu1 = parcelRequire("8kPu1");

const $cc23084c386c6715$export$180fe852598a23ab = {
    pending: [
        'started'
    ],
    started: [
        'aborted',
        'failed',
        'succeeded'
    ],
    aborted: [
        'started'
    ],
    failed: [
        'started'
    ],
    succeeded: [
        'started'
    ]
};
const $cc23084c386c6715$export$178881f329fdb81f = (fromState, toState)=>{
    return $cc23084c386c6715$export$180fe852598a23ab[fromState]?.includes(toState) ?? false;
};


class $677a536053deeb18$export$fa331fd384051f6a {
    start(callback) {
        this.checks.forEach((check)=>check.start(callback));
    }
    stop() {
        this.checks.forEach((check)=>check.stop());
    }
    constructor(checks){
        this.checks = void 0;
        this.checks = checks;
    }
}


class $fd9e9a5afa72d596$export$c90b54e658fc4d7c {
    startCheck() {
        this.stopCheck();
        this.check.start(({ status: status, reason: reason, metadata: metadata })=>{
            if (status === 'success') this.success({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'abort') this.abort({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'failure') this.failure({
                reason: reason,
                metadata: metadata
            });
        });
    }
    stopCheck() {
        this.check.stop();
    }
    getEndStateMetadata(options = {}) {
        const metadata = {
            ...options.metadata
        };
        if (options.reason) metadata.experienceEndReason = options.reason;
        return metadata;
    }
    /**
   * Transitions to a new experience state and tracks analytics events.
   *
   * Upon transition to each state, two events are tracked:
   * - experienceMeasured: tracked on every successful transition, used for data analysis
   * - experienceSampled: tracked only on 1 out of every N transitions based on sample rate
   *
   * @param toState - The target state to transition to
   * @param metadata - Optional metadata to attach to the analytics events
   * @returns true if transition was successful, false if invalid transition
   */ transitionTo(toState, metadata) {
        if (!(0, $cc23084c386c6715$export$178881f329fdb81f)(this.currentState, toState)) return false;
        this.currentState = toState;
        if (toState === 'started') {
            this.isSampledTrackingEnabled = Math.random() < this.sampleRate;
            this.startTimeMs = Date.now();
            this.startMetadata = metadata;
        }
        this.trackTransition(toState, metadata);
        if (toState === 'started') this.startCheck();
        else {
            this.stopCheck();
            this.startMetadata = undefined;
        }
        this.statesSeen.add(toState);
        return true;
    }
    /**
   * Tracks analytics events for a state transition.
   *
   * Fires both experienceMeasured (always) and experienceSampled (sampled) events.
   *
   * @param toState - The state that was transitioned to
   * @param metadata - Metadata to include in the event, including firstInSession flag
   */ trackTransition(toState, metadata) {
        const attributes = {
            experienceKey: this.id,
            experienceStatus: toState,
            experienceStatusFirstSeen: !this.statesSeen.has(toState),
            experienceStartTime: this.startTimeMs || 0,
            experienceDuration: this.startTimeMs ? Date.now() - this.startTimeMs : 0,
            ...this.globalMetadata,
            ...this.startMetadata,
            ...metadata
        };
        const experienceMeasuredEvent = {
            action: (0, $d925B.ACTION).EXPERIENCE_MEASURED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            actionSubjectId: this.actionSubjectId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: attributes
        };
        this.dispatchAnalyticsEvent(experienceMeasuredEvent);
        if (this.isSampledTrackingEnabled) {
            const experienceSampledEvent = {
                action: (0, $d925B.ACTION).EXPERIENCE_SAMPLED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                actionSubjectId: this.actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            };
            this.dispatchAnalyticsEvent(experienceSampledEvent);
        }
    }
    /**
   * Starts tracking the experience and all checks which monitor for completion.
   *
   * Metadata from options will be merged with metadata provided in subsequent events.
   *
   * @param options - Configuration for starting the experience
   * @param options.metadata - Optional custom metadata attached to all subsequent events for this started experience
   * @param options.forceRestart - If true and experience already in progress will abort and restart
   * @param options.method - Optional method for experience start, e.g., how the experience was initiated
   */ start(options = {}) {
        if (options.forceRestart && this.currentState === 'started') this.abort({
            reason: (0, $8kPu1.EXPERIENCE_ABORT_REASON).RESTARTED
        });
        return this.transitionTo('started', {
            experienceStartMethod: options.method,
            ...options.metadata
        });
    }
    /**
   * Marks the experience as successful and stops any ongoing checks.
   *
   * @param options - Configuration for the success event
   * @param options.metadata - Optional custom metadata attached to the success event
   * @param options.reason - Optional reason for success
   * @returns false if transition to success state was not valid
   */ success(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('succeeded', metadata);
    }
    /**
   * Aborts the experience and stops any ongoing checks.
   *
   * Use this when a started experience terminates early due to user action or context change
   * (e.g., component unmount, navigation). This is neither success nor failure.
   *
   * @param options - Configuration for the abort event
   * @param options.metadata - Optional custom metadata attached to the abort event
   * @param options.reason - Optional reason for abort
   *
   * @example
   * // Abort on component unmount
   * useEffect(() => {
   *   return () => experience.abort({ reason: 'unmount', metadata: { someKey: 'someValue' } });
   * }, []);
   *
   * @returns false if transition to aborted state was not valid
   */ abort(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('aborted', metadata);
    }
    /**
   * Manually marks the experience as failed and stops any ongoing checks.
   *
   * Use this for actual failures in the experience flow (e.g., timeout, error conditions).
   *
   * @param options - Configuration for the failure event
   * @param options.metadata - Optional custom metadata attached to the failure event
   * @param options.reason - Optional reason for failure
   * @returns false if transition to failed state was not valid
   */ failure(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('failed', metadata);
    }
    /**
   * Creates a new Experience instance for tracking user experiences.
   *
   * @param id - Unique identifier for the experience e.g. 'toolbarOpen' 'menuAction'
   * @param options - Configuration options for the experience
   * @param options.checks - Experience checks to monitor for completion
   * @param options.dispatchAnalyticsEvent - Function to dispatch analytics events
   * @param options.sampleRate - Sample rate for experienceSampled events
   * @param options.metadata - Global metadata to attach to all events
   * @param options.action - Optional sub identifier for the specific experience action e.g. 'bold' 'insertTable'
   * @param options.actionSubjectId - Optional sub identifier for the experience action subject e.g. 'selectionToolbar' 'quickInsert'
   */ constructor(id, options){
        this.id = void 0;
        this.actionSubjectId = void 0;
        this.dispatchAnalyticsEvent = void 0;
        this.sampleRate = void 0;
        this.globalMetadata = void 0;
        this.check = void 0;
        this.currentState = 'pending';
        /**
     * Set of experience states that have been seen in the current session.
     *
     * Used to determine if experienceStatusFirstSeen flag should be set in events.
     */ this.statesSeen = new Set();
        /**
     * Indicates whether sampled tracking is enabled for this current experience session.
     *
     * Set to true | false upon transitioning to 'started' state.
     * When true, on subsequent transitions we fire experienceSampled events.
     * Ensures that every tracked start has corresponding abort/fail/success tracked.
     */ this.isSampledTrackingEnabled = void 0;
        /**
     * Timestamp (in milliseconds) when the experience transitioned to 'started' state.
     *
     * Used to calculate experience duration. Set via Date.now() when experience starts.
     */ this.startTimeMs = void 0;
        /**
     * Metadata provided at experience start time to merge into subsequent events.
     *
     * Used to retain experienceStartMethod and other start-specific metadata.
     */ this.startMetadata = void 0;
        this.id = id;
        this.actionSubjectId = options.actionSubjectId;
        this.dispatchAnalyticsEvent = options.dispatchAnalyticsEvent;
        this.sampleRate = options.sampleRate ?? (0, $8kPu1.DEFAULT_EXPERIENCE_SAMPLE_RATE);
        this.globalMetadata = {
            ...options.metadata,
            experienceAction: options.action
        };
        this.check = new (0, $677a536053deeb18$export$fa331fd384051f6a)(options.checks || []);
    }
}
module.exports["Experience"] = $fd9e9a5afa72d596$export$c90b54e658fc4d7c;

});

parcelRegister("8kPu1", function(module, exports) {
/**
 * Built-in failure reasons for experience checks
 *
 * These are used by the various ExperienceCheck implementations to
 * provide consistent, well-known failure reasons for analytics and debugging.
 */ const $d05112237b8e1d04$export$21dde0ac9b2abe83 = {
    /**
	 * Experience timed out before completion
	 */ TIMEOUT: 'timeout',
    /**
	 * Target element could not be found when starting DOM mutation observation
	 */ DOM_MUTATION_TARGET_NOT_FOUND: 'domMutationTargetNotFound',
    /**
	 * Error occurred during DOM mutation check execution
	 */ DOM_MUTATION_CHECK_ERROR: 'domMutationCheckError'
};
const $d05112237b8e1d04$export$e6589edd1f8a04af = {
    /**
	 * Experience was aborted because it was restarted while already in progress
	 */ RESTARTED: 'restarted'
};
const $d05112237b8e1d04$export$8e85905c8b6efc67 = 0.001;
const $d05112237b8e1d04$export$b110169935468339 = {
    ASYNC_OPERATION: 'asyncOperation',
    MENU_ACTION: 'menuAction',
    MENU_OPEN: 'menuOpen',
    TOOLBAR_ACTION: 'toolbarAction',
    TOOLBAR_OPEN: 'toolbarOpen'
};
module.exports["EXPERIENCE_FAILURE_REASON"] = $d05112237b8e1d04$export$21dde0ac9b2abe83;
module.exports["EXPERIENCE_ABORT_REASON"] = $d05112237b8e1d04$export$e6589edd1f8a04af;
module.exports["DEFAULT_EXPERIENCE_SAMPLE_RATE"] = $d05112237b8e1d04$export$8e85905c8b6efc67;
module.exports["EXPERIENCE_ID"] = $d05112237b8e1d04$export$b110169935468339;

});

parcelRegister("fo9p3", function(module, exports) {

var $8kPu1 = parcelRequire("8kPu1");

const $5240fd93cec52085$var$DEFAULT_FAILURE_RESULT = {
    status: 'failure',
    reason: (0, $8kPu1.EXPERIENCE_FAILURE_REASON).TIMEOUT
};
class $5240fd93cec52085$export$1a6fa509d14ac50 {
    start(callback) {
        this.stop();
        this.timeoutId = setTimeout(()=>{
            const result = this.onTimeout() || $5240fd93cec52085$var$DEFAULT_FAILURE_RESULT;
            callback(result);
        }, this.durationMs);
    }
    stop() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    }
    constructor({ durationMs: durationMs, onTimeout: onTimeout = ()=>$5240fd93cec52085$var$DEFAULT_FAILURE_RESULT }){
        this.timeoutId = void 0;
        this.durationMs = 0;
        this.onTimeout = void 0;
        this.durationMs = durationMs;
        this.onTimeout = onTimeout;
    }
}
module.exports["ExperienceCheckTimeout"] = $5240fd93cec52085$export$1a6fa509d14ac50;

});

parcelRegister("7fmpI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");

class $5aeffb90025ca075$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}
module.exports["ErrorBoundary"] = $5aeffb90025ca075$export$e926676385687eaf;

});

parcelRegister("c4jUA", function(module, exports) {

var $3BqCC = parcelRequire("3BqCC");


var $4U5Tv = parcelRequire("4U5Tv");


var $ehlgT = parcelRequire("ehlgT");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c954dc8baefb0c1$var$nativeCeil = Math.ceil, $8c954dc8baefb0c1$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $8c954dc8baefb0c1$var$chunk(array, size, guard) {
    if (guard ? $4U5Tv(array, size, guard) : size === undefined) size = 1;
    else size = $8c954dc8baefb0c1$var$nativeMax($ehlgT(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($8c954dc8baefb0c1$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $3BqCC(array, index, index += size);
    return result;
}
module.exports = $8c954dc8baefb0c1$var$chunk;

});

parcelRegister("9HtP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e1d16a2959b92a8$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $1e1d16a2959b92a8$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $42omo.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("2oRGU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $d925B = parcelRequire("d925B");


var $h9Yad = parcelRequire("h9Yad");

function $7292b2eba851ae1a$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $h9Yad.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}
module.exports["RenderTracking"] = $7292b2eba851ae1a$export$fe16de086fea1f5f;

});

parcelRegister("6VsTy", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");

const $33afbf7bccf03c68$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $5SAOw.Node) || Array.isArray(nodeOrMark.marks);
};
const $33afbf7bccf03c68$export$3d8be158d19aadd1 = (nodeOrMark, options)=>{
    const name = nodeOrMark.type.name;
    const isNode = $33afbf7bccf03c68$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    if (options?.anchrorId !== undefined && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) commonAttributes['data-node-anchor'] = options.anchrorId;
    return commonAttributes;
};
module.exports["createProseMirrorMetadata"] = $33afbf7bccf03c68$export$3d8be158d19aadd1;

});

parcelRegister("iScNA", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ae74dae40b2182$export$2e2bcd8739ae039);

var $80xRs = parcelRequire("80xRs");

const $72ae74dae40b2182$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $72ae74dae40b2182$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $80xRs.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        // Filter out null/undefined providers to prevent errors when calling methods on them
        return (0, $80xRs.getOnlyFulfilled)(results).filter((provider)=>provider != null);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $80xRs.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $80xRs.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $80xRs.getOnlyFulfilled)(results);
        return $72ae74dae40b2182$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});

parcelRegister("jTtEd", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");

function $8e2fd2af7fc541b0$export$8e2864079bc476bd(appearance, contentMode) {
    if ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === 'compact') return 0, $aFUXX.akEditorFullPageDenseFontSize;
    }
    if (appearance === undefined) return 0, $aFUXX.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $aFUXX.akEditorFullPageDefaultFontSize) : undefined;
}
module.exports["getBaseFontSize"] = $8e2fd2af7fc541b0$export$8e2864079bc476bd;

});

parcelRegister("uq7dM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

const $b70de66aa381d38d$var$pulseBackground = (0, $9K4OG.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$pulseBackgroundReverse = (0, $9K4OG.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$flashWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $b70de66aa381d38d$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $b70de66aa381d38d$var$flashWrapperAnimated = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$b70de66aa381d38d$var$flashWrapper} & > div`]: {
        animationName: $b70de66aa381d38d$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $b70de66aa381d38d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: animate ? $b70de66aa381d38d$var$flashWrapperAnimated : $b70de66aa381d38d$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args);
        this.toggle = false;
    }
}
module.exports["default"] = $b70de66aa381d38d$export$2e2bcd8739ae039;

});

parcelRegister("80xRs", function(module, exports) {
var $56266f841bff4619$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $56266f841bff4619$var$isFullfilled = (result)=>result.status === "fulfilled";
const $56266f841bff4619$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $56266f841bff4619$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $56266f841bff4619$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($56266f841bff4619$var$markFullfilled).catch($56266f841bff4619$var$markRejected)));
};
const $56266f841bff4619$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $56266f841bff4619$export$b7581cbf0e22e36b = (results)=>results.filter($56266f841bff4619$var$isFullfilled).map((result)=>result.value);
module.exports["waitForAllPromises"] = $56266f841bff4619$export$b43fdcffd84b7b0f;
module.exports["waitForFirstFulfilledPromise"] = $56266f841bff4619$export$cb8861b0e3f3dd6f;
module.exports["getOnlyFulfilled"] = $56266f841bff4619$export$b7581cbf0e22e36b;

});


$parcel$global.rlb("4m4Yp")
//# sourceMappingURL=panel.8dc5734d.js.map
